webpackJsonp([182],{

/***/ "+4G4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-email\"><defs><style type=\"text/css\"></style></defs><path d=\"M513 583.8l448.5-448.5c-11.6-4.7-24.3-7.3-37.5-7.3L100 128c-12.7 0-24.9 2.4-36.1 6.7L513 583.8z\" p-id=\"9121\" /><path d=\"M513 674.3 14.6 175.9C5.3 191.1 0 208.9 0 228l0 568c0 55.2 44.8 100 100 100l824 0c55.2 0 100-44.8 100-100l0-568c0-18.5-5.1-35.9-13.9-50.8L513 674.3z\" p-id=\"9122\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "+AaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//================================

function QnLoginClient(base, platformId) {
    var baseUrl = base;
    var platformId = platformId;
    var that = this;

    this.geBaseUrl = function () {
        return baseUrl;
    };

    this.getPlatformId = function () {
        return platformId;
    };

    this.getCheckPagePath = function () {
        return "loginCheck.html";
    };

    this.getUniloginPagePath = function () {
        return "unilogin.html";
    };

    this.getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    };

    this.validateTGC = function () {
        var postParams = "dont_login=1&clean_dirty=1";
        qnapi.query('passport/validate/tgc', postParams, handleOnValidateInClient);
    };

    this.getJumpUrl = function (target, redirectUrl, userType, dontLogin) {
        var targetPath = "";
        if (target == "login") {
            targetPath = this.getUniloginPagePath();
        } else {
            targetPath = this.getCheckPagePath();
        }
        var url = this.geBaseUrl() + targetPath + "?platform_id=" + this.getPlatformId() + "&redirect_url=" + redirectUrl;
        if (dontLogin) {
            url += "&dont_login=" + 1;
            //userType = 'merchant';//hack
        }
        if (userType) {
            url += "&user_type=" + userType;
        }
        // console.log('jump url = ' + url);
        return url;
    };

    this.firstCheck = function (redirectBackUrl, onCheckFail) {
        if (!redirectBackUrl) {
            return;
        }

        var tgc = this.getCookie('QNTGC');
        if (tgc) {
            //go and check
            // console.log('has tgc');
            var url = this.getJumpUrl('check', redirectBackUrl, null, 1);
            window.location.href = url;
        } else {
            //no login, run check fail
            // console.log('no tgc');
            if (onCheckFail) {
                onCheckFail();
            }
        }
    };

    this.jumpToCheck = function (redirectBackUrl, userType) {
        if (!redirectBackUrl || !userType) {
            return;
        }
        var url = this.getJumpUrl('check', redirectBackUrl, userType);
        console.log(url);
        console.log("jumpToCheck");
        window.location.href = url;
        return;
        console.log("jumpToCheck22222333");
    };

    this.jumpToLogin = function (redirectBackUrl, userType) {
        if (!redirectBackUrl || !userType) {
            return;
        }
        var url = this.getJumpUrl('login', redirectBackUrl, userType);
        window.location.href = url;
    };

    /*
     * =====================================================
     *                    以下是新的扩展 
     * =====================================================
     */

    var currentSessKey = '';
    this.localSessName = 'local_sess';
    this.isLocalSessOk = false;

    this.findGetParameter = function (parameterName) {
        var useDecodeURI = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var result = null,
            tmp = [];
        location.search.substr(1).split("&").forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) {
                if (useDecodeURI) {
                    result = decodeURIComponent(tmp[1]);
                } else {
                    result = tmp[1];
                }
            }
        });
        return result;
    };

    this.localRunConfig = {
        JumpBackUrl: null,
        OnLocalSessionOkDo: null, //检测到或成功获取本地session时执行
        OnLocalSessionNotOkDo: null, //检测到无本地session是执行
        OnHasTicketDo: null, //有ticket时执行
        OnAfterLocalSessionOkDo: null, //本地sessionOK后执行
        OnSessionFailDo: null, //没有session时执行
        OnTicketValidateFail: null //ticket 无效时，应该如何处理，理论上要重新去passport一趟
    };

    this.getLocalSess = function () {
        return that.getCookie(that.localSessName);
    };

    this.setLocalSess = function (value, duration) {
        if (!that.getLocalSess()) {
            // console.log("set local!");
            var expires = "";
            if (duration) {
                var date = new Date();
                date.setTime(date.getTime() + duration * 1000);
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = that.localSessName + "=" + value + expires + "; path=/";
        }
    };

    this.removeLocalSess = function () {
        document.cookie = that.localSessName + '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT';
    };

    var checkSessChange = function checkSessChange() {
        if (currentSessKey) {
            var localSession = that.getLocalSess();
            if (currentSessKey != localSession) {
                // console.log("local sess has changed");
                currentSessKey = localSession;
                window.location.reload(false);
            }
        }
    };

    this.runOnOnLocalSessionOkDo = function (localSess) {
        var localSession = null;
        if (localSess) {
            localSession = localSess;
        } else {
            localSession = that.getLocalSess();
        }
        if (localSession) {
            currentSessKey = localSession;
            that.isLocalSessOk = true;
            that.localRunConfig.OnLocalSessionOkDo();
            if (that.localRunConfig.OnAfterLocalSessionOkDo) {
                that.localRunConfig.OnAfterLocalSessionOkDo();
            }

            window.onfocus = checkSessChange;
            //window.setInterval(repeatCheckSessChange, (3 + Math.floor(Math.random() * 3)) * 1000);
        } else {
            if (that.localRunConfig.OnSessionFailDo) {
                that.localRunConfig.OnSessionFailDo();
            }
        }
    };

    this.handleTicketValidate = function (rspData) {
        if (rspData.code == 0) {
            // console.log("ticket validate ok");

            that.setLocalSess(rspData.data.session_key, rspData.data.duration);
            that.runOnOnLocalSessionOkDo();
        } else {
            // console.log("ticket validate fail:" + rspData.code);
            //有ticket但是无效，需要又去passport才行
            if (that.localRunConfig.OnTicketValidateFail) {
                that.localRunConfig.OnTicketValidateFail();
            }
        }
    };

    this.runInPageReady = function (runConfig) {
        //1.config
        if (!runConfig.JumpBackUrl || !runConfig.OnLocalSessionOkDo || !runConfig.OnLocalSessionNotOkDo || !runConfig.OnHasTicketDo) {
            alert("请检查runInPageReady的使用参数！");
            // console.log(runConfig);
        }
        that.localRunConfig.JumpBackUrl = runConfig.JumpBackUrl;
        that.localRunConfig.OnLocalSessionOkDo = runConfig.OnLocalSessionOkDo;
        that.localRunConfig.OnLocalSessionNotOkDo = runConfig.OnLocalSessionNotOkDo;
        that.localRunConfig.OnHasTicketDo = runConfig.OnHasTicketDo;
        if (runConfig.OnAfterLocalSessionOkDo) {
            that.localRunConfig.OnAfterLocalSessionOkDo = runConfig.OnAfterLocalSessionOkDo;
        }
        if (runConfig.OnSessionFailDo) {
            that.localRunConfig.OnSessionFailDo = runConfig.OnSessionFailDo;
        }
        if (runConfig.OnTicketValidateFail) {
            that.localRunConfig.OnTicketValidateFail = runConfig.OnTicketValidateFail;
        }

        //2.start
        var withLocalSessClean = that.findGetParameter('local_sess_clean');
        var ticket = that.findGetParameter('service_ticket');
        if (withLocalSessClean) {
            that.removeLocalSess();
            if (ticket) {
                window.location.href = decodeURIComponent(that.localRunConfig.JumpBackUrl) + '?service_ticket=' + ticket;
                return;
            }
        }

        var localSession = that.getLocalSess();
        if (localSession) {
            // 有本地系统的cookie，判定为已登录
            that.runOnOnLocalSessionOkDo(localSession);
        } else {
            //没有本地系统的cookie,尝试取ticket
            that.localRunConfig.OnLocalSessionNotOkDo();

            if (ticket) {
                // console.log('has ticket!');
                //OnHasTicketDo
                that.localRunConfig.OnHasTicketDo(ticket);
            } else {
                //ticket也没用，检查tgc
                that.firstCheck(that.localRunConfig.JumpBackUrl, that.localRunConfig.OnSessionFailDo);
            }
        }
    };

    this.logout = function () {
        document.cookie = 'QNTGC=; path=/; domain=.qnbar.com; expires=Thu, 01 Jan 1970 00:00:01 GMT';
        document.cookie = 'QNTGC=; path=/; domain=.qnbar.cn; expires=Thu, 01 Jan 1970 00:00:01 GMT';
        document.cookie = 'QNTGC=; path=/; domain=.qnbar.net; expires=Thu, 01 Jan 1970 00:00:01 GMT';

        that.removeLocalSess();

        //OnLoginOutDo
    };
}

/* harmony default export */ __webpack_exports__["a"] = ({
    QnLoginClient: QnLoginClient
});

/***/ }),

/***/ "+D4M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-mima",
  "use": "icon-mima-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mima\"><defs><style type=\"text/css\"></style></defs><path d=\"M780.8 354.579692 665.6 354.579692 665.6 311.689846c0-72.310154-19.849846-193.299692-153.6-193.299692-138.870154 0-153.6 135.049846-153.6 193.299692l0 42.889846L243.2 354.579692 243.2 311.689846C243.2 122.249846 348.790154 0 512 0s268.8 122.249846 268.8 311.689846L780.8 354.579692zM588.8 669.420308C588.8 625.900308 554.220308 590.769231 512 590.769231s-76.8 35.131077-76.8 78.651077c0 29.459692 15.399385 54.468923 38.439385 67.820308l0 89.639385c0 21.740308 17.250462 39.699692 38.4 39.699692s38.4-17.959385 38.4-39.699692l0-89.639385C573.44 723.889231 588.8 698.88 588.8 669.420308zM896 512l0 393.609846c0 65.260308-51.869538 118.390154-115.2 118.390154L243.2 1024c-63.291077 0-115.2-53.129846-115.2-118.390154L128 512c0-65.220923 51.869538-118.390154 115.2-118.390154l537.6 0C844.130462 393.609846 896 446.779077 896 512z\" p-id=\"9230\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "+nHC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_qnbar_platform_js__ = __webpack_require__("Ljt4");


var PT = new __WEBPACK_IMPORTED_MODULE_0__vendor_qnbar_platform_js__["a" /* default */].Platform();
PT.config.env = "local"; //local test release
PT.config.hostBaseUrl = 'http://agent.local.qnbar.cn/'; //当前页面访问环境的host base
PT.config.platformUsagespace = 'PT_AGENT_BZ'; //平台标记，固定需要，qnapi的请求要带上 【后端给具体定义】
PT.config.apiBaseUrl = 'https://api2.qnbar.cn/'; //后端服务api 访问基本地址 例如 https://api2.qnbar.com
PT.config.qnloginBaseUrl = "http://passport.t.qnbar.cn/"; //passport统一登录服务web的基本地址
PT.config.qnloginPlatformNo = 8; //passport统一登录的注册平台号
PT.config.loginJumpBackUrl = encodeURIComponent(PT.config.hostBaseUrl); //passport统一登录的登录成功固定回跳地址
PT.config.wsHost = "ws.qnbar.cn";
PT.config.wsPort = "16668";
PT.config.wsProto = "wss";
PT.init();
/* unused harmony default export */ var _unused_webpack_default_export = ({
    PT: PT
});

/***/ }),

/***/ "/qC1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("nFVA");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("43f45eac", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-df96aa28\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-df96aa28\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0Gq2":
/***/ (function(module, exports, __webpack_require__) {

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = __webpack_require__("LkYP");
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.AuthKeyReq', null, global);
goog.exportSymbol('proto.BindReq', null, global);
goog.exportSymbol('proto.Msg', null, global);
goog.exportSymbol('proto.MsgEndPoint', null, global);
goog.exportSymbol('proto.MsgRsp', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AuthKeyReq = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.AuthKeyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.AuthKeyReq.displayName = 'proto.AuthKeyReq';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.AuthKeyReq.prototype.toObject = function (opt_includeInstance) {
    return proto.AuthKeyReq.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.AuthKeyReq} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.AuthKeyReq.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      sysdimension: jspb.Message.getFieldWithDefault(msg, 1, ""),
      key: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AuthKeyReq}
 */
proto.AuthKeyReq.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AuthKeyReq();
  return proto.AuthKeyReq.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AuthKeyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AuthKeyReq}
 */
proto.AuthKeyReq.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setSysdimension(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setKey(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AuthKeyReq.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.AuthKeyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AuthKeyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AuthKeyReq.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSysdimension();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
};

/**
 * optional string sysDimension = 1;
 * @return {string}
 */
proto.AuthKeyReq.prototype.getSysdimension = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.AuthKeyReq.prototype.setSysdimension = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string key = 2;
 * @return {string}
 */
proto.AuthKeyReq.prototype.getKey = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.AuthKeyReq.prototype.setKey = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.BindReq = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.BindReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.BindReq.displayName = 'proto.BindReq';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.BindReq.prototype.toObject = function (opt_includeInstance) {
    return proto.BindReq.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.BindReq} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.BindReq.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      tobindbzid: jspb.Message.getFieldWithDefault(msg, 1, 0),
      op: jspb.Message.getFieldWithDefault(msg, 2, ""),
      bindendpoint: (f = msg.getBindendpoint()) && proto.MsgEndPoint.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BindReq}
 */
proto.BindReq.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.BindReq();
  return proto.BindReq.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BindReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BindReq}
 */
proto.BindReq.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */reader.readInt32();
        msg.setTobindbzid(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setOp(value);
        break;
      case 3:
        var value = new proto.MsgEndPoint();
        reader.readMessage(value, proto.MsgEndPoint.deserializeBinaryFromReader);
        msg.setBindendpoint(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.BindReq.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.BindReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BindReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.BindReq.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTobindbzid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getOp();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getBindendpoint();
  if (f != null) {
    writer.writeMessage(3, f, proto.MsgEndPoint.serializeBinaryToWriter);
  }
};

/**
 * optional int32 toBindBzId = 1;
 * @return {number}
 */
proto.BindReq.prototype.getTobindbzid = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};

/** @param {number} value */
proto.BindReq.prototype.setTobindbzid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string op = 2;
 * @return {string}
 */
proto.BindReq.prototype.getOp = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.BindReq.prototype.setOp = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional MsgEndPoint bindEndPoint = 3;
 * @return {?proto.MsgEndPoint}
 */
proto.BindReq.prototype.getBindendpoint = function () {
  return (/** @type{?proto.MsgEndPoint} */jspb.Message.getWrapperField(this, proto.MsgEndPoint, 3)
  );
};

/** @param {?proto.MsgEndPoint|undefined} value */
proto.BindReq.prototype.setBindendpoint = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};

proto.BindReq.prototype.clearBindendpoint = function () {
  this.setBindendpoint(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.BindReq.prototype.hasBindendpoint = function () {
  return jspb.Message.getField(this, 3) != null;
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Msg = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Msg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.Msg.displayName = 'proto.Msg';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.Msg.prototype.toObject = function (opt_includeInstance) {
    return proto.Msg.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.Msg} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.Msg.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      msgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
      bzid: jspb.Message.getFieldWithDefault(msg, 2, 0),
      op: jspb.Message.getFieldWithDefault(msg, 3, ""),
      frommsgid: jspb.Message.getFieldWithDefault(msg, 4, ""),
      from: (f = msg.getFrom()) && proto.MsgEndPoint.toObject(includeInstance, f),
      to: (f = msg.getTo()) && proto.MsgEndPoint.toObject(includeInstance, f),
      sdata: jspb.Message.getFieldWithDefault(msg, 7, ""),
      bzdata: jspb.Message.getFieldWithDefault(msg, 8, ""),
      rdata: jspb.Message.getFieldWithDefault(msg, 9, ""),
      tag: jspb.Message.getFieldWithDefault(msg, 10, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Msg}
 */
proto.Msg.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Msg();
  return proto.Msg.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Msg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Msg}
 */
proto.Msg.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setMsgid(value);
        break;
      case 2:
        var value = /** @type {number} */reader.readInt32();
        msg.setBzid(value);
        break;
      case 3:
        var value = /** @type {string} */reader.readString();
        msg.setOp(value);
        break;
      case 4:
        var value = /** @type {string} */reader.readString();
        msg.setFrommsgid(value);
        break;
      case 5:
        var value = new proto.MsgEndPoint();
        reader.readMessage(value, proto.MsgEndPoint.deserializeBinaryFromReader);
        msg.setFrom(value);
        break;
      case 6:
        var value = new proto.MsgEndPoint();
        reader.readMessage(value, proto.MsgEndPoint.deserializeBinaryFromReader);
        msg.setTo(value);
        break;
      case 7:
        var value = /** @type {string} */reader.readString();
        msg.setSdata(value);
        break;
      case 8:
        var value = /** @type {string} */reader.readString();
        msg.setBzdata(value);
        break;
      case 9:
        var value = /** @type {string} */reader.readString();
        msg.setRdata(value);
        break;
      case 10:
        var value = /** @type {string} */reader.readString();
        msg.setTag(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Msg.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.Msg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Msg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Msg.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getMsgid();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getBzid();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getOp();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getFrommsgid();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(5, f, proto.MsgEndPoint.serializeBinaryToWriter);
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(6, f, proto.MsgEndPoint.serializeBinaryToWriter);
  }
  f = message.getSdata();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getBzdata();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getRdata();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getTag();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
};

/**
 * optional string msgId = 1;
 * @return {string}
 */
proto.Msg.prototype.getMsgid = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setMsgid = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional int32 bzId = 2;
 * @return {number}
 */
proto.Msg.prototype.getBzid = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};

/** @param {number} value */
proto.Msg.prototype.setBzid = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string op = 3;
 * @return {string}
 */
proto.Msg.prototype.getOp = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 3, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setOp = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string fromMsgId = 4;
 * @return {string}
 */
proto.Msg.prototype.getFrommsgid = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 4, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setFrommsgid = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional MsgEndPoint from = 5;
 * @return {?proto.MsgEndPoint}
 */
proto.Msg.prototype.getFrom = function () {
  return (/** @type{?proto.MsgEndPoint} */jspb.Message.getWrapperField(this, proto.MsgEndPoint, 5)
  );
};

/** @param {?proto.MsgEndPoint|undefined} value */
proto.Msg.prototype.setFrom = function (value) {
  jspb.Message.setWrapperField(this, 5, value);
};

proto.Msg.prototype.clearFrom = function () {
  this.setFrom(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.Msg.prototype.hasFrom = function () {
  return jspb.Message.getField(this, 5) != null;
};

/**
 * optional MsgEndPoint to = 6;
 * @return {?proto.MsgEndPoint}
 */
proto.Msg.prototype.getTo = function () {
  return (/** @type{?proto.MsgEndPoint} */jspb.Message.getWrapperField(this, proto.MsgEndPoint, 6)
  );
};

/** @param {?proto.MsgEndPoint|undefined} value */
proto.Msg.prototype.setTo = function (value) {
  jspb.Message.setWrapperField(this, 6, value);
};

proto.Msg.prototype.clearTo = function () {
  this.setTo(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.Msg.prototype.hasTo = function () {
  return jspb.Message.getField(this, 6) != null;
};

/**
 * optional string sData = 7;
 * @return {string}
 */
proto.Msg.prototype.getSdata = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 7, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setSdata = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string bzData = 8;
 * @return {string}
 */
proto.Msg.prototype.getBzdata = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 8, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setBzdata = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string rData = 9;
 * @return {string}
 */
proto.Msg.prototype.getRdata = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 9, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setRdata = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string tag = 10;
 * @return {string}
 */
proto.Msg.prototype.getTag = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 10, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setTag = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MsgEndPoint = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MsgEndPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.MsgEndPoint.displayName = 'proto.MsgEndPoint';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.MsgEndPoint.prototype.toObject = function (opt_includeInstance) {
    return proto.MsgEndPoint.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.MsgEndPoint} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.MsgEndPoint.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      group: jspb.Message.getFieldWithDefault(msg, 1, ""),
      sn: jspb.Message.getFieldWithDefault(msg, 2, ""),
      timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MsgEndPoint}
 */
proto.MsgEndPoint.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MsgEndPoint();
  return proto.MsgEndPoint.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MsgEndPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MsgEndPoint}
 */
proto.MsgEndPoint.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setGroup(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setSn(value);
        break;
      case 3:
        var value = /** @type {number} */reader.readInt32();
        msg.setTimestamp(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MsgEndPoint.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.MsgEndPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MsgEndPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MsgEndPoint.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getGroup();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getSn();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
};

/**
 * optional string group = 1;
 * @return {string}
 */
proto.MsgEndPoint.prototype.getGroup = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.MsgEndPoint.prototype.setGroup = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string sn = 2;
 * @return {string}
 */
proto.MsgEndPoint.prototype.getSn = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.MsgEndPoint.prototype.setSn = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional int32 timestamp = 3;
 * @return {number}
 */
proto.MsgEndPoint.prototype.getTimestamp = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};

/** @param {number} value */
proto.MsgEndPoint.prototype.setTimestamp = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MsgRsp = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MsgRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.MsgRsp.displayName = 'proto.MsgRsp';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.MsgRsp.prototype.toObject = function (opt_includeInstance) {
    return proto.MsgRsp.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.MsgRsp} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.MsgRsp.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      code: jspb.Message.getFieldWithDefault(msg, 1, 0),
      codemsg: jspb.Message.getFieldWithDefault(msg, 2, ""),
      msgid: jspb.Message.getFieldWithDefault(msg, 3, ""),
      bzid: jspb.Message.getFieldWithDefault(msg, 4, 0),
      op: jspb.Message.getFieldWithDefault(msg, 5, ""),
      frommsgid: jspb.Message.getFieldWithDefault(msg, 6, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MsgRsp}
 */
proto.MsgRsp.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MsgRsp();
  return proto.MsgRsp.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MsgRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MsgRsp}
 */
proto.MsgRsp.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */reader.readInt32();
        msg.setCode(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setCodemsg(value);
        break;
      case 3:
        var value = /** @type {string} */reader.readString();
        msg.setMsgid(value);
        break;
      case 4:
        var value = /** @type {number} */reader.readInt32();
        msg.setBzid(value);
        break;
      case 5:
        var value = /** @type {string} */reader.readString();
        msg.setOp(value);
        break;
      case 6:
        var value = /** @type {string} */reader.readString();
        msg.setFrommsgid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MsgRsp.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.MsgRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MsgRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MsgRsp.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getCodemsg();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getMsgid();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getBzid();
  if (f !== 0) {
    writer.writeInt32(4, f);
  }
  f = message.getOp();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getFrommsgid();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.MsgRsp.prototype.getCode = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};

/** @param {number} value */
proto.MsgRsp.prototype.setCode = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string codeMsg = 2;
 * @return {string}
 */
proto.MsgRsp.prototype.getCodemsg = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.MsgRsp.prototype.setCodemsg = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string msgId = 3;
 * @return {string}
 */
proto.MsgRsp.prototype.getMsgid = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 3, "")
  );
};

/** @param {string} value */
proto.MsgRsp.prototype.setMsgid = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional int32 bzId = 4;
 * @return {number}
 */
proto.MsgRsp.prototype.getBzid = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};

/** @param {number} value */
proto.MsgRsp.prototype.setBzid = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional string op = 5;
 * @return {string}
 */
proto.MsgRsp.prototype.getOp = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 5, "")
  );
};

/** @param {string} value */
proto.MsgRsp.prototype.setOp = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string fromMsgId = 6;
 * @return {string}
 */
proto.MsgRsp.prototype.getFrommsgid = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 6, "")
  );
};

/** @param {string} value */
proto.MsgRsp.prototype.setFrommsgid = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

goog.object.extend(exports, proto);

/***/ }),

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = parseTime;
/* unused harmony export formatTime */
/* harmony export (immutable) */ __webpack_exports__["g"] = setRouteQuery;
/* harmony export (immutable) */ __webpack_exports__["o"] = createDownloadUrl;
/* harmony export (immutable) */ __webpack_exports__["s"] = validate;
/* harmony export (immutable) */ __webpack_exports__["t"] = resetFields;
/* harmony export (immutable) */ __webpack_exports__["u"] = validateField;
/* harmony export (immutable) */ __webpack_exports__["c"] = filterEmptyProperty;
/* harmony export (immutable) */ __webpack_exports__["a"] = agencyQnbarRequest;
/* unused harmony export toFormData */
/* harmony export (immutable) */ __webpack_exports__["v"] = deepCopy;
/* harmony export (immutable) */ __webpack_exports__["k"] = calculateMd5ByChunkSize;
/* harmony export (immutable) */ __webpack_exports__["w"] = toMulFormData;
/* harmony export (immutable) */ __webpack_exports__["j"] = getChangeProps;
/* harmony export (immutable) */ __webpack_exports__["d"] = xlsx;
/* harmony export (immutable) */ __webpack_exports__["r"] = throttle;
/* harmony export (immutable) */ __webpack_exports__["f"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["l"] = agencyQnbarRequest2;
/* harmony export (immutable) */ __webpack_exports__["q"] = humpToUnderline;
/* harmony export (immutable) */ __webpack_exports__["i"] = getDateStartTime;
/* harmony export (immutable) */ __webpack_exports__["p"] = getDateEndTime;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getAMap; });
/* harmony export (immutable) */ __webpack_exports__["m"] = getImageInfo;
/* harmony export (immutable) */ __webpack_exports__["x"] = pick;
/* harmony export (immutable) */ __webpack_exports__["A"] = getRlativePath;
/* harmony export (immutable) */ __webpack_exports__["z"] = getDateEndTimestamp;
/* harmony export (immutable) */ __webpack_exports__["n"] = calculateMD5File_2;
/* harmony export (immutable) */ __webpack_exports__["y"] = getDateStartTimestamp;
/* harmony export (immutable) */ __webpack_exports__["b"] = agencyQnbarRequest_noalert;
/* harmony export (immutable) */ __webpack_exports__["B"] = downloadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__env__ = __webpack_require__("yZtZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svrapi__ = __webpack_require__("Mp/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_spark_md5__ = __webpack_require__("JSQk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_spark_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_spark_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_file_saver__ = __webpack_require__("t4zo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_xlsx__ = __webpack_require__("uXZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amap_amap_jsapi_loader__ = __webpack_require__("Milw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amap_amap_jsapi_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amap_amap_jsapi_loader__);














var PT = __WEBPACK_IMPORTED_MODULE_5__env__["a" /* default */].PT;

function parseTime(time, cFormat) {
  var isUTC = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date = void 0;
  if ((typeof time === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(time)) === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  var formatObj = null;
  if (isUTC) {
    formatObj = {
      y: date.getUTCFullYear(),
      m: date.getUTCMonth() + 1,
      d: date.getUTCDate(),
      h: date.getUTCHours(),
      i: date.getUTCMinutes(),
      s: date.getUTCSeconds(),
      a: date.getUTCDay()
    };
  } else {
    formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    };
  }
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

function formatTime(time, option) {
  time = +time * 1000;
  var d = new Date(time);
  var now = Date.now();

  var diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * 设置路由查询参数
 * @param param {Object} 要设置的参数对象
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
function setRouteQuery(param) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'replace';

  this.$router[method](this.$route.path + '?' + toFormData(param));
}

/**
 * 获取下载地址(新)
 * @param name {string} api名称
 * @param params {object} 参数
 * @param auth {boolean} 是否需要鉴权参数
 * @returns {string} 完整的下载地址
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
function createDownloadUrl(name, params) {
  var auth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var query = '?';
  if (auth) {
    var token = __WEBPACK_IMPORTED_MODULE_8_js_cookie___default.a.get(PT.qnlogin.localSessName);
    query += 'api_local_sess=' + token + '&api_usagespace=' + PT.config.platformUsagespace + '&';
  }
  if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(params).length) {
    query += '' + toFormData(params);
  }
  return '' + PT.config.apiBaseUrl + __WEBPACK_IMPORTED_MODULE_6__svrapi__["a" /* default */][name] + query;
}

/**
 * 验证表单
 * @param name
 * @returns {Promise<any>}
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
function validate(name) {
  var _this = this;

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    _this.$refs[name].validate(function (valid) {
      if (valid) {
        resolve();
      } else {
        reject();
      }
    });
  });
}

/**
 * 重置表单
 * @param name
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
function resetFields(name) {
  this.$refs[name].resetFields();
}

/**
 * 对部分表单字段进行校验的方法
 * @param prop 表单字段
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
function validateField(prop) {
  var _this2 = this;

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    _this2.$refs[name].validateField(prop, function (err) {
      if (err) {
        resolve(err);
      } else {
        reject(err);
      }
    });
  });
}

/**
 * 过滤掉空属性
 * @param obj {object} 需要过滤的对象
 * @returns {object}
 */
function filterEmptyProperty(obj) {
  var params = {};
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
      params[key] = obj[key];
    }
  });
  return params;
}

/**
 * 代理http请求，返回promise对象
 * @param name {string} api名称
 * @param params {object} api参数
 * @returns Promise
 */
function agencyQnbarRequest(name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_6__svrapi__["a" /* default */][name], params, function (res) {
      if (res.code === 0) {
        resolve(res);
      } else {
        reject(res);
        if (__WEBPACK_IMPORTED_MODULE_6__svrapi__["a" /* default */][name] !== 'warehouse/agent/psn/check') {
          __WEBPACK_IMPORTED_MODULE_7_element_ui__["MessageBox"].alert(res.msg, '提示');
        }
      }
    }, function (err) {
      reject({ code: -1, msg: '网络请求失败: ' + err });
    });
  });
}

/**
 * 将参数对象转化为键值对的字符串
 * @param data {object} 参数对象
 * @returns {string}
 */
function toFormData(data) {
  var res = '';
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
    res += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]) + '&';
  });
  return res.slice(0, -1);
}

/**
 * 深克隆数据
 * @param data {object} 参数对象
 * @returns {Object}
 */
function deepCopy() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}

// MD5解析
function calculateMd5ByChunkSize(file, chunkSize) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
    var fileReader = new FileReader();
    var blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice;
    var chunks = Math.ceil(file.size / chunkSize);
    var currentChunk = 0;
    var spark = new __WEBPACK_IMPORTED_MODULE_9_spark_md5___default.a();

    // 读取完成时触发事件
    fileReader.onload = function (e) {
      spark.appendBinary(e.target.result); // append binary string
      currentChunk++;
      if (currentChunk < chunks) {
        loadNext();
      } else {
        resolve(spark.end());
      }
    };

    function loadNext() {
      var start = currentChunk * chunkSize,
          end = start + chunkSize >= file.size ? file.size : start + chunkSize;
      fileReader.readAsBinaryString(blobSlice.call(file, start, end));
    }

    loadNext();
  });
}

function toMulFormData(data) {
  var formData = new FormData();
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
    formData.append(key, data[key]);
  });
  return formData;
}

/**
 * 返回有变动的属性
 * @param oldVal {Object} 旧的对象
 * @param newVal {Object} 新对象
 * @param filter {Array=} 例外的属性不检测
 * @returns {(boolean|Object)} 变动属性组成的对象，如果属性无变动则返回false
 */
function getChangeProps(oldVal, newVal) {
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (oldVal === newVal) return {};
  var keys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(oldVal);
  var changeProps = {};
  keys.forEach(function (key) {
    if (filter.includes(key)) return;
    if (oldVal[key] !== newVal[key]) {
      changeProps[key] = newVal[key];
    }
  });
  if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(changeProps).length) return false;
  return changeProps;
}

// 将数据转换为xlsx文件并导出
function xlsx(json, fields) {
  var filename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.xlsx';
  // 导出xlsx
  json.forEach(function (item) {
    for (var i in item) {
      if (fields.hasOwnProperty(i)) {
        item[fields[i]] = item[i];
      }
      delete item[i]; // 删除原先的对象属性
    }
  });
  var sheetName = filename; // excel的文件名称
  var wb = __WEBPACK_IMPORTED_MODULE_11_xlsx___default.a.utils.book_new(); // 工作簿对象包含一SheetNames数组，以及一个表对象映射表名称到表对象。XLSX.utils.book_new实用函数创建一个新的工作簿对象。
  var ws = __WEBPACK_IMPORTED_MODULE_11_xlsx___default.a.utils.json_to_sheet(json, { header: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(fields) }); // 将JS对象数组转换为工作表。
  wb.SheetNames.push(sheetName);
  wb.Sheets[sheetName] = ws;
  var defaultCellStyle = { font: { name: 'Verdana', sz: 13, color: 'FF00FF88' }, fill: { fgColor: { rgb: 'FFFFAA00' } } // 设置表格的样式
  };var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary', cellStyles: true, defaultCellStyle: defaultCellStyle, showGridLines: false // 写入的样式
  };var wbout = __WEBPACK_IMPORTED_MODULE_11_xlsx___default.a.write(wb, wopts);
  var blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
  __WEBPACK_IMPORTED_MODULE_10_file_saver___default.a.saveAs(blob, filename + '.xlsx');
}

var s2ab = function s2ab(s) {
  var buf;
  if (typeof ArrayBuffer !== 'undefined') {
    buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }return buf;
  } else {
    buf = new Array(s.length);
    for (var i = 0; i != s.length; ++i) {
      buf[i] = s.charCodeAt(i) & 0xFF;
    }return buf;
  }
};

// 限流
function throttle(fn, interval) {
  var last = 0;
  return function () {
    var now = Date.now();
    if (now - last >= interval) {
      last = now;
      fn.apply(this, arguments);
    }
  };
}

// 防抖
function debounce(fn, delay) {
  var timer = null;
  return function () {
    var _this3 = this,
        _arguments = arguments;

    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      fn.apply(_this3, _arguments);
    }, delay);
  };
}

/**
 * 添加了自动转参数
 * @returns Promise
 */
function agencyQnbarRequest2() {
  try {
    arguments[1] = humpToUnderline(arguments[1]);
  } catch (e) {}
  return agencyQnbarRequest.apply(null, arguments);
}

// 驼峰转下划线
function humpToUnderline(obj) {
  var newObj = {};
  for (var key in obj) {
    var val = obj[key];
    key = key.replace(/[A-Z]/g, function (str) {
      return '_' + str.toLowerCase();
    });
    newObj[key] = val;
  }
  return newObj;
}

function getDateStartTime(date) {
  return new Date(parseTime(date, '{y}-{m}-{d}') + ' 0:0:0').getTime() / 1000;
}

function getDateEndTime(date) {
  return new Date(parseTime(date, '{y}-{m}-{d}') + ' 23:59:59').getTime() / 1000;
}

/**
 * 获取高德地图构造函数
 */
var getAMap = function () {
  window._AMapSecurityConfig = {
    securityJsCode: '79770c81abc0a8d17a37e2263f6633d0' // 密钥
  };
  var AMap = null;
  return function () {
    if (AMap) return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(AMap);
    return __WEBPACK_IMPORTED_MODULE_12__amap_amap_jsapi_loader___default.a.load({
      key: '2291eb77f53217f765e03c6a2c46c064',
      version: '2.0',
      plugins: ['AMap.ControlBar', 'AMap.PlaceSearch', 'AMap.MouseTool', 'AMap.ElasticMarker', 'AMap.HawkEye', 'AMap.DistrictSearch', 'AMap.Autocomplete', 'AMap.Scale', 'AMap.ToolBar', 'AMap.Geocoder', 'AMap.Geolocation']
    }).then(function (AMap) {
      return AMap;
    });
  };
}();

// 获取图片分辨率
function getImageInfo(url) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
    var image = new Image();
    var w = void 0,
        h = void 0;
    image.src = url;
    if (!image.complete) {
      image.onload = function () {
        w = image.width;
        h = image.height;
        image.onload = null;
        resolve({
          width: w,
          height: h
        });
      };
      return;
    }
    w = image.width;
    h = image.height;
    resolve({
      width: w,
      height: h
    });
  });
}

/**
 * 拷贝部分对象
 * @param {Object} obj 拷贝的元数据
 * @param {Array} props 属性名组成的数组
 */
function pick(obj, props) {
  var data = props.reduce(function (data, key) {
    if (key in obj) {
      data[key] = obj[key];
    }
    return data;
  }, {});
  return data;
}

/**
 * 获取文件相对路径
 * @param {string} fullPath 全路径
 * @returns
 */
function getRlativePath(fullPath) {
  if (!fullPath) return '';
  return fullPath.replace(/(http(s)?:\/\/)[\w\.]+(\.cn|\.com)/g, '');
}

// 获取日期的当日结束时间，单位（秒）
function getDateEndTimestamp(date) {
  return date.setHours(23, 59, 59, 0) / 1000;
}

// 计算文件的MD5
function calculateMD5File_2(file, chunkSize) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
    var chunks = Math.ceil(file.size / chunkSize);
    var currentChunk = 0;
    var spark = new __WEBPACK_IMPORTED_MODULE_9_spark_md5___default.a.ArrayBuffer();
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
      spark.append(e.target.result);
      currentChunk++;
      if (currentChunk < chunks) {
        loadNext();
      } else {
        var md5 = spark.end();
        resolve(md5);
      }
    };
    fileReader.onerror = function (e) {
      reject(e);
    };
    function loadNext() {
      var start = currentChunk * chunkSize;
      var end = start + chunkSize;
      if (end > file.size) {
        end = file.size;
      }
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }
    loadNext();
  });
}

// 获取日期的当日开始时间，单位（秒）
function getDateStartTimestamp(date) {
  return date.setHours(0, 0, 0, 0) / 1000;
}

/**
 * 代理http请求，返回promise对象 (与之前的http请求没有变化，去掉了的默认弹出框错误提示)
 * @param name {string} api名称
 * @param params {object} api参数
 * @returns Promise
 */
function agencyQnbarRequest_noalert(name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mode = arguments[2];

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_6__svrapi__["a" /* default */][name], params, function (res) {
      if (res.code === 0) {
        resolve(res);
      } else {
        reject(res);
      }
    }, function (err) {
      reject({ code: -1, msg: '网络请求失败: ' + err });
    }, mode);
  });
}

/**
 * 下载文件，适用于批量下载
 * @param {string} url 下载文件的url
 * @param {number} triggerDelay 延迟添加iframe时间
 * @param {number} removeDelay 延迟删除iframe时间
 */
function downloadFile(url) {
  var triggerDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var removeDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;

  //动态添加iframe，设置src，然后删除
  // 动态添加iframe，设置src，然后删除
  setTimeout(function () {
    var frame = $('<iframe style="display: none;" class="multi-download"></iframe>');
    frame.attr('src', url);
    $(document.body).after(frame);
    setTimeout(function () {
      frame.remove();
    }, removeDelay);
  }, triggerDelay);
}

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "11jX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("o0jG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e0d390_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("8CfS");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e0d390_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/QnInput/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-71e0d390", Component.options)
  } else {
    hotAPI.reload("data-v-71e0d390", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "13E8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-xinrenzhinan",
  "use": "icon-xinrenzhinan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-xinrenzhinan\"><defs><style type=\"text/css\"></style></defs><path d=\"M780.108 761.059c54.451 60.351 87.706 138.983 87.706 225.358 0 12.015-0.659 23.882-1.902 35.581l-71.955 0c1.589-11.675 2.695-23.493 2.695-35.581 0-71.578-29.094-136.386-76.189-185.002C658.778 836.02 587.76 855.95 512 855.95c-75.689 0-146.65-19.888-208.294-54.432-47.129 48.604-76.358 113.305-76.358 184.9 0 12.088 1.105 23.906 2.695 35.581l-71.955 0c-1.243-11.699-1.902-23.567-1.902-35.581 0-86.366 33.19-165.055 87.587-225.446-96.765-78.277-158.75-197.84-158.75-331.998C85.023 193.163 276.188 2.001 512 2.001s426.977 191.162 426.977 426.972C938.977 563.184 876.94 682.785 780.108 761.059zM512 295.787c-196.511 0-355.814-80.302-355.814 122.251 0 202.551 159.303 366.749 355.814 366.749s355.814-164.199 355.814-366.749C867.814 215.485 708.511 295.787 512 295.787zM678.047 500.136c-26.2 0-47.442-21.24-47.442-47.442 0-26.197 21.242-47.442 47.442-47.442 26.202 0 47.442 21.244 47.442 47.442C725.488 478.896 704.249 500.136 678.047 500.136zM654.326 630.601c0 32.754-63.722 59.302-142.326 59.302s-142.326-26.549-142.326-59.302c0-8.445 4.376-16.446 12.017-23.719 21.98 20.927 71.979 35.579 130.309 35.579s108.329-14.652 130.309-35.579C649.949 614.155 654.326 622.156 654.326 630.601zM345.953 500.136c-26.202 0-47.442-21.24-47.442-47.442 0-26.197 21.24-47.442 47.442-47.442 26.2 0 47.442 21.244 47.442 47.442C393.395 478.896 372.153 500.136 345.953 500.136z\" p-id=\"9555\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "1BzD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarItem__ = __webpack_require__("6o49");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_export__ = __webpack_require__("iNHu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_export___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_export__);



//
//
//
//
//
//
//
//
//
//
//
//

 // 获取vuex数据



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SidebarItem: __WEBPACK_IMPORTED_MODULE_4__SidebarItem__["default"] },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['sidebar', 'permissions']), {
    myRoutes: function myRoutes() {
      return this.routes;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  data: function data() {
    return {
      routes: [],
      user_info: {},
      user_all: []
    };
  },

  watch: {
    permissions: function permissions(newVal) {
      if (newVal && newVal.length > 0) {
        var routes = this.$router.options.routes;
        this.handleRoutes(routes);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    var routes = this.$router.options.routes;
    var baseInfo = JSON.parse(localStorage.getItem('base_info'));
    if (!baseInfo) {
      var prarm = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* agencyQnbarRequest */])('getdetail', prarm).then(function (res) {
        console.log(res, '获取数据');
        var baseInfo = res.data;
        localStorage.setItem('base_info', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(baseInfo));
        _this.handleRoutes(routes);
      });
    } else {
      this.handleRoutes(routes);
    }
  },

  methods: {
    // 处理路由
    handleRoutes: function handleRoutes(routes_data) {
      // 只从 Vuex 获取权限，不使用 localStorage 缓存
      var user_all = this.permissions && this.permissions.length > 0 ? this.permissions : [];
      if (user_all.length === 0) {
        // 权限还未从接口返回，不渲染菜单，等 watch 触发
        this.routes = [];
        return;
      }

      var mythisroutes = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(routes_data));
      var newarr = [];

      // 辅助鉴权函数：兼容新对象结构与旧字符串结构，并支持超级root权限
      var checkNodePermission = function checkNodePermission(node) {
        if (!node.meta) return true;
        var metaVal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(node.meta) === 'object' ? node.meta.permission : node.meta;
        if (!metaVal) return true;
        return user_all.indexOf(metaVal) !== -1;
      };

      // 第一级菜单过滤
      mythisroutes.forEach(function (route) {
        if (checkNodePermission(route)) {
          newarr.push(route);
        }
      });

      // 第二级菜单过滤
      newarr.forEach(function (item) {
        if (item.children) {
          item.children = item.children.filter(function (child) {
            return checkNodePermission(child);
          });
        }
      });

      // 第三级菜单过滤 (兼容原有 title === '2' 的逻辑)
      newarr.forEach(function (parent) {
        if (parent.children) {
          parent.children.forEach(function (child) {
            if (child.children) {
              child.children = child.children.filter(function (grandChild) {
                return checkNodePermission(grandChild) || grandChild.title === '2';
              });
            }
          });
        }
      });

      this.routes = newarr;
      this.$router.options.routes = newarr;
    }
  }
});

/***/ }),

/***/ "1Nx3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

// Qnapi
function Qnapi(base, pusagespace, pgetLocalSessFunc) {
    var baseUrl = base;
    var usagespace = pusagespace;
    var getLocalSessFunc = pgetLocalSessFunc;
    var that = this;

    var class2type = {};
    "Boolean Number String Function Array Date RegExp Object Error".split(" ").forEach(function (e, i) {
        class2type["[object " + e + "]"] = e.toLowerCase();
    });

    this.typeof = function (obj) {
        if (obj == null) {
            return String(obj);
        }
        return (typeof obj === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) === "object" || typeof obj === "function" ? class2type[class2type.toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj);
    };

    this.setBaseUrl = function (base) {
        baseUrl = base;
    };

    //阻塞请求队列
    this.blocked = false;
    this.blockQueryObjQueue = [];
    this.blockQueryObj = function (func, apiPath, paramObj, callbackSucc, callbackOnFail) {
        this.func = func;
        this.apiPath = apiPath;
        this.paramObj = paramObj;
        this.callbackSucc = callbackSucc;
        this.callbackOnFail = callbackOnFail;
    };

    this.blockQuery = function () {
        that.blocked = true;
    };

    this.resumeQuery = function () {
        that.blocked = false;
        for (var i = 0; i < that.blockQueryObjQueue.length; i++) {
            var obj = that.blockQueryObjQueue[i];
            // console.log('resume : ' + obj.apiPath);
            obj.func(obj.apiPath, obj.paramObj, obj.callbackSucc, obj.callbackOnFail);
        }
    };

    this.query = function (apiPath, paramObj, callbackSucc, callbackOnFail) {

        if (that.blocked) {
            // console.log('blocked : ' + apiPath);
            that.blockQueryObjQueue.push(new that.blockQueryObj(this.query, apiPath, paramObj, callbackSucc, callbackOnFail));
            return;
        }

        var paramsType = that.typeof(paramObj);
        var poststr = "";
        if (paramsType == 'object') {
            for (var key in paramObj) {
                if (poststr != "") {
                    poststr += "&";
                }
                poststr += key + "=" + encodeURIComponent(paramObj[key]);
            }
        } else {
            poststr = paramObj;
        }

        if (usagespace) {
            if (poststr != "") {
                poststr += "&";
            }
            poststr += "api_usagespace=" + usagespace;
        }
        if (getLocalSessFunc) {
            var sess = getLocalSessFunc();
            if (sess) {
                if (poststr != "") {
                    poststr += "&";
                }
                poststr += "api_local_sess=" + sess;
            }
        }

        var url = baseUrl + apiPath;
        var xmlhttp = new XMLHttpRequest();
        xmlhttp.open("POST", url, true);
        xmlhttp.timout = 3000;
        xmlhttp.withCredentials = true;
        xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        try {
            xmlhttp.onreadystatechange = function () {
                if (xmlhttp.readyState == 4) {
                    if (xmlhttp.status == 200) {
                        var obj = JSON && JSON.parse(xmlhttp.responseText) || $.parseJSON(xmlhttp.responseText);
                        callbackSucc(obj);
                    } else {
                        if (callbackOnFail != null) {
                            // console.log('query fail : ' + xmlhttp.status );
                            callbackOnFail(xmlhttp.status);
                        }
                    }
                }
            };
            xmlhttp.send(poststr);
        } catch (e) {
            //   console.log('catch error', e);
            callbackOnFail(e);
        }
    };

    //fetch 模式获取请求
    this.q = function (apiPath, paramObj) {
        /*
        // Return a new promise.
        return new Promise(function(resolve, reject) {
               var paramsType = that.typeof(paramObj);
            var poststr = "";
            if (paramsType == 'object'){
                for (var key in paramObj) {
                    if (poststr != "") {
                        poststr += "&";
                    }
                    poststr += key + "=" + encodeURIComponent(paramObj[key]);
                }
            }else{
                poststr = paramObj;
            }
             if (usagespace){
                if (poststr != "") {
                    poststr += "&";
                }
                poststr += "api_usagespace=" + usagespace;
            }
            if (getLocalSessFunc){
                var sess = getLocalSessFunc();
                if (sess){
                    if (poststr != "") {
                        poststr += "&";
                    }
                    poststr += "api_local_sess=" + sess;
                }
            }
             var url = baseUrl + apiPath;
            var xmlhttp = new XMLHttpRequest();
            xmlhttp.open("POST", url, true);
            xmlhttp.timout = 3000;
            xmlhttp.withCredentials = true;
            xmlhttp.setRequestHeader("Content-type","application/x-www-form-urlencoded");
             try{
                xmlhttp.onreadystatechange=function(){
                    if (xmlhttp.readyState==4){
                        if (xmlhttp.status==200){
                            var obj = JSON && JSON.parse(xmlhttp.responseText) || $.parseJSON(xmlhttp.responseText);
                            resolve(obj);
                        }else{
                            if (callbackOnFail != null){
                                console.log('query fail : ' + xmlhttp.status);
                                reject(Error(xmlhttp.status));
                            }
                        }
                    }
                };
                 xmlhttp.onerror = function() {
                    reject(Error("Network Error"));
                };
                 xmlhttp.send(poststr);
             } catch(e) {
                console.log('catch error', e);
                reject(e);
            }
         });*/
    };
};

/* harmony default export */ __webpack_exports__["a"] = ({
    Qnapi: Qnapi
});

/***/ }),

/***/ "1cb1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        Vue.directive('loadmore', {
            // bind(el, binding) {
            //   const selectWrap = el.querySelector('.el-table__body-wrapper')
            //   selectWrap.addEventListener('scroll', function() {
            //     let sign = 100
            //     const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
            //     if (scrollDistance <= sign) {
            //       binding.value()
            //     }
            //   })
            // }
            bind: function bind(el, binding) {
                // 获取element-ui定义好的scroll盒子
                var SELECTWRAP_DOM = el.querySelector('.el-table__body-wrapper');
                SELECTWRAP_DOM.addEventListener('scroll', function () {
                    /*
                     * scrollHeight 获取元素内容高度(只读)
                     * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                     * clientHeight 读取元素的可见高度(只读)
                     * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                     * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                     */
                    var sign = 80; // 定义默认的向上滚于乡下滚的边界
                    var CONDITION = this.scrollHeight - Math.ceil(this.scrollTop) === this.clientHeight && this.scrollTop > sign; // 注意: && this.scrollTop
                    if (this.scrollTop > sign) {
                        sign = this.scrollTop;
                        //console.log('向下');
                    }
                    if (this.scrollTop < sign) {
                        sign = this.scrollTop;
                        //console.log('向上');
                    }
                    if (CONDITION) {
                        binding.value();
                    }
                });
            }
        });
    }
});

/***/ }),

/***/ "1wdh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-shouce",
  "use": "icon-shouce-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shouce\"><defs><style type=\"text/css\"></style></defs><path d=\"M896 192v704H256.8c-71.2 0-128.8-57.6-128.8-128.8V256.8C128 185.6 185.6 128 256.8 128H768v512H257.6c-36 0-65.6 29.6-65.6 65.6v60.8c0 36 29.6 65.6 65.6 65.6H832V192h64zM768 704H256v64h512v-64z\" p-id=\"8326\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3e5d":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.navbar[data-v-6bce3e2a] {\n  height: 50px;\n  line-height: 50px;\n  border-radius: 0px !important;\n}\n.navbar .hamburger-container[data-v-6bce3e2a] {\n    line-height: 58px;\n    height: 50px;\n    float: left;\n    padding: 0 10px;\n}\n.navbar .errLog-container[data-v-6bce3e2a] {\n    display: inline-block;\n    position: absolute;\n    right: 150px;\n}\n.navbar .screenfull[data-v-6bce3e2a] {\n    position: absolute;\n    right: 90px;\n    top: 16px;\n    color: red;\n}\n.navbar .avatar-container[data-v-6bce3e2a] {\n    height: 50px;\n    display: inline-block;\n    position: absolute;\n    right: 35px;\n}\n.navbar .avatar-container .avatar-wrapper[data-v-6bce3e2a] {\n      cursor: pointer;\n      margin-top: 5px;\n      position: relative;\n}\n.navbar .avatar-container .avatar-wrapper .user-avatar[data-v-6bce3e2a] {\n        width: 40px;\n        height: 40px;\n        border-radius: 10px;\n}\n.navbar .avatar-container .avatar-wrapper .el-icon-caret-bottom[data-v-6bce3e2a] {\n        position: absolute;\n        right: -20px;\n        top: 25px;\n        font-size: 12px;\n}\n.navbar .nav-info[data-v-6bce3e2a] {\n    position: absolute;\n    right: 140px;\n    top: 0;\n    font-size: 18px;\n}\n", ""]);

// exports


/***/ }),

/***/ "3zpo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    created: function created() {
        this.getBreadcrumb();
    },
    data: function data() {
        return {
            levelList: null
        };
    },

    methods: {
        getBreadcrumb: function getBreadcrumb() {
            var matched = this.$route.matched.filter(function (item) {
                return item.name;
            });
            var first = matched[0];
            if (first && (first.name !== '首页' || first.path !== '')) {
                matched = [{ name: '首页', path: '/' }].concat(matched);
            }
            this.levelList = matched;
        }
    },
    watch: {
        $route: function $route() {
            this.getBreadcrumb();
        }
    }
});

/***/ }),

/***/ "41Of":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-from",
  "use": "icon-from-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-from\"><defs><style type=\"text/css\"></style></defs><path d=\"M960 256v64H64v-64c0-35.2 28.8-64 64-64h768c35.2 0 64 28.8 64 64z m0 128v384c0 35.2-28.8 64-64 64H128c-35.2 0-64-28.8-64-64V384h896zM256 640H128v32h128v-32z m128-64H128v32h256v-32z\" p-id=\"8100\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "5SbU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-QQ",
  "use": "icon-QQ-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-QQ\"><defs><style type=\"text/css\"></style></defs><path d=\"M273.5104 480.17408 272.31232 476.44672 271.33952 471.6032 270.6944 468.95104 270.6944 465.6128 270.6944 461.62944 270.6944 458.02496 271.85152 453.72416 273.02912 449.1776 274.5856 444.40576 276.6848 439.0912 279.43936 433.57184 283.33056 428.04224 283.33056 424.17152 283.70944 420.54656 284.3136 415.62112 285.98272 410.08128 287.51872 404.10112 288.74752 401.3568 290.16064 398.7968 291.98336 395.95008 293.96992 393.8304 293.96992 389.9392 293.96992 385.56672 293.96992 380.16 295.1168 373.11488 296.27392 364.93312 298.33216 355.14368 301.16864 344.95488 303.27808 339.3536 305.36704 333.2608 307.6608 327.5776 310.40512 321.4848 313.20064 314.81856 316.416 308.57216 320.03072 301.90592 324.58752 295.24992 326.69696 291.4304 328.93952 288.3072 333.824 281.26208 338.85184 274.23744 344.55552 267.008 350.6688 259.97312 357.30432 253.04064 364.22656 245.9136 372.60288 238.22336 377.91744 233.54368 384.39936 228.49536 390.97344 224.04096 398.08 219.76064 404.91008 215.95136 412.61056 212.79744 420.79232 208.91648 428.92288 206.25408 437.03296 203.48928 445.7984 200.74496 454.5536 198.656 463.75936 196.9152 473.09824 195.40992 482.31424 194.18112 491.52 192.9216 501.34016 192.38912 510.67904 192.38912 520.33536 192.38912 530.35008 192.38912 540.01664 193.60768 549.7344 194.7648 559.63648 195.79904 568.832 198.01088 578.53952 200.07936 587.65312 202.45504 597.63712 205.1072 606.7712 208.34304 615.51616 212.03968 624.85504 215.95136 633.37472 220.22144 641.65888 224.9728 649.7792 230.20544 656.77312 235.06944 660.0192 237.81376 663.41888 239.8208 669.91104 245.32992 675.3792 250.65472 680.83712 256.16384 686.15168 262.2464 690.5344 268.14464 695.7568 274.23744 699.392 280.7808 703.0784 286.59712 706.99008 293.36576 710.23616 299.25376 715.69408 311.71584 718.37696 318.1568 720.47616 324.12672 722.57536 330.60864 724.45952 336.70144 725.77024 341.94432 727.47008 348.1088 730.44992 359.1168 732.35456 368.75264 733.5936 378.07104 734.65856 385.56672 736.33792 396.98432 736.7168 398.7968 738.05824 400.85504 741.67296 406.76352 743.99744 410.76736 746.05568 414.93504 748.67712 419.39968 750.99136 424.7552 752.49664 430.2336 754.13504 436.24448 755.37408 442.40896 755.93728 445.44 756.45952 449.1776 756.45952 452.42368 755.93728 455.63904 755.93728 459.64288 754.9952 463.52384 753.27488 471.04 751.29856 474.83904 749.83424 479.10912 749.83424 480.17408 750.53056 481.49504 752.49664 484.61824 761.05728 497.28512 767.81568 506.79808 771.05152 513.14688 775.41376 520.09984 779.2128 527.7184 783.59552 535.8592 787.97824 545.01376 792.91392 555.37664 795.6992 561.72544 798.23872 567.93088 800.43008 574.47424 802.59072 580.36224 804.23936 586.5472 805.91872 592.35328 808.0384 603.67872 809.71776 615.24992 810.87488 625.5104 810.87488 631.11168 810.87488 635.71968 810.87488 639.98976 810.09664 645.12 808.99072 653.9776 807.4752 661.93408 805.12 669.15328 804.23936 672.09216 802.59072 675.6352 801.21856 678.10304 799.37536 681.14432 797.75744 683.0592 795.6992 685.53728 793.856 687.53408 791.88992 689.24416 789.53472 690.2784 787.41504 691.31264 785.67424 691.88608 784.15872 691.88608 783.01184 691.88608 781.312 691.31264 778.07616 689.7152 776.59136 688.65024 775.03488 687.53408 773.33504 686.00832 771.61472 684.29824 768.77824 681.14432 765.41952 676.68992 762.7776 672.09216 760.13568 668.416 757.5552 664.13568 753.92 656.5376 749.83424 648.63232 749.35296 648.35584 748.67712 648.35584 747.01824 649.59488 746.05568 651.6736 744.45824 654.25408 741.67296 661.93408 737.47456 672.86016 732.09856 686.00832 728.05376 692.56192 723.8144 699.40224 718.77632 707.09248 713.43104 714.61888 710.69696 718.0288 707.3792 721.74592 699.7504 729.2416 700.416 729.91744 701.45024 730.99264 705.25952 733.22496 721.13152 740.85376 728.05376 744.7552 734.65856 748.544 741.19168 753.31584 747.01824 758.23104 749.83424 760.45312 751.95392 763.01312 754.13504 765.98272 755.93728 769.19808 756.91008 771.87072 758.09792 775.07584 758.60992 777.85088 759.17312 781.08672 758.60992 783.2576 758.60992 785.4592 758.09792 787.73248 756.91008 789.8112 756.45952 791.43936 755.37408 793.41568 752.49664 797.3376 749.83424 800.48128 747.776 802.83648 746.05568 804.57728 741.67296 807.77216 736.7168 810.55744 731.43296 813.21984 725.77024 815.77984 719.45216 818.25792 716.05248 819.29216 713.07264 820.13184 705.73056 821.84192 698.15296 823.47008 690.5344 825.088 682.25024 826.43968 673.71008 826.79808 664.95488 827.8528 656.29184 827.8528 647.17824 827.8528 637.77792 827.8528 627.97824 827.27936 618.8544 826.43968 609.01376 825.088 599.25504 824.04352 588.97408 822.60992 579.01056 820.13184 569.2928 818.25792 559.63648 815.49312 549.7344 811.95008 540.01664 809.02144 534.89664 807.31136 530.35008 805.69344 527.47264 804.57728 524.61568 803.97312 520.93952 803.97312 516.53632 803.97312 507.19744 803.31776 502.4768 802.83648 496.39424 802.16064 492.4928 805.69344 487.168 809.02144 479.9488 812.53376 471.9616 816.91648 467.10784 819.29216 462.03904 821.17632 450.84672 825.7536 444.76416 827.27936 438.38464 828.99968 429.53728 830.72 423.99744 831.15008 418.14016 831.65184 412.02688 832.32768 404.91008 832.59392 398.08 832.59392 390.97344 832.59392 375.83872 832.59392 359.424 832.32768 343.48032 830.72 335.4112 829.57312 327.61856 828.416 320.03072 827.27936 312.44288 825.7536 305.36704 823.47008 298.33216 821.84192 291.98336 819.29216 285.98272 816.91648 280.38144 814.24384 275.51744 811.32544 270.6944 807.77216 269.04576 806.05184 266.88512 803.97312 265.24672 802.16064 263.77216 800.07168 262.41024 797.99296 261.35552 795.89376 259.82976 791.43936 259.29728 789.13536 258.62144 786.57536 258.62144 784.20992 259.29728 781.53728 259.29728 778.88512 259.82976 776.23296 259.82976 774.61504 259.82976 770.87744 260.08576 768.0512 261.35552 764.81536 262.41024 761.57952 264.32512 757.67808 265.728 756.1728 266.88512 754.432 269.90592 750.73536 272.31232 748.83072 274.5856 747.49952 276.6848 745.80992 280.00256 744.7552 282.66496 743.13728 285.98272 741.4272 289.76128 740.29056 293.56032 739.13344 297.96352 738.17088 302.1312 737.61792 307.07712 736.9728 312.44288 736.5632 313.83552 736.1024 314.14272 736.1024 314.81856 735.52896 314.81856 734.8736 313.83552 733.5424 310.9888 732.19072 303.872 726.02624 299.08992 722.21696 293.56032 717.37344 287.98976 711.95648 282.19392 705.03424 275.51744 697.23136 273.02912 693.01248 269.73184 688.65024 266.88512 683.61216 264.32512 678.10304 260.87424 672.86016 258.62144 666.88 255.93856 660.91008 253.25568 654.25408 251.31008 647.87456 249.45664 639.98976 248.90368 639.70304 248.34048 639.70304 248.05376 639.13984 247.36768 639.13984 246.24128 639.70304 245.67808 639.98976 244.89984 641.31072 244.62336 642.9184 244.03968 644.352 243.02592 646.73792 239.7696 652.53376 238.08 656.04608 235.39712 659.10784 232.5504 662.79424 229.40672 666.88 226.08896 670.50496 222.18752 674.01728 218.58304 677.31456 214.58944 679.936 210.2272 682.67008 206.0288 684.29824 201.08288 685.53728 196.22912 686.00832 195.75808 686.00832 195.08224 686.00832 193.96608 685.53728 193.08544 683.61216 191.66208 682.67008 189.7984 678.10304 188.63104 675.6352 187.38176 672.09216 186.34752 668.416 185.79456 664.79104 184.25856 656.5376 183.67488 651.6736 183.67488 646.73792 183.67488 635.71968 184.25856 623.81056 185.22112 617.728 186.34752 611.46112 187.38176 604.71296 189.21472 598.43584 191.27296 591.2064 193.39264 584.16128 196.22912 576.91136 198.90176 569.99936 202.5984 562.98496 206.0288 555.37664 210.2272 548.23936 215.16288 540.53888 220.18048 533.61664 225.42336 525.91616 229.79584 520.5504 235.39712 514.4064 241.29536 508.2112 244.03968 505.26208 247.36768 501.94432 252.20096 497.75616 257.16736 493.48608 265.24672 486.2464 271.33952 481.792Z\" p-id=\"9447\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "5dAb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-icons",
  "use": "icon-icons-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icons\"><defs><style type=\"text/css\"></style></defs><path d=\"M871.424 61.44q18.432 0 34.816 6.656t28.672 18.944 19.456 28.672 7.168 35.84l0 720.896q0 38.912-25.088 64.512t-62.976 25.6l-721.92 0q-40.96 0-66.048-26.624t-25.088-66.56l0-718.848q0-35.84 24.576-62.464t65.536-26.624l720.896 0zM633.856 829.44q18.432 0 26.624-8.704t8.192-23.04q0-13.312-8.192-22.528t-26.624-9.216l-62.464 0q1.024-2.048 1.024-6.144l0-507.904 63.488 0q18.432 0 25.6-9.216t7.168-22.528-7.168-22.528-25.6-9.216l-249.856 0q-18.432 0-25.6 9.216t-7.168 22.528 7.168 22.528 25.6 9.216l57.344 0 0 507.904q0 2.048 0.512 3.072t0.512 3.072l-56.32 0q-18.432 0-26.624 9.216t-8.192 22.528q0 14.336 8.192 23.04t26.624 8.704l245.76 0z\" p-id=\"14765\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "6HNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon-svg',
  props: {
    iconClass: {
      type: String,
      required: true
    }
  },
  computed: {
    iconName: function iconName() {
      return '#icon-' + this.iconClass;
    }
  }
});

/***/ }),

/***/ "6PsS":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAACsCAYAAACTkDk+AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo2RjQ2QTQ5MDJGRDYxMUU3QTMzREE2QjI4QjY4NUVENyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo2RjQ2QTQ5MTJGRDYxMUU3QTMzREE2QjI4QjY4NUVENyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjZGNDZBNDhFMkZENjExRTdBMzNEQTZCMjhCNjg1RUQ3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjZGNDZBNDhGMkZENjExRTdBMzNEQTZCMjhCNjg1RUQ3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+JirVnAAAEOlJREFUeNrsXV1sJMdx7u6Z/eX/8XhHSj6eeDxHPxfLPsGyE0Sxz35IbMBIlLxEcAJEseA85CFwAgRIXmLZkB+Sh0QOAgQwHFgw4JcAgWU7QCw/2DoYgbOgI1oSaCl3ou5MkeLmyOXt7+zOzkxXenaJRNNVw8yKR+d4VwUMBigWu3rmG3Z9rK7uloLlf2R5fq5ublOWes1cF2zbp/78/Npjn5yz9Y2P3P/t6aPom2J4jocwUAwUCwN1F4p7l5KGS+Z2ydafedh5VSqRe6fOcUUvCkXFtn1lpdb76UuNhF4p0WWgbq3EIH3eVn7sD/OtqdNyIgvr+8fP1te8OiDWx0MfxygWBoqFgWLWd2exu8WYoNn67mL51Z2Pn27Z+i9ecT19VSZ001ea0ex3q8g2X5Z/Y27ft9SagXr3I4aduxMgZS6Yyk2k/E5CH4bCARDI1u/A3np15zoPfSwMFAPFwmTiXUrMDFZRjHKER+mnVm+CjCDBJnKNcNfc3iDa3magbp2AuS4i9KJB7g7pT/5wpyUwcbhsSMOv8dDHwkAxUCwMFMvdSSaq5vqYrczv+b+x9A9vnLT1Oq/+Qvl6x1LXGagjFsPWeub2oq1fFoMZ3mXiV1Z+nmkhHvo4RrEwUCx3Voxanp9bMLcPEz+KsxCS+BCpOaLQXJcJfY+BunUSg/RNQh/n7uy0UDzhR807fdmQhks89LEwUAwUCwPFcniRtwmTe9LcniR+1DbXeIKuTeWaex+aPWcbniwGe9Pj+kSCBmoRSSUc29Z/pXfNX+tSJCMwV87S/cQQj88x6xvKfeb6KKGPZ1EXEl9WAGuthyZRLfjMTLBanAwuZGF9/St+O4Xip7FEHvpYGCgGiuUOj1GGNMSB/X22Pio7Y8rXqKoHlGxIDbZtTxAVQDkp+mMu2Hp/n5AkleMy7LsStSGl8AGS9k5e+KbfHyAe55ohGY07Eqj9QI3KtPy5YmX78XsXUn7H1u8ROjFfCqsPTQULmcjBZ8Y2zLWQhUxs/rC39/JXm6uE7W+Z63ke+lgYKAaKhYG62+XIUkiGKf2xuT2SYHGOzDfeP30ekYn5YrP93olJlK440Q8nCjpBeMJIeq4DZdt2cSzqLE8GY9bDwT1FDz1j3h1vnpu4B/kLQENOqoT9+tWW96/f2UL+qi/5r3k3IrDUnmGCf3TcWN/HzfWbiRdnnqv2q3OUbVwL/iiiiAW9PZ7XNjsjtxMo5zSaODRvsVVQGrG+SRcqM4XCo1lY3y8+6K5dH28gf1s/6pWJfsR0/UiA4qGPYxQLA3UXyqFjlCENxTgxYOshp6QMdYsgL0A0A/vxIamEQQrI1kek7bDaqGU581K6TfoThD0AkP5UQUbGQct6uo55H/cR7dYNyaj/vwJl5JfM9QNbufehE6v1D57IOrcjBZHqkXKQd7P1Dmk7HB0mbDQEPb8kRfq800SyD5L0t/T5086urxL6qBaK2peq14g2v2Cup3no4xjFwkCxMFB3ooyUQjKM5i/NLVHpE064he69ZbTCvHVh0uu+p1y2nDkPnPIj27YfyXbegXFb/wtTQTRd1IkqolCLnqtEEbEiCd6YC5Y/gKVyB6eQnHy76BTG8VerQAudsHdkrlfOzyJ/tb7uutItJZ65HoivPvsmem9RLfrP4Lp/k3ilXzRscO8oWN9nzHU28XC+Xr/x6/PUojAqpSOmSxHVbpxCQlVBJ0vRtnn5mVJItD9JVyFF/Yq5MlUh5ZS7tjR1Bvk7XcL9gMlia/J3MdOtfyXeqoKsenpWDCdCeejjGMXCQLEwUMdW3FsAbBrYzgjtkrZAs9JR/MkR+yaJPhza3/RTs46hj0hf+1L1lWUxZ5OPbxkm+Phh/6J0Rt2AlY7QbpTy1uCQ/mDEvgHRh8P7c2R02L8oHvo4RrEwUEwmhrI8Pxf/h4/WK/nzxTfNKHzjnbpgMudT/11PlXRnphiuWCO+Q43tBQfap4p6BXVODhaWbVrqeHJvheh2x9bHMa7WL6AoXnSi9pgTrqTEGGkpvM322ys47LheBMk2IhBwZixC/mq+anuhRG1ARIa0G6Owvhikv7WVO5dObfuni3ZKZ10Q+wpNFaPVhcnwYpavpaigMl+MqKogtJBNjJRCEq1GiLfN7oOqGKAyVSGFOly74e1Q/qh+tOaL48hfTkLlzbaL/OlGRKW43uahj2MUCwPFwkAde9a3z37wirwImilsa5tooU/oD9pECrXxxORWc8H1k4Yge65EKwvF1xtn+rUol2nFoRRA+kux76XYdm09pPjbZ7q4DSV9QxXbRLuZgZIE24qL/AWh9yhb00KV1NOyQdnGIC3muplWHCoBlD9y4hCE3EjpG2W/l2KL9DJ9+wPanwbKvsRDH8coFgaKZRij9vchSv7nPpM/I4E4fCSnYoJQTcZD6C5MhIhkzJWi5kIpstsgU0hxnNvuOsifp7G//WCNbO/LeU1bb1iLrkV59DFGIL16kF/FsV1rDSphX3RUe77kIltXOe1QJ59PA+jpoE/4czsLJYnauHlvTmsfEvbSlf1lgTGJycTXECB5tfLWE4sXs6R0pBTrizMBSiG9pxytGqAypZAagapcabrIFjRkTiF9emoLpZAMSK1ndt+LU0haVfZ0/mIWMjEp82u/f+GjmVJIDb/Tem7te8hfXuqKIxXyt/dnp1p+lDz31/t+S7T/pfE1Hvo4RrEwUCwM1HFKIa0TGQif0u+ni7wkUxocMrKekmJZz5RCGqabUBt9UMjfPutDtn+6cb675pUT+ryC4K/PXrN3tBQveif9K/0x1MbvnH8wmC4UE/YFx2mnPB/SG9ZH7aAZC/k+JbHjpiFQ1HsbAIUYm4xgT9CHjCAWpoGeODTSTNELIt20S9katkSxvh5l+3Y/3+xoJ6HvatF6sNBGLOyl3hTp7/7p2dZssTSRxR+lV1KmpZBIf0CwTKkk+d546OMYxcJAMZnYHzuV7GUlEzKFTIAA77BkIgCZmUwUlEZBWEkIXvPHUXDXKucXHRe1sVprBGNuN2Ffdp32+2enMpEJAE2SCZD086WQCS87mdDZyQSkkAkp5KHJRE5CZjLha4X8hSBbX6mfRcH9gZnZ3b965BHUxmPfvtzS1jm8s4V87zuf+OVMZEJKRZIJCUwmOEaxMFAsDNSdzfrwBKErycm5OKsjrIk8Rw5SRc2UzESmiUNDSDzKXx+yTxxeOtls7kHemsgTuhaU0Mf4VrvpPfMf/4bayCsBvShZe15ynbR3gfQRaOr4PrHPXFcJ1odr3YeVXqsUUGhCS4awQukp1help5BWU9rApE8Oti+4mDGFRE4cjuVgNdBoorJVCzAL6wRBxVx4olLkDAtLTuR1wyit1h3pnRTWJwT9fCTrcyT53njo4xjFwkDdpWSCOLxEpJX8NoiASJY0gyBLmskdMCGlpDkUqpGSEUC2SgLyd0CJMelPArZ3h+m07Sz9iAT4vlbIX0+rqBPiQ1s6feX3IpmwDwLyvQ2AWsAppMEqv0yHmkBKSbMU2UuaZUrJrztMC2YqadYgkb9RS4xBUgvZIHNJM4DT2uqVkb+arzbebLuojVerxVYvTJKX6bZXnSVLtlk4RrEwUAwUy+3L+laIFFJL0FsExGxp00ohkdsXALGdwAEppDblz7Al5E+kbF+Qkxq1ASDTUjqkv/PjIdj7L0kpvKcuv4RsZ4v5Tq3XT+hzSkNBZvcn5cCdtJgn9d4GQD2akkLKtJ1AlDpxOHIKCfkrquwppAAU8mdexEEpHeSv7GL7QAdrP7nZypRCKjjQeng6uz/zISF/hnlyColjFAsDxfK/MYqSzBsPpoENI2ysKFNsNe0vZRNGOJKNFWNbYk/EQZ/tXJixk9T2RhFIN9Qykz/DL5xRgMq88aBI2XhQjrCxIqTYKtpfyiaM8kg2VswpiB450c/aBqzU8ki503HDN3bzmfyBlBEPfRyjWBgoFgbquLG+CmIHwyqkSkoA3bCYTpxC2rUNb/aV141kxWZKS+MhCpZFB9rnxkPk7xt781FBRBtWG10g+uYWVGe8oCv/J8sZStrzUdJNsUV6DakUJbM/w/o8yjYGCh3uoW5BCqkTylVzoVTI0jhutKCgUigA6sdKY3LbtJEphfTwlLf6YKF30RouDkohZTpERaTvuIn0Sqb4k9n9GdbHKSSOUSwMFAsDdexY3xJKm9T7v7f8d1cesPWbTyz6/qli4pDgSMvgRz8rowOF75vpw8JkiA5MXqnlETcyzDHeAhy18dBU4I8N54jeyawiJbHtlleAf3qrbB9g7AHBxNL8qXifLFsnzSMStqaNiGjDM+8C/zVI+oDmc39/1ZMWVQRXvWVuv42AWq/uXLeVy/NzbZK9AHmAcY6y1cOZy0wHJpsHTrNF/sxDkwcYw2By1NIP38FEVn/7IE1YH4aT0oaT0mfcboq/AUjWCkcZaKAw4aGPYxQLA3WXkglK4gkYXDUTAnWoCVmFJCB7FZJIqdLRII0/yFSFJOmqp5GqkFLs0w5tQXoTctL8kZVF4ErzhGDbj3SISp5KIZmGqaogeiGbzF6FJFKqdJTMvgMm0FVPI1UhHVkKKcWf+fD5EBWOUSwMFAsDdceyvm+Y60Vbec8/bz5npzzCMbez8QdLaIXcZt3tb9bRoSbqw4te5kNUXm/mmqgka7jDAF5xKIBaqTfSikPKvh/J3upWCdk6CrqRlpn8nX6hGo5dbaE2dF49pXxt6xuZgVqv7uyY246tX56fm7ZZmNOLyBWH1ArAA2SDbmNwW0i+YUmuADTgZT5EJc0fZW+4857pB+5bRPaD9Ke60YaMAK/KjOA1Kl3EQx/HKBYGiuVAMpEm/26uxJiqc6oz8dNmzzbsLRTbwUx+zRrvnZ22i1JISkFPa7lm62fKUc9VYKen6vtZAVvahD4SdJ15L6UNZB9Bqj+kV4GOxq62kT9DwP7L3C6n9COTyMMibQjGJXP7ga2v/crJ1foHT4ySQkJVOu9b6G2P5/W7PodX3IIqpCCSaz/eLGVKIeUaQWvxuWuUvy8Y0vA0D30co1gYKBYG6k6UW0EmTprbY7Y+mMp9WgXwkJ15EcTEYfv+id3djwzaSUjOgZgVFRM6BfVAy2nb9ux0sDc3Hp7IwvqavrN7ZSeP/O1XFiXsx66169Mv7CB/Oifr5vkSelCi57bDZ4jX9LohE6//POk5EtOBeIHA8wjA4Tl9F7K0kdvrVyhbw7jQxGHMwijbvh7UbF/Iwvq0FhXTDvZH2EdtWHO8ENk6NPtsmPfxPA99HKNYGCiWWyLuEbZ9zVwvEx8Gmo+SADfL1zvo4JDeQqmjCyrTISpiuCX3Og47xKEmgj7UpPyzThBv1ZyIn/X+TeI5YtkSw3ktOyYeL6BMUP2TzMxRzD1d2vA+Yes3n1jc9k8XMx2iYvgrdfgIfahJyglpC9/aatklxnE3zLN8gIc+FgaKgWJhoFhokbdDJ5bn5+JgjQJ2cCL/pOGIk4kMxGy+Xf3UPWhtfcGFpnmYhK2SoDVI9DFO/XivXni5hdJCTjf8uvJ13VJXDZn4LgN1MIDXze3sO3VR2V27/tlzh5o4PPVCtTLxepOaOFzKWhXEQx8LA8VAsRy5uLd5/7rCSsuAGswxUakaTei9A9puHacP93YHqmSTAalTV6MrkXGV+gF6zUMfCwPFQLEwUCx3Fpl41lyJVI/Oq5mF57fQYjFwhCcjtHMkuZ2A6kdXzI1KC9Vv1xchj9uXtTw/97i5fZP40Si1519er+58joc+FgaKgWJhoFgOL/8twABQLgzCG+S8qAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "6o49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("aacO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02591744_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("sQ6K");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("AWug")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02591744"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02591744_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/SidebarItem.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SidebarItem.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-02591744", Component.options)
  } else {
    hotAPI.reload("data-v-02591744", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7eqC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_loading_images_pic_loading_png__ = __webpack_require__("nUw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_loading_images_pic_loading_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_loading_images_pic_loading_png__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'QnImage',
  props: {
    realImg: {
      type: String,
      default: ''
    },
    loadingImg: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_0__assets_loading_images_pic_loading_png___default.a
    }
  },
  data: function data() {
    return {
      previewImg: ''
    };
  },

  watch: {
    realImg: function realImg(val) {
      this.proxySetSrc(val);
    }
  },
  created: function created() {
    if (this.realImg) {
      this.proxySetSrc(this.realImg);
    } else {
      this.setSrc(this.loadingImg);
    }
  },

  methods: {
    setSrc: function setSrc(url) {
      this.previewImg = url;
    },
    proxySetSrc: function proxySetSrc(url) {
      var _this = this;

      this.setSrc(this.loadingImg);
      var img = document.createElement('img');
      img.onload = function () {
        _this.setSrc(url);
      };
      img.src = url;
    }
  }
});

/***/ }),

/***/ "8CfS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-input', _vm._g(_vm._b({
    attrs: {
      "icon": _vm.value.toString().length ? _vm.closeIcon : _vm.$attrs.icon,
      "value": _vm.value,
      "on-icon-click": _vm.clearValue
    },
    on: {
      "input": function (e) { return _vm.$emit('input', e); }
    }
  }, 'el-input', _vm.$attrs, false), _vm.$listeners), [_vm._l((Object.keys(this.$slots)), function(name) {
    return _vm._t(name, null, {
      slot: name
    })
  })], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-71e0d390", esExports)
  }
}

/***/ }),

/***/ "8x+Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2eaa0f2f", esExports)
  }
}

/***/ }),

/***/ "90Fk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.svg": "sEM+",
	"./EXCEL.svg": "BMOy",
	"./QQ.svg": "5SbU",
	"./a.svg": "GUmw",
	"./agent.svg": "Liw6",
	"./b.svg": "9kJb",
	"./bug.svg": "SVqS",
	"./c.svg": "PloX",
	"./description.svg": "rn/p",
	"./email.svg": "+4G4",
	"./from.svg": "41Of",
	"./helpCenter.svg": "OQVf",
	"./icons.svg": "5dAb",
	"./lease.svg": "fK1T",
	"./mima.svg": "+D4M",
	"./quanxian.svg": "mwRM",
	"./shouce.svg": "1wdh",
	"./store.svg": "Lta+",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./tubiao.svg": "nQME",
	"./tuozhuai.svg": "I8fT",
	"./weixin.svg": "E+Kt",
	"./wujiaoxing.svg": "sHk8",
	"./xinrenzhinan.svg": "13E8",
	"./yanjing.svg": "tAWD",
	"./yonghuming.svg": "vXUM",
	"./zonghe.svg": "oglU",
	"./zujian.svg": "ILQa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";

/***/ }),

/***/ "9kJb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-b",
  "use": "icon-b-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-b\"><defs><style type=\"text/css\"></style></defs><path d=\"M712.347826 0h44.521739v979.478261h-44.521739zM267.130435 534.26087h44.521739v445.217391H267.130435zM489.73913 311.652174h44.52174v667.826087h-44.52174zM44.521739 712.347826h44.521739v267.130435H44.521739zM934.956522 445.217391h44.521739v534.26087h-44.521739z\" fill=\"\" p-id=\"8895\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "A66B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (file) {
  return function () {
    return __webpack_require__("Opzk")("./" + file + '.vue');
  };
};

/***/ }),

/***/ "AWug":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("JuFU");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("22f91606", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-02591744\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarItem.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-02591744\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarItem.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "AkUR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__("aret");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29d0b9f6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__("izhu");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("gQzw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29d0b9f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29d0b9f6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/Layout.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Layout.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-29d0b9f6", Component.options)
  } else {
    hotAPI.reload("data-v-29d0b9f6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BMOy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-EXCEL",
  "use": "icon-EXCEL-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-EXCEL\"><defs><style type=\"text/css\"></style></defs><path d=\"M625.664 132.608V199.68h309.76v43.008h-309.76V312.32h309.76v43.008h-309.76v68.608h309.76v43.008h-309.76v68.608h309.76v43.008h-309.76v68.608h309.76v43.008h-309.76v68.096h309.76v43.008h-309.76v89.088H1024v-757.76h-398.336zM0 914.944L577.024 1024V0L0 109.056\" p-id=\"10098\" /><path d=\"M229.376 660.48H139.776l118.272-187.904-112.64-180.736h92.16l65.536 119.808L370.688 291.84h89.088l-112.64 177.664L466.944 660.48H373.248l-70.144-125.44L229.376 660.48z\" p-id=\"10099\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Cjjf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("effA");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("772dcf91", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-87a99cd0\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-87a99cd0\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "D5KH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-view-container"
  }, _vm._l((Array.from(_vm.visitedViews)), function(tag) {
    return _c('router-link', {
      key: tag.path,
      staticClass: "tabs-view",
      attrs: {
        "to": tag.path
      }
    }, [_c('el-tag', {
      attrs: {
        "closable": true,
        "type": _vm.isActive(tag.path) ? 'primary' : ''
      },
      on: {
        "close": function($event) {
          _vm.closeViewTabs(tag, $event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tag.name) + "\n    ")])], 1)
  }))
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b93f3c44", esExports)
  }
}

/***/ }),

/***/ "DOpt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("1BzD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc943de_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("bFqg");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Vk+A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bc943de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc943de_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/Sidebar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Sidebar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2bc943de", Component.options)
  } else {
    hotAPI.reload("data-v-2bc943de", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DfDl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var service = 'http://api2.dev.qnbar.cn/';
var api = {
    login: service + "zyu/oss/admin/login", //登录
    addstoreinfo: service + "bz-oss/oss/mix-agent/create-agent", //增加门店 
    editstoreinfo: service + "bz-oss/oss/mix-agent/update-agent", //编辑门店
    getstorelist: service + "bz-oss/oss/mix-agent/get-list", //门店列表信息
    changepass: service + "bz-oss/oss/change/pwd", //oss修改密码
    getprovincelist: service + "common/oss/region/get-province", //省份列表
    getcitylist: service + "common/oss/region/get-city" //市区列表 
};
/* harmony default export */ __webpack_exports__["a"] = ({
    api: api
});

/***/ }),

/***/ "E+Kt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-weixin",
  "use": "icon-weixin-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-weixin\"><defs><style type=\"text/css\"></style></defs><path d=\"M669.029188 317.395814c10.181291 0 20.235686 0.748037 30.23789 1.865487C672.100256 192.728466 536.831031 98.730629 382.414962 98.730629c-172.618362 0-314.03484 117.659747-314.03484 267.066545 0 86.2422 47.044337 157.061129 125.674313 211.988112l-31.406554 94.467535 109.75511-55.05285c39.302708 7.78122 70.80955 15.765055 110.010947 15.765055 9.849726 0 19.624747-0.481977 29.323017-1.243317-6.144182-20.996197-9.69827-42.982954-9.69827-65.792449C402.040732 428.732551 519.845498 317.395814 669.029188 317.395814zM500.167537 232.256738c23.639342 0 39.302708 15.550161 39.302708 39.185464 0 23.536043-15.66439 39.300075-39.302708 39.300075-23.535984 0-47.146672-15.765055-47.146672-39.300075C453.021889 247.806899 476.632577 232.256738 500.167537 232.256738zM280.402504 310.7433c-23.537007 0-47.300174-15.765055-47.300174-39.300075 0-23.635303 23.76419-39.185464 47.300174-39.185464 23.53496 0 39.200373 15.550161 39.200373 39.185464C319.602877 294.978245 303.937464 310.7433 280.402504 310.7433z\" p-id=\"9338\" /><path d=\"M955.617831 562.14712c0-125.543298-125.622123-227.882104-266.733643-227.882104-149.41292 0-267.090791 102.338806-267.090791 227.882104 0 125.770472 117.677871 227.879034 267.090791 227.879034 31.278636 0 62.837668-7.896854 94.243199-15.765055l86.119862 47.170323-23.612735-78.473259C908.675829 695.672206 955.617831 632.965026 955.617831 562.14712zM602.306891 522.858302c-15.638806 0-31.431114-15.549138-31.431114-31.416524 0-15.651468 15.792308-31.405267 31.431114-31.405267 23.73963 0 39.302708 15.754822 39.302708 31.405267C641.609599 507.309164 626.04652 522.858302 602.306891 522.858302zM775.027587 522.858302c-15.538518 0-31.201884-15.549138-31.201884-31.416524 0-15.651468 15.66439-31.405267 31.201884-31.405267 23.535984 0 39.300661 15.754822 39.300661 31.405267C814.329272 507.309164 798.563571 522.858302 775.027587 522.858302z\" p-id=\"9339\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "GUmw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-a",
  "use": "icon-a-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-a\"><defs><style type=\"text/css\"></style></defs><path d=\"M44.521739 0h44.521739v979.478261H44.521739zM267.130435 534.26087h44.521739v445.217391H267.130435zM489.73913 311.652174h44.52174v667.826087h-44.52174zM712.347826 712.347826h44.521739v267.130435h-44.521739zM934.956522 445.217391h44.521739v534.26087h-44.521739z\" fill=\"\" p-id=\"8555\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Hana":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Levelbar__ = __webpack_require__("N2mp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Hamburger__ = __webpack_require__("dahE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TabsView__ = __webpack_require__("jSdT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Screenfull__ = __webpack_require__("k0sJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_js__ = __webpack_require__("DfDl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__env_js__ = __webpack_require__("yZtZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svrapi_js__ = __webpack_require__("Mp/4");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 //获取vuex数据
 //面包屑导航
 //隐藏侧边栏
 //历史打开页面保存
 //全屏

// 请求参数设置



var PT = __WEBPACK_IMPORTED_MODULE_7__env_js__["a" /* default */].PT;

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Levelbar: __WEBPACK_IMPORTED_MODULE_2__Levelbar__["default"],
        Hamburger: __WEBPACK_IMPORTED_MODULE_3__components_Hamburger__["a" /* default */],
        Screenfull: __WEBPACK_IMPORTED_MODULE_5__components_Screenfull__["a" /* default */],
        TabsView: __WEBPACK_IMPORTED_MODULE_4__TabsView__["default"]
    },
    data: function data() {
        var _this = this;

        var validatePass = function validatePass(rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (_this.ruleForm2.checkPass !== '') {
                    _this.$refs.ruleForm2.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = function validatePass2(rule, value, callback) {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== _this.ruleForm2.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            user_title: "",
            photoUrl: "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80",
            showDialog: false,
            ruleForm2: {
                pass: '',
                checkPass: ''
            },
            rules2: {
                pass: [{ validator: validatePass, trigger: 'blur' }],
                checkPass: [{ validator: validatePass2, trigger: 'blur' }]
            }
        };
    },
    mounted: function mounted() {
        var self = this;
        eventBus.$on('user_title', function (val) {
            self.user_title = val;
        });
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['sidebar', 'avatar', 'navbarData', 'permissions']), {
        islocal_user: function islocal_user() {
            return Array.isArray(this.permissions) && this.permissions.includes('local_user_base_module');
        }
    }),
    methods: {
        toggleSideBar: function toggleSideBar() {
            this.$store.dispatch('ToggleSideBar');
        },
        handleOnLogout: function handleOnLogout(rsp) {
            window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl);
        },

        // 退出登录
        runLogout: function runLogout() {
            var postParams = {
                local_sess: PT.qnlogin.getLocalSess()
            };
            PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_8__svrapi_js__["a" /* default */].logout, postParams, this.handleOnLogout);
            PT.qnlogin.logout();

            this.hasLogin = PT.qnlogin.isLocalSessOk;
            localStorage.removeItem("user_all");
            localStorage.removeItem("user_data");
        },
        submitForm: function submitForm(formName) {
            var self = this;
            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    var userType = self.$store.state.user.user_type;
                    if (userType === 'agent_staff') {
                        // 员工修改密码
                        var data = {
                            guid: self.$store.state.user.guid,
                            new_pwd: self.ruleForm2.pass
                        };
                        PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_8__svrapi_js__["a" /* default */].modifyPass, data, function (rsp) {
                            if (rsp.code == 0) {
                                self.$alert("密码修改成功", '提示');
                                self.runLogout();
                            } else {
                                self.$alert(rsp.msg, '提示');
                            }
                        });
                    } else {
                        // 老板修改密码
                        var data = {
                            guid: 1,
                            new_pwd: self.ruleForm2.pass,
                            repeat_new_pwd: self.ruleForm2.checkPass
                        };
                        PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_8__svrapi_js__["a" /* default */].Modifypassword, data, function (rsp) {
                            if (rsp.code == 0) {
                                self.$alert("密码修改成功", '提示');
                                self.runLogout();
                            } else {
                                self.$alert(rsp.msg, '提示');
                            }
                        });
                    }
                } else {
                    alert('error submit!');
                    return false;
                }
            });
        },
        resetForm: function resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        changePSW: function changePSW() {
            this.showDialog = true;
        }
    }
});

/***/ }),

/***/ "Hg9M":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("WmEM");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0dbd5125", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-27592aaa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Levelbar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-27592aaa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Levelbar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "I8fT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tuozhuai",
  "use": "icon-tuozhuai-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tuozhuai\"><defs><style type=\"text/css\"></style></defs><path d=\"M574.957891 267.016403 511.503696 267.016403l204.64896 0L511.212054 63.654762l-203.361641 203.361641L449.041086 267.016403l0 189.662641L258.687714 456.679044l0 125.916804L449.041086 582.595848l0 190.354396 125.916804 0L574.957891 582.595848l188.874695 0L763.832586 456.679044 574.957891 456.679044 574.957891 267.016403zM511.25401 960.345238l189.620685-187.394994L323.125305 772.950244 511.25401 960.345238zM71.291696 518.891967l187.394994 189.620685L258.68669 330.762239 71.291696 518.891967zM763.832586 330.762239l0 377.74939 188.874695-189.620685L763.832586 330.762239z\" p-id=\"9008\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "ILQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-zujian",
  "use": "icon-zujian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zujian\"><defs><style type=\"text/css\"></style></defs><path d=\"M568.6 0h454.9v454.9H568.6V0z m0 568.6h454.9v454.9H568.6V568.6zM0 568.6h454.9v454.9H0V568.6zM0 0h454.9v454.9H0V0z\" fill=\"\" p-id=\"10531\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__("bREw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("UjVw");






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_2__modules_app__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */]
  },
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "IqSV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3e5d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("44ec10db", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6bce3e2a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Navbar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6bce3e2a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Navbar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "JdRO":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in\n *    IE on Windows Phone and in iOS.\n */\n\nhtml {\n  line-height: 1.15; /* 1 */\n  -ms-text-size-adjust: 100%; /* 2 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\n\nbody {\n  margin: 0;\n}\n\n/**\n * Add the correct display in IE 9-.\n */\n\narticle,\naside,\nfooter,\nheader,\nnav,\nsection {\n  display: block;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in IE.\n */\n\nfigcaption,\nfigure,\nmain { /* 1 */\n  display: block;\n}\n\n/**\n * Add the correct margin in IE 8.\n */\n\nfigure {\n  margin: 1em 40px;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\n\na {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}\n\n/**\n * 1. Remove the bottom border in Chrome 57- and Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\n\nb,\nstrong {\n  font-weight: inherit;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font style in Android 4.3-.\n */\n\ndfn {\n  font-style: italic;\n}\n\n/**\n * Add the correct background and color in IE 9-.\n */\n\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\naudio,\nvideo {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in iOS 4-7.\n */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Remove the border on images inside links in IE 10-.\n */\n\nimg {\n  border-style: none;\n}\n\n/**\n * Hide the overflow in IE.\n */\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: sans-serif; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\nhtml [type=\"button\"], /* 1 */\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Correct the padding in Firefox.\n */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * 1. Add the correct display in IE 9-.\n * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  display: inline-block; /* 1 */\n  vertical-align: baseline; /* 2 */\n}\n\n/**\n * Remove the default vertical scrollbar in IE.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n */\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n */\n\ndetails, /* 1 */\nmenu {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n  display: list-item;\n}\n\n/* Scripting\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\ncanvas {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in IE.\n */\n\ntemplate {\n  display: none;\n}\n\n/* Hidden\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10-.\n */\n\n[hidden] {\n  display: none;\n}\n", ""]);

// exports


/***/ }),

/***/ "JuFU":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.svg-icon[data-v-02591744] {\n  margin-right: 10px;\n}\n.hideSidebar .menu-indent[data-v-02591744] {\n  display: block;\n  text-indent: 10px;\n}\n", ""]);

// exports


/***/ }),

/***/ "Jysk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tab",
  "use": "icon-tab-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tab\"><defs><style type=\"text/css\"></style></defs><path d=\"M896 320H128V160c0-17.6 14.4-32 32-32h704c17.6 0 32 14.4 32 32v160zM320 896H160c-17.6 0-32-14.4-32-32V384h192v512zM864 896H384V384h512v480c0 17.6-14.4 32-32 32z\" p-id=\"8213\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Liw6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-agent",
  "use": "icon-agent-usage",
  "viewBox": "0 0 1230 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1230 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-agent\"><defs><style type=\"text/css\"></style></defs><path d=\"M821.128 972.82l-0.467-4.741c0-2.485 0.185-4.926 0.523-7.318a375.941 375.941 0 0 0-0.326-7.656l-0.074-1.414a344.144 344.144 0 0 0-0.486-7.324l-0.123-1.519a369.601 369.601 0 0 0-0.664-7.434l-0.006-0.08m0.677 7.514a369.601 369.601 0 0 0-0.67-7.434m-0.868-7.662l-0.16-1.292a349.8 349.8 0 0 0-0.971-7.071l-0.246-1.667a338.457 338.457 0 0 0-1.15-7.139l-0.03-0.172-0.075-0.418c-0.4-2.282-0.824-4.55-1.266-6.826l-0.29-1.494a374.527 374.527 0 0 0-1.438-6.894l-0.37-1.623a362.798 362.798 0 0 0-1.604-6.9l-0.21-0.811a342.606 342.606 0 0 0-1.641-6.37l-0.412-1.538a321.886 321.886 0 0 0-1.82-6.445l-0.59-1.986a359.388 359.388 0 0 0-1.95-6.327l-0.492-1.513a356.085 356.085 0 0 0-1.802-5.411l-0.658-1.925a328.414 328.414 0 0 0-2.152-5.977l-0.86-2.319a352.138 352.138 0 0 0-1.993-5.171l-1.046-2.607a374.964 374.964 0 0 0-1.875-4.575l-0.935-2.22a370.524 370.524 0 0 0-2.41-5.492l-1.101-2.435a359.037 359.037 0 0 0-2.367-5.091l-1.193-2.466a331.416 331.416 0 0 0-2.067-4.194l-1.168-2.324a364.614 364.614 0 0 0-2.669-5.117l-1.451-2.693a367.75 367.75 0 0 0-4.188-7.502l-1.814-3.13c-0.615-1.045-1.23-2.09-1.857-3.136a364.596 364.596 0 0 0-9.168-14.463l-1.722-2.546a330.824 330.824 0 0 0-3.1-4.483l-1.801-2.558-2.19-3.025-1.967-2.65a372.276 372.276 0 0 0-3.296-4.354l-1.697-2.196a380.516 380.516 0 0 0-3.837-4.82l-1.495-1.845c-0.867-1.046-1.74-2.103-2.62-3.149l-1.432-1.69a350.705 350.705 0 0 0-4.335-5.006l-1.433-1.612a334.474 334.474 0 0 0-4.673-5.128l-1.28-1.377a355.163 355.163 0 0 0-2.89-3.05l-0.996-1.027a359.67 359.67 0 0 0-5.227-5.295l-1.402-1.377a332.607 332.607 0 0 0-5.417-5.209l-0.88-0.824a352.408 352.408 0 0 0-3.216-2.97l-0.922-0.836a328.707 328.707 0 0 0-5.793-5.135l-1.205-1.039a355.858 355.858 0 0 0-5.952-5.006l-0.935-0.774a369.737 369.737 0 0 0-3.505-2.829c-53.64-42.744-119.806-70.452-192.103-76.7a311.005 311.005 0 0 1-47.288 1.169l-0.24-0.013h-0.098l-0.142-0.012-0.246-0.012h-0.104l-0.135-0.013-0.246-0.012-0.105-0.006-0.135-0.006-0.246-0.019h-0.11l-0.124-0.012-0.246-0.012-0.123-0.006-0.123-0.013-0.24-0.012-0.123-0.006-0.123-0.006-0.24-0.019-0.122-0.006-0.117-0.006-0.246-0.012-0.123-0.013-0.117-0.006-0.24-0.012-0.135-0.012-0.105-0.007-0.246-0.018-0.135-0.006-0.104-0.006-0.246-0.019-0.142-0.012h-0.098l-0.24-0.018-0.148-0.013-0.092-0.006-0.246-0.018-0.147-0.013h-0.086l-0.246-0.018-0.16-0.012-0.08-0.007-0.246-0.018-0.154-0.012h-0.08l-0.246-0.025-0.166-0.012h-0.074l-0.24-0.025-0.172-0.012h-0.067l-0.246-0.025-0.172-0.012-0.062-0.006-0.246-0.019-0.178-0.012-0.062-0.006-0.24-0.025-0.184-0.012h-0.055l-0.246-0.025-0.185-0.012-0.049-0.006-0.246-0.025-0.184-0.012h-0.056l-0.234-0.03-0.202-0.02h-0.043l-0.234-0.024-0.21-0.018h-0.036l-0.24-0.025-0.203-0.018h-0.037l-0.24-0.025-0.209-0.018h-0.03l-0.24-0.025-0.215-0.018h-0.025l-0.24-0.025-0.221-0.018h-0.019l-0.24-0.031-0.22-0.018h-0.02l-0.24-0.025-0.227-0.025h-0.006l-0.246-0.024-0.233-0.019-0.246-0.03-0.234-0.019C247.599 630.386 103.583 784.357 103.583 972.02v0.185h-0.99l0.062 0.615a51.088 51.088 0 0 1-102.183 0l-0.46-4.741c0-4.047 0.473-7.982 1.358-11.745 0.086-2.755 0.203-5.498 0.332-8.24l0.19-3.266c0.1-1.703 0.185-3.413 0.308-5.116 0.062-1.04 0.154-2.078 0.234-3.111 0.123-1.673 0.246-3.34 0.381-5.006l0.381-4.09c0.123-1.352 0.246-2.705 0.388-4.058 0.141-1.359 0.295-2.712 0.449-4.07l0.467-4.114 0.474-3.696c0.196-1.513 0.387-3.026 0.602-4.538 0.166-1.2 0.345-2.386 0.523-3.585 0.209-1.433 0.418-2.866 0.646-4.299 0.209-1.346 0.43-2.687 0.658-4.034 0.22-1.322 0.436-2.65 0.676-3.972a446.96 446.96 0 0 1 1.476-8.006l0.732-3.69c0.295-1.451 0.59-2.908 0.897-4.354a469.656 469.656 0 0 1 1.71-7.73l0.873-3.707c0.338-1.402 0.676-2.81 1.027-4.206l0.94-3.714 1.015-3.862 1.077-3.936 1.063-3.788 1.126-3.868 1.137-3.787 1.181-3.825c0.4-1.255 0.8-2.515 1.211-3.77l1.267-3.855a411.312 411.312 0 0 1 2.57-7.478l1.28-3.56 1.457-3.985 1.205-3.173 1.667-4.31 1.168-2.922c0.578-1.432 1.15-2.859 1.74-4.286l1.316-3.123c0.59-1.403 1.175-2.798 1.783-4.194l1.236-2.804c0.646-1.47 1.292-2.934 1.956-4.39l1.082-2.338c0.75-1.63 1.5-3.259 2.275-4.876l0.941-1.955a449.496 449.496 0 0 1 2.38-4.895c0.523-1.052 1.058-2.091 1.587-3.136 0.658-1.31 1.31-2.62 1.986-3.918l0.467-0.891A459.983 459.983 0 0 1 71.115 726.99l0.455-0.738a450.89 450.89 0 0 1 3.167-4.944l1.095-1.698c1.088-1.666 2.189-3.32 3.296-4.968l0.91-1.353a423.045 423.045 0 0 1 3.443-5.012l0.96-1.383a347.732 347.732 0 0 1 3.474-4.87l1.008-1.396a362.6 362.6 0 0 1 3.432-4.655l1.217-1.636c1.132-1.5 2.263-2.982 3.413-4.464l1.28-1.66a409.084 409.084 0 0 1 3.566-4.508l1.156-1.445a448.613 448.613 0 0 1 3.8-4.655l1.04-1.248a343.591 343.591 0 0 1 3.86-4.563l1.157-1.353a346.347 346.347 0 0 1 3.954-4.52l1.033-1.168a427.432 427.432 0 0 1 4.175-4.612l0.954-1.045a420.343 420.343 0 0 1 4.236-4.539l1.021-1.076c1.458-1.525 2.921-3.05 4.403-4.55l0.812-0.83c1.525-1.556 3.062-3.1 4.612-4.63l0.738-0.726a725.34 725.34 0 0 1 4.944-4.797l0.172-0.16a461.484 461.484 0 0 1 115.674-80.641l0.061-0.025 0.05-0.024 0.055-0.031 0.049-0.025 0.061-0.024 0.05-0.025 0.055-0.03 0.055-0.025 0.05-0.025 0.06-0.024 0.05-0.025 1.291-0.627 0.062-0.025 0.05-0.03 0.054-0.025 0.271-0.13 0.055-0.024 0.05-0.024 0.061-0.031 0.05-0.025 0.055-0.024 0.049-0.025 0.061-0.025 0.05-0.03 0.055-0.025 0.055-0.025 0.05-0.024 0.06-0.025 0.05-0.03 0.055-0.025 0.056-0.025 0.049-0.024 0.061-0.031 0.05-0.025 0.055-0.024 0.055-0.025 0.05-0.024a520.424 520.424 0 0 1 9.9-4.619c-72.125-56.376-118.497-144.187-118.497-242.834C154.438 137.928 292.353 0 462.473 0c170.131 0 308.04 137.928 308.04 308.041 0 62.262-18.478 120.206-50.239 168.65l-0.178-0.142a53.179 53.179 0 0 1-95.412-32.302c0-22.936 16.898-36.557 25.384-56.376a204.186 204.186 0 0 0 16.431-80.518c0-113.172-91.747-204.906-204.912-204.906S256.669 194.18 256.669 307.353c0 105.62 79.916 192.551 182.572 203.688 2.435-0.117 4.87-0.216 7.311-0.295v0.202c5.012-0.16 10.048-0.245 15.109-0.245 97.238 0 187.46 30.063 261.91 81.379v-0.043a466.85 466.85 0 0 1 12.249 8.787l1.31 0.966 2.084 1.555c1.599 1.206 3.185 2.442 4.772 3.665l0.43 0.338c1.009 0.775 1.999 1.569 2.995 2.356l2.048 1.623c1.033 0.83 2.06 1.66 3.087 2.503l1.937 1.58 2.871 2.38 2.147 1.808 2.89 2.472 1.943 1.685 2.908 2.558 1.92 1.71 2.963 2.68 1.74 1.593 2.89 2.687 2.116 1.999 2.46 2.337 2.275 2.22 2.398 2.348 2.152 2.153 2.454 2.472 1.63 1.678c1.014 1.046 2.029 2.091 3.037 3.149l0.35 0.369a464.33 464.33 0 0 1 19.838 22.254l0.916 1.088 2.577 3.137 1.636 2.01 2.305 2.89 1.692 2.14 2.324 3.001 1.617 2.091 2.472 3.29 1.31 1.759c0.812 1.094 1.611 2.189 2.41 3.29l1.544 2.14 2.128 2.982 1.617 2.306 2.177 3.148 1.383 2.036 2.245 3.345 1.353 2.054c0.738 1.119 1.475 2.244 2.195 3.37l1.39 2.176 2.01 3.173 1.556 2.521 1.876 3.057 1.42 2.38c0.64 1.07 1.285 2.14 1.919 3.215l1.15 2.005a471.753 471.753 0 0 1 8.252 14.838l0.006 0.019c0.615 1.144 1.205 2.293 1.802 3.443l1.23 2.368c0.615 1.187 1.211 2.386 1.814 3.585l1.1 2.195 1.642 3.37 1.267 2.62 1.531 3.252 1.23 2.645 1.488 3.277 1.23 2.73 1.414 3.247 1.2 2.786 1.365 3.259 1.193 2.878 1.303 3.228 1.083 2.737 1.346 3.462 1.027 2.724 1.292 3.456 1.02 2.828 1.144 3.21 1.187 3.456 0.953 2.786 1.107 3.394c0.326 0.996 0.658 1.986 0.971 2.989 0.376 1.18 0.738 2.373 1.107 3.566l0.855 2.743c0.332 1.094 0.652 2.201 0.972 3.302l0.953 3.235 0.012 0.055c0.59 2.066 1.168 4.132 1.734 6.21l0.006 0.025a520.886 520.886 0 0 1 1.648 6.272l0.025 0.08 0.78 3.161 0.837 3.382 0.787 3.382 0.714 3.081 0.72 3.308c0.245 1.12 0.491 2.251 0.725 3.376l0.658 3.247c0.221 1.107 0.449 2.214 0.658 3.32l0.608 3.198 0.652 3.567 0.541 3.105 0.585 3.518 0.51 3.191 0.547 3.61 0.455 3.124 0.474 3.492 0.442 3.407 0.406 3.358 0.388 3.333 0.369 3.572 0.338 3.333 0.307 3.395 0.29 3.419 0.276 3.61 0.228 3.227c0.086 1.292 0.16 2.583 0.233 3.875l0.172 3.037c0.087 1.679 0.154 3.364 0.222 5.043l0.074 1.764c0.086 2.337 0.153 4.692 0.203 7.041 0.295 2.214 0.448 4.47 0.448 6.765l0.468 4.747c0 28.219-22.875 51.088-51.094 51.088a51.088 51.088 0 0 1-51.089-51.088v-0.006m-3.861-55.098a345.59 345.59 0 0 0-1.15-7.145m-3.468-17.421a355.796 355.796 0 0 0-1.605-6.9m57.286-399.622l1.2-1.199c61.824-35.278 103.516-101.8 103.516-178.082 0-84.528-51.186-157.096-124.246-188.414-18.312-7.859-36.483-14.13-56.585-14.13a48.548 48.548 0 0 1-48.555-48.53l-0.443-4.508a48.555 48.555 0 0 1 46.489-48.518l2.398-2.398c159.346 11.806 284.957 144.833 284.957 307.18 0 97.023-44.859 183.556-114.954 240.018 0.14 1.728 0.215 3.474 0.233 5.24 154.691 71.903 262.795 227.104 266.602 408.015a51.654 51.654 0 0 1 0.448 6.764l0.462 4.748c0 28.225-22.876 51.088-51.088 51.088a51.088 51.088 0 0 1-51.089-51.088l-0.467-4.741c0-2.515 0.185-4.981 0.535-7.392-3.96-127.615-74.547-238.425-178.113-298.854a359.258 359.258 0 0 0-27.026-14.26c-22.36-13.295-41.692-13.049-62.926-23.933a70.993 70.993 0 0 1-38.672-63.227l-0.652-6.592c0-31.158 20.07-57.618 47.982-67.18h-0.006z\" p-id=\"2289\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Ljt4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__qnapi_js__ = __webpack_require__("1Nx3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__qnlogin_js__ = __webpack_require__("+AaE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__qnpermission_js__ = __webpack_require__("rGfR");




function Platform() {
    var that = this;

    //==================== 全局全站配置，每个站点独立配置一份来统一加载即可 ====================
    this.config = function () {
        this.env = "local"; //local test release
        this.hostBaseUrl = 'http://passport.tt.qnbar.com/'; //当前页面访问环境的host base
        this.platformUsagespace = 'PT_AGENT_BZ'; //平台标记，固定需要，请求要带上 【后端给具体定义】

        //api访问地址相关
        this.apiBaseUrl = 'http://passportapi.tt.qnbar.com/'; //后端服务api 访问基本地址

        //统一登录相关
        this.qnloginBaseUrl = "http://passport.tt.qnbar.com/"; //统一登录服务的基本地址
        this.qnloginPlatformNo = 8; //统一登录中本平台的编号 - 【后端给具体定义】
        this.loginJumpBackUrl = encodeURIComponent(hostBaseUrl + "test_agent.html"); //统一登录成功后无参数的回跳地址，url_encode的

        // websocket消息通知相关
        this.wsHost = "10.10.4.6";
        this.wsPort = "16666";
        this.wsProto = "ws";
    };

    //==================== 固定工具初始化，固定逻辑 ====================
    //初始化qnlogin通用接口对象
    this.qnlogin = null;
    this.apiClient = null;
    this.permissionChecker = null; //全局用的权限检查器

    this.init = function () {
        that.qnlogin = new __WEBPACK_IMPORTED_MODULE_1__qnlogin_js__["a" /* default */].QnLoginClient(that.config.qnloginBaseUrl, that.config.qnloginPlatformNo); //【todo url记得改, 平台编号记得改】
        //后端api请求工具
        that.apiClient = new __WEBPACK_IMPORTED_MODULE_0__qnapi_js__["a" /* default */].Qnapi(that.config.apiBaseUrl, that.config.platformUsagespace, that.qnlogin.getLocalSess);
        that.permissionChecker = new __WEBPACK_IMPORTED_MODULE_2__qnpermission_js__["a" /* default */].PermissionChecker();
    };
}

/* harmony default export */ __webpack_exports__["a"] = ({
    Platform: Platform
});

/***/ }),

/***/ "Lta+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-store",
  "use": "icon-store-usage",
  "viewBox": "0 0 1028 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1028 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-store\"><defs><style type=\"text/css\"></style></defs><path d=\"M1022.8256 187.1856 1022.8256 33.2736C1022.8256 14.9712 1007.9824 0 989.8416 0L36.336 0C18.192 0 3.344 14.9712 3.344 33.2736l0 154.1184c0 1.2208 0.072 2.432 0.2 3.6192C2.272 198.128 1.6 205.4144 1.6 212.808c0 17.8768 3.8208 35.16 11.056 50.9152l0 724.1616c0 18.3024 14.8448 33.272 32.992 33.272l932.5536 0c18.1488 0 32.9904-14.968 32.9904-33.272L1011.192 280.1328c10.4304-18.2016 16-38.9232 16-60.5088C1027.1856 208.5056 1025.6864 197.6192 1022.8256 187.1856L1022.8256 187.1856zM61.5344 161.976 61.5344 58.6896l0 0L964.64 58.6896l0 103.2864M859.784 974.2064 167.4384 974.2064 167.4384 467.1488l692.3456 0L859.784 974.2064 859.784 974.2064zM964.64 974.2064l-58.3024 0L906.3376 453.472c0-18.3024-14.848-33.2736-32.9888-33.2736L153.88 420.1984c-18.144 0-32.992 14.9712-32.992 33.2736l0 520.7344-61.68 0L59.208 316.3296c18.6544 11.5136 40.1392 17.6752 62.5632 17.6752 21.6016 0 42.3472-5.7504 60.4464-16.3872 19.7248 13.608 43.304 21.1808 67.8592 21.1808 32.1024 0 62.2784-12.6064 84.9744-35.5024 6.392-6.44 11.9712-13.4864 16.6992-21.0016 3.992 5.7296 8.5056 11.1568 13.5136 16.2128 22.7024 22.8896 52.8784 35.4976 84.976 35.4976 21.6 0 42.3472-5.7504 60.4432-16.3872 19.7232 13.608 43.3056 21.1808 67.8624 21.1808 32.096 0 62.2768-12.6064 84.9744-35.5024 6.096-6.1424 11.4416-12.8368 16.0272-19.9664 4.1568 6.0992 8.8944 11.856 14.192 17.2 22.696 22.8944 52.8784 35.5024 84.9744 35.5024 21.5968 0 42.3472-5.7584 60.44-16.3936 19.7248 13.616 43.304 21.1824 67.8656 21.1824 20.4672 0 40.1536-5.136 57.6192-14.7856L964.6384 974.2064 964.64 974.2064z\" p-id=\"1862\" /><path d=\"M805.5072 601.3008c0-10.7088-9.6576-19.392-21.5712-19.392L245.0816 581.9088c-11.9136 0-21.5728 8.6832-21.5728 19.392l0 0.4336c0 10.7104 9.6592 19.3936 21.5728 19.3936L783.936 621.128c11.9136 0 21.5712-8.6832 21.5712-19.3936L805.5072 601.3008z\" p-id=\"1863\" /><path d=\"M805.5072 706.4608c0-10.712-9.6576-19.3936-21.5712-19.3936L245.0816 687.0672c-11.9136 0-21.5728 8.6816-21.5728 19.3936l0 0.432c0 10.7088 9.6592 19.392 21.5728 19.392L783.936 726.2848c11.9136 0 21.5712-8.6832 21.5712-19.392L805.5072 706.4608z\" p-id=\"1864\" /><path d=\"M805.2848 818.8704c0-10.7104-9.6592-19.3936-21.5712-19.3936L244.8544 799.4768c-11.912 0-21.5712 8.6832-21.5712 19.3936l0 0.432c0 10.7104 9.6592 19.392 21.5712 19.392L783.712 838.6944c11.912 0 21.5712-8.6816 21.5712-19.392L805.2832 818.8704z\" p-id=\"1865\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87a99cd0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("vT7U");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Cjjf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87a99cd0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-87a99cd0", Component.options)
  } else {
    hotAPI.reload("data-v-87a99cd0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9A7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = login;
/* harmony export (immutable) */ __webpack_exports__["b"] = getInfo;
/* harmony export (immutable) */ __webpack_exports__["c"] = logout;
/* unused harmony export getRolePermissions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__("Vo7i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env__ = __webpack_require__("yZtZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");


function login(username, password) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/user/login',
    method: 'post',
    data: {
      username: username,
      password: password
    }
  });
}




function getInfo() {
  var token = __WEBPACK_IMPORTED_MODULE_1__env__["a" /* default */].PT.qnlogin.getLocalSess();
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* agencyQnbarRequest_noalert */])('getdetail', { local_sess: token });
}

function logout() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/user/logout',
    method: 'post'
  });
}

function getRolePermissions() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* agencyQnbarRequest_noalert */])('getAllPermissions');
}

/***/ }),

/***/ "Mp/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _loginValidateTicket$;

/* eslint-disable no-dupe-keys */
/* harmony default export */ __webpack_exports__["a"] = (_loginValidateTicket$ = {
  // 登录相关
  loginValidateTicket: 'agent/bz/login/validate-ticket',
  logout: 'agent/bz/logout',
  loginUserInfo: 'agent/bz/login/user-info', // 获取已登录用户的详细信息
  getAllPermissions: 'role-permission/role/get-all', // 获取全量权限列表
  getRoleList: 'agent/bz/qnbar-agent/role/list', // 获取角色列表
  getRoleDetail: 'agent/bz/qnbar-agent/role/info', // 获取角色详情
  addRole: 'agent/bz/qnbar-agent/role/add', // 新增角色
  editRole: 'agent/bz/qnbar-agent/role/edit', // 编辑角色
  deleteRole: 'agent/bz/qnbar-agent/role/delete', // 删除角色
  getTreeRolePermission: 'agent/bz/qnbar-agent/role/all/permission', // 获取权限的树形结构
  addPermission: 'agent/bz/permission/create', // 创建权限
  editPermission: 'agent/bz/permission/update', // 编辑权限
  deletePermission: 'agent/bz/permission/del', // 删除权限
  getStaffList: 'agent/bz/qnbar-agent/role/user/list', // 获取用户列表
  addStaff: 'agent/bz/qnbar-agent/role/user/add', // 新增用户
  editStaff: 'agent/bz/qnbar-agent/role/user/edit', // 编辑用户
  delStaff: 'agent/bz/qnbar-agent/role/user/delete', // 删除用户
  modifyPass: 'agent/bz/qnbar-agent/role/user/password/edit', // 修改密码
  editStaffStatus: 'agent/bz/qnbar-agent/role/user/status/edit', // 编辑用户状态（冻结/解冻）
  getCachePermission: 'agent/bz/role-permission/role/cache/get', // 获取缓存权限

  // 平台跳转授权请求
  grantJumpPlatform: 'agent/bz/grant/platform-jump',

  // 合作商
  getdetail: 'agent/bz/qnbar-agent/get-base-info', // 获取自己详情
  getlist: 'agent/bz/mix-agent/get-list', // 商家列表
  getprovincelist: 'common/oss/region/get-province', // 省份列表
  getcitylist: 'common/oss/region/get-city', // 市区列表
  getAreasList: 'common/oss/region/get-areas', // 区县列表
  Modifypassword: 'agent/bz/qnbar-agent/change-pwd', // 修改密码
  getdetailinfo: 'agent/bz/mix-agent/get-info', // 获取详情
  changestatus: 'agent/bz/mix-agent/change-status', // 冻结解冻
  resetpassword: 'agent/bz/mix-agent/reset-pwd', // 重置商家密码
  // 申请门店相关接口
  getRequestList: 'agent/store/checkStoreGet', // 获取建店申请门店列表
  addCheckAgents: 'agent/store/addCheckAgents', // 提交门店申请
  editCheckAgents: 'agent/store/editCheckAgents', // 编辑审核门店
  getAgentByAsn: 'agent/store/checkAgentByAsn', // 获取门店详情
  deleteCloseAgent: 'agent/store/closeCheckAgent', // 撤销关闭提交门店申请
  getLogData: 'agent/store/logGetByAsn', // 查看操作记录
  // 序列号

  getimeilist: 'agent/bz/qnbar-agent/get-imei-list', // 获取序列号列表
  addimei: 'agent/bz/qnbar-agent/add-imei', // 添加序列号
  searchimei: 'agent/bz/qnbar-agent/find-imei', // 搜索imei
  delImei: 'agent/bz/qnbar-agent/del-imei', // 删除imei

  bindingStoreLists: 'agent/bz/qnbar-agent/get-agent-name', // 获取绑定序列号门店列表
  searchAgentStore: 'agent/bz/qnbar-agent/search-agent', // 搜索门店
  bandAgent: 'agent/bz/qnbar-agent/band-agent', // 绑定门店
  bandOffAgent: 'agent/bz/qnbar-agent/band-off-agent', // 解绑门店
  createMixDemo: 'agent/bz/qnbar-agent/create-mix-demo', // 创建演示门店
  getagent: 'bz-oss/oss/qnbar-agent/get-select-list', // 获取合作商

  // 门店广告有关
  getStorePoster: 'bz-oss/oss/commercial/poster/list/get', // 根据门店id获取海报
  updateStorePoster: 'bz-oss/oss/commercial/poster/update', // 根据门店ID更新官方海报
  deleteStorePoster: 'bz-oss/oss/commercial/poster/del', // 根据门店ID删除官方海报
  getStoreVideo: 'bz-oss/oss/commercial/animation/get-video', // 根据门店id获取开机动画视频
  updateStoreVideo: 'bz-oss/oss/commercial/animation/set-video', // 根据门店id设置开机动画视频
  getAnimationType: 'bz-oss/oss/commercial/animation-type/get', // 根据门店id获取开机动画类型
  updateAnimationType: 'bz-oss/oss/commercial/animation-type/set', // 根据门店id设置开机动画类型
  getAnimationImg: 'bz-oss/oss/commercial/animation/get-pic', // 根据门店id获取开机动画图片
  updateAnimationImg: 'bz-oss/oss/commercial/animation/set-pic', // 根据门店id设置开机动画图片

  getStoreList: 'agent/bz/qnbar-agent/get-name-id-list', // 获取合作商门店列表

  addDmeoStore: 'agent/bz/qnbar-agent/mix-agent/create', // 新增demo门店
  getSystemList: 'common/mix-agent/system/get-type', // 获取可用影视系统
  editstoreinfo: 'agent/bz/qnbar-agent/mix-agent/update', // 修改门店

  // 租赁设备
  getLeaseDeviceList: 'api/lease/get-device-list', // 获取租赁设备列表
  modifyDeviceLease: 'api/lease/modify-device-lease', // 修改租赁设备状态
  getAgentLeaseList: 'api/lease/get-agent-list', // 获取租赁设备门店列表
  getSnList: 'api/lease/get-sn-list', // 获取租赁设备信息
  getRentalEquipmentUseDetails: 'agent/psn/lease/use/info', // 获取租赁设备使用详情
  GetDisconnectionInformation: 'agent/psn/lease/disconnected/get', // 获取设备断网信息
  SetDisconnectionStatus: 'agent/psn/lease/disconnected/set', // 设置设备是否断网的使用
  BatchDeleteDeviceList: 'agent/bz/qnbar-agent/psn/batch/del', // 批量删除设备
  BatchUnbindDeviceList: 'agent/bz/qnbar-agent/psn/batch/bind/off', // 批量解绑设备
  BatchChangeBindDeviceList: 'agent/bz/qnbar-agent/psn/batch/change', // 批量换绑设备
  // 门店组
  storeGroupTypeList: 'bz-oss/oss/store/type/get', // 获取门店组类型列表
  leaseExcelExport: 'agent/bz/lease/excel/export', // 导出租赁信息

  // 租赁管理2
  exportLeaseMoneyFlowForAgent: 'agent/leaseRecord/exportLeaseMoneyFlowForAgent', // 导出购买记录
  leaseMoneyFlowForAgent: 'agent/leaseRecord/leaseMoneyFlowForAgent', // 购买结算记录
  leaseStore: 'agent/bz/qnbar-agent/lease/store', // 租赁门店获取
  leaseStoreUpdate: 'agent/bz/qnbar-agent/lease/store/update', // 租赁门店编辑
  leaseKeysModels: 'agent/bz/qnbar-agent/lease/keys/models', // 获取可选型号
  leaseAllKeys: 'agent/bz/qnbar-agent/lease/all/keys', // 获取所有的key
  leaseModelsKeysUpdate: 'agent/bz/qnbar-agent/lease/models/keys/update', // 增加key型号
  leasePsnList: 'agent/bz/qnbar-agent/lease/psn/list', // 租赁设备检索
  getMoneyFlow: 'agent/leaseRecord/getMoneyFlow', // 结算明细
  exportMoneyFlow: 'agent/leaseRecord/exportMoneyFlow', // 导出结算明细
  getAgentSettlementRecord: 'agent/leaseRecord/getAgentSettlementRecord', // 结算记录
  exportAgentSettlementRecord: 'agent/leaseRecord/exportAgentSettlementRecord', // 导出结算记录
  getStoreNameList: 'agent/bz/mix-agent/get-list', // 商家列表
  leaseKeysDetail: 'agent/bz/qnbar-agent/lease/keys/detail', // 密钥详情
  leasePasAdd: 'agent/bz/qnbar-agent/lease/psn/add', // 租赁设备增加
  leasePsnDel: 'agent/bz/qnbar-agent/lease/psn/del', // 租赁设备解除
  leaseKeysAlert: 'agent/bz/qnbar-agent/lease/keys/alert', // 密钥剩余情况
  leaseKeysDetailInfo: 'agent/bz/qnbar-agent/lease/keys/detail/info', // 密钥详情info
  exportStoreLease: 'agent/bz/qnbar-agent/lease/exportStoreLease', // 导出租赁门店
  exportLeaseDetail: 'agent/bz/qnbar-agent/lease/exportLeaseDetail', // 导出密钥详情
  exportDetailInfo: 'agent/bz/qnbar-agent/lease/exportDetailInfo', // 导出密钥详情info

  // 租赁管理3
  distributeKeys: 'agent/bz/qnbar-agent/lease/keys/distribute', // 分发密匙
  getDistributeLogs: 'agent/bz/qnbar-agent/lease/distribute/logs/get', // 获取分发列表
  exportDistributeKeys: 'agent/bz/qnbar-agent/lease/exportDistributeKeys',

  // 共享文件
  getShareFolder: 'agent/folder/folderGet', // 获取共享文件夹
  getShareFiles: 'agent/folder/fileGet', // 获取共享文件

  // 维修相关
  addRepair: 'warehouse/agent/repair/add', // 新增维修单
  getRepair: 'warehouse/agent/repair/get', // 查询维修单
  editDetailsRepair: 'warehouse/oss/repair/edit', // 编辑维修单信息
  getWarehouseGoods: 'warehouse/goods/list', // 获取商品列表
  payOrderRepair: 'warehouse/agent/repair/order/pay', // 下单支付
  editCheckStatusWarehouse: 'warehouse/oss/check/status/edit', // 更新维修单状态接口
  queryActivationTime: 'warehouse/agent/psn/check', // 查询激活时间
  getFileWarehouse: 'warehouse/agent/file/get', // 附件查询
  addFileWarehouse: 'warehouse/agent/file/add', // 附件新增
  deleteFileWarehouse: 'warehouse/agent/file/del', // 附件删除
  getLogsRepair: 'warehouse/agent/repair/logs/get', // 日志查询
  editPriceRepair: 'warehouse/agent/repair/price/edit', // 批量改价
  editStatusPayRepair: 'warehouse/agent/repair/pay/status/edit', // 结算审核
  getOsnOrderRepair: 'warehouse/agent/repair/order/osn/get', // 订单查询
  getDetailsRepair: 'warehouse/agent/repair/details/get', // 查询维修单详情

  // psn列表批量操作
  agentPsnBatch: 'agent/bz/qnbar-agent/psn/batch', // 批量操作投影仪设备号

  // 电影管理/服务器管理
  agentMachineGet: 'agent/machine/get', // 获取服务器数据
  agentMachineSerStatusRefresh: 'agent/machine/svr/status/refresh', // 获取服务器在线状态,储存状态
  agentSourceUpdateQueue: 'agent/source/updateQueue', // 下载列表  /   电影管理

  // 电影管理/电影黑名单
  agentGetMovieBlack: 'agent/film-black/film/list/get', // 获取电影黑名单数据

  // 更新管理/通用软件
  agentAppThirdAppGet: 'agent/app/thirdApp/get', // 获取软件列表
  agentAppThirdAppGetBindStore: 'agent/app/thirdApp/getBindStore', // 获取绑定门店
  agentAppThirdAppOpBindStore: 'agent/app/thirdApp/opBindStore', // 操作软件门店关联
  agentMixagentNameidList: 'agent/mix-agent/name-id/list', // 获取所有门店

  // 电影白名单
  getWhiteFilmList: 'agent/film/white/get', // 获取电影白名单列表
  getWhiteStoreStatus: 'agent/film/white/status/get', // 获取白名单状态（门店）
  exportWhiteFilm: 'agent/film/white/export', // 导出电影白名单列表

  // 回访系统相关
  QueryisteturnVisitServices: 'agent/return/visit/record/list', // 查询回访服务列表
  ExportReturnVisitRecords: 'agent/return/visit/record/export', // 导出回访记录
  AddReturnVisitRecord: 'agent/return/visit/record/add', // 新增回访记录
  EditReturnVisitRecord: 'agent/return/visit/record/edit', // 编辑回访服务
  DeleteReturnVisitRecord: 'agent/return/visit/record/delete', // 删除回访记录
  FindNamePartnerStore: 'agent/agent/dynamic/query/list', // 查找合作商店名

  // 青柠电影OTT设备
  agentOttDeviceList: 'agent/ott/device/list', // 获取电影设备列表
  agentOttDeviceInfo: '/agent/ott/device/info', // 电影设备日志详情
  agentOttDeviceExport: 'agent/ott/device/export', // 添加导出接口

  // 借机服务相关
  GetBorrowMachineList: 'agent/borrow_record/partner/list', // 获取借机列表数据
  AddBorrowMachineApplication: 'agent/borrow_record/partner/create_order', // 新增借机申请
  GetOrderQRCode: 'agent/borrow_record/partner/get_qr_code', // 获取订单支付二维码
  EditBorrowMachineOrder: 'agent/borrow_record/partner/edit', // 编辑订单信息
  GetDeviceInformation: 'agent/borrow_record/partner/get_machine', // 获取设备信息
  GetMailingAddressAndLoanMachineAgreement: 'agent/borrow_conf/detail', // 获取借机协议或邮寄地址
  GetOrderStatus: 'agent/borrow_record/partner/get_pay_status', // 获取订单状态
  CancelBorrowMachineOrder: 'agent/borrow_record/partner/revoke_order', // 撤销借机订单
  GetBorrowOrderDetails: 'agent/borrow_record/partner/detail', // 获取借机单详情
  EditReturnedEquipment: 'agent/return_record/edit', // 编辑归还设备
  GetEquipmentCanBrented: 'agent/borrow_record/partner/get_psn', // 根据hg_sn获取可租借的设备psn
  BatchReturnEquipment: 'agent/return_record/batch_add', // 批量归还设备
  ExportBorrowMachineList: 'agent/borrow_record/partner/export', // 导出合作商借机列表
  GetExpiredBorrowMachineOrderData: 'agent/borrow_record/partner/get_su_day', // 获取快过期借机单的数据

  // 内容审核
  agentInterfaceAuditList: 'agent/interface/audit/list', // 合作商查询审核记录列表
  bzOssInterfaceAuditWhitelistCheck: 'bz-oss/interface/audit/whitelist/check', // OSS-根据GUID查询白名单状态
  interfaceAuditItems: '/bz-mix/interface/audit/items', // BZMIX-查询指定门店内容类型待审核的列表

  // 申请建店
  ossOssHideLogItem: 'bz-oss/oss/hide/log/item', // 申请建店 门店组筛选
  getFastStoreList: 'bz-oss/oss/mix-agent/name-id/list', // 查询门店列表
  ossOttDeviceExport: 'bz-oss/ott/device/export', // 导出设备

  // 芒果TV会员
  getMangoMemberList: 'bz-oss/film-center/mg_member/list', // 获取芒果会员列表
  exportmangoMemberList: 'bz-oss/film-center/mg_member/member_export', // 导出芒果会员列表

  // 售后换货
  exAgentOrderList: 'ex/agent/order/list', // 获取换货列表
  exAgentOrderExport: 'ex/agent/order/export', // 换货列表导出
  exAgentOrderInfo: 'ex/agent/order/info', // 查询换货详情

  // 华为云上传
  commonOssUpload: 'common/oss/upload', // 拉取上传配置
  uploadWSCommonOss: 'common/ws/upload', // 拉取上传配置(网宿)
  HuaWeiCommonOssUpload: 'common/hwobs/upload', // 拉取华为云上传配置
  HuaWeiSectionUpload: 'common/hwobspart/upload', // 拉取华为云分段上传配置
  HuaWeiMergeSection: 'common/hwobspart/merge', // 华为云分段上传后合并端
  HuaWeiCancelUpload: 'common/hwobspart/cancel', // 取消华为云上传
  HuaweiAndWsUpload: 'common/upload', // 获取上传配置（根据后端的返回的结果，决定是华为还是网宿）

  // 清除缓存
  commonClearPsn: '/common/clear/psn', // 清除设备缓存
  commonClearStore: '/common/clear/store', // 清除门店缓存
  commonClearAgent: '/common/clear/agent', // 清除合作商缓存
  commonClearAppWhite: '/common/clear/app_white',
  getAuditStore: 'agent/store/storeStatusCount', // 获取待审核门店数据

  // 售后维修
  expairManageExportListForAgent: 'repair-manage/export-list-for-agent', // 维修记录导出
  repairManageAgentList: 'repair-manage/agent/list', // 经销商列表查询
  repairManageSearchList: 'repair-manage/search-list', // 获取维修工单列表（带部件信息）
  repairManageSearchSendList: 'repair-manage/search-send-list', // 获取收件人列表
  editsystemSettings: 'repair-manage/set-edit', // 系统设置编辑
  systemSettingsDetails: 'repair-manage/set-info', // 系统设置详情
  getPartsList: 'repair-manage/parts-list', // 获取部件列表
  getPartDetails: 'repair-manage/parts-info', // 获取部件详情
  repairManagePartsUseList: 'repair-manage/parts-use-list', // 部件列表使用详情
  repairManagePartsUseExportList: 'repair-manage/parts-use-export-list', // 部件列表使用详情导出
  editPartInformation: 'repair-manage/parts-edit', // 编辑部件信息
  delPart: 'repair-manage/parts-del', // 删除部件
  getPartsAll: 'repair-manage/parts-all', // 获取全部部件
  importFaultDetection: 'repair-manage/check-wx-data', // 导入维修检测
  saveFaultDetection: 'repair-manage/batch-save-wx-data', // 保存维修检测
  importMaintenanceInspection: 'repair-manage/confirm-wx-data', // 导入维修质检
  saveMaintenanceInspection: 'repair-manage/batch-save-confirm-data', // 保存维修质检
  repairManageBatchXxjhCheck: 'repair-manage/batch-xxjh-check', // 批量线下寄回校验
  repairManageBatchXxjhSave: 'repair-manage/batch-xxjh-save', // 批量线下寄回保存
  getMaintenanceOfSingleDetails: 'repair-manage/info', // 维修单详情
  repairManageEditTj: 'repair-manage/edit-tj', // 维修单-编辑-提交申请状态
  repairManageEditSh: 'repair-manage/edit-sh', // 维修单-编辑-确认收货状态
  repairManageEditShRemark: 'repair-manage/edit-sh-remark', // 维修单-编辑-编辑收货说明
  repairManageEditJc: 'repair-manage/edit-jc', // 维修单-编辑-确认故障检测
  repairManageEditJcRemark: 'repair-manage/edit-jc-remark', // 维修单-编辑-编辑故障说明
  repairManageEditWx: 'repair-manage/edit-wx', // 维修单-编辑-确认维修质检
  repairManageEditWxRemark: 'repair-manage/edit-wx-remark', // 维修单-编辑-编辑维修说明
  repairManageEditJh: 'repair-manage/edit-jh', // 维修单-编辑-确认产品寄回
  repairManageEditJhRemark: 'repair-manage/edit-jh-remark', // 维修单-编辑-编辑产品寄回
  repairManageCancelExpress: 'repair-manage/cancel-express', // 维修单-编辑-取消上门取件
  repairManageEditWc: 'repair-manage/edit-wc', // 维修单-编辑-确认完成
  repairManageCheckModel: 'repair-manage/check-model', // 维修单-新增-校验
  repairManageCreateOrder: 'repair-manage/create-order', // 维修单-新增-保存
  repairManageRevokeOrder: 'repair-manage/revoke-order', // 维修单-新增-撤销
  repairManageRevokeOrderRemark: 'repair-manage/revoke-order-remark', // 维修单-编辑-撤销
  repairManageSettleOrder: 'repair-manage/settle-order', // 维维修单-结算-线下
  repairManageGetQrCode: 'repair-manage/get-qr-code', // 维修单-结算-线上
  repairManageGetOrderPayType: 'repair-manage/get-order-pay-type', // 维修单-结算-检查支付状态
  repairManageExportHzd: 'repair-manage/export-hzd', // 维修单-下载回执单,
  repairManageBatchSmqjCheck: 'repair-manage/batch-smqj-check', // 批量上门取件校验,
  repairManageBatchDchzdCheck: 'repair-manage/batch-dchzd-check', // 批量导出回执单校验,
  repairManageBatchGetPersonInfo: 'repair-manage/batch-get-person-info', // 批量获取收件人,
  repairManageCashList: 'repair-manage/cash-list', // 维修流水列表,
  repairManageCashExportList: 'repair-manage/cash-export-list', // 维修流水列表导出
  repairManageExpressInfo: 'repair-manage/express-info', // 物流查询
  repairManageQuotedPrice: 'repair-manage/quoted-price', // 报价

  // 影咖合作商相关接口
  umStoreRevenueReport: 'agent/um/store/revenue/report', // 获取门店营收订单
  umStoreRevenueExport: 'agent/um/store/revenue/export', // 导出门店营收订单
  umStorePayReport: 'agent/um/store/pay/report', // 获取门店支付订单
  umStorePayExport: 'agent/um/store/pay/export', // 导出门店支付订单
  umStoreOrderReport: 'agent/um/store/order/report', // 获取门店订单
  umStoreOrderExport: 'agent/um/store/order/export', // 导出门店订单
  umRevenueChart: 'agent/um/revenue/chart', // 获取营收占比
  umPayChart: 'agent/um/pay/chart', // 获取营收占支付比
  umStoreRevenueChart: 'agent/um/store/revenue/top/chart', // 获取营收占支付比top10
  umTotalRevenueChart: 'agent/um/total/revenue/chart', // 获取总营收趋势
  umPersonRevenueChart: 'agent/um/person/revenue/chart', // 获取入场人数趋势
  umDurationRevenueChart: 'agent/um/duration/revenue/chart', // 获取时段营收占比
  umRoomRevenueTopChart: 'agent/um/room/revenue/top/chart', // 获取房间收银top10
  umGoodsRevenueTopChart: 'agent/um/goods/revenue/top/chart', // 获取商品零售top10
  umRechargeRevenueTopChart: 'agent/um/recharge/revenue/top/chart', // 获取会员充值top10
  ossMixagentGetList: 'bz-oss/oss/mix-agent/get-list', // 获取门店
  getUmClientRoomlist: 'agent/um/client/room/play/get', // 获取播放记录
  exprotUmClientRoomlist: 'agent/um/client/room/play/export', // 导出播放记录
  umFreezingEquipment: 'agent/um/pro-imei/freeze-imei', // 冻结设备
  umBathFreezingEquipment: 'agent/um/pro-imei/batch/frozen', // 批量冻结设备
  umUnfreezeEquipment: 'agent/um/pro-imei/unfreeze-imei', // 解冻设备

  // 温度监测
  tempStatPsnList: 'agent/temp/stat/psn-list', // 高温设备列表
  tempStatPsnTempDetail: 'agent/temp/stat/psn-temp-detail', // 高温详情
  tempStatPsnTempLog: 'agent/temp/stat/psn-temp-log', // 高温日志列表
  tempStatDealHotPsn: 'agent/hzs-temp/stat/deal-hot-psn', // 处理高温设备
  tempStatDealHotPsnList: 'agent/temp/stat/deal-hot-psn-list', // 处理日志列表
  tempStatPsnModelList: 'agent/temp/stat/psn-model-list', // 监测设备列表
  tempStatEditPsnModel: 'agent/temp/stat/edit-psn-model', // 编辑监测设备
  getModelList: 'firmware/getModelList', // 获取纯固件型号列表
  tempStatMonthStatistics: 'temp/stat/month-statistics', // 全部设备高温统计
  tempStatPsnListexport: 'agent/temp/stat/psn-list-export', // 高温设备列表导出
  tempStatPsnTempLogexport: 'agent/temp/stat/psn-temp-log-export', // 高温日志列表导出
  tempStatDealHotPsnListexport: 'agent/temp/stat/deal-hot-psn-list-export', // 处理日志列表导出

  // 软件商城
  agentThirdAppNewGet: 'software/agent/thirdApp/new/get', // 获取软件
  agentThirdAppGetBindStore: 'software/agent/thirdApp/getBindStore', // 获取详情
  agentThirdAppOpBindStore: 'software/agent/thirdApp/opBindStore', // （推送/取消推送）软件
  thirdAppCountGet: 'software/thirdApp/count/get', // 获取门店软件下载次数
  umBathUnfreezeEquipment: 'agent/um/pro-imei/batch/relieve/frozen', // 批量解冻设备

  // 租赁三
  agentLeaseXcList: 'agent/lease/xc/list', // 查询租赁3列表
  agentLeaseXcExport: 'agent/lease/xc/export', // 导出租赁3列表
  agentLeaseXcAdd: 'agent/lease/xc/add', // 新增租赁3
  agentLeaseXcEdit: 'agent/lease/xc/edit', // 编辑租赁3
  agentLeaseXcStatusEdit: 'agent/lease/xc/status/edit', // 编辑租赁3开通状态
  agentLeaseXcRecordReport: 'agent/lease/xc/record/report', // 查询租赁3授权统计
  agentLeaseXcRecordReportExport: 'agent/lease/xc/record/report/export', // 导出租赁3授权统计
  agentLeaseXcDetailReport: 'agent/lease/xc/detail/report', // 查询租赁3授权明细
  agentleaseXcDetailReportExport: 'agent/lease/xc/detail/report/export' }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentLeaseXcList', 'agent/lease/xc/list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentLeaseXcExport', 'agent/lease/xc/export'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentLeaseXcAdd', 'agent/lease/xc/add'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentLeaseXcEdit', 'agent/lease/xc/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentLeaseXcStatusEdit', 'agent/lease/xc/status/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentLeaseXcRecordReport', 'agent/lease/xc/record/report'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentLeaseXcRecordReportExport', 'agent/lease/xc/record/report/export'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentLeaseXcDetailReport', 'agent/lease/xc/detail/report'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentleaseXcDetailReportExport', 'agent/lease/xc/detail/report/export'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentBzMixAgentApplyAuth', 'agent/bz/mix-agent/apply_auth'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentBzMixAgentAuthSearchStore', 'agent/bz/mix-agent/auth_search_store'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentBzMixAgentApplyList', 'agent/bz/mix-agent/apply_list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentBzMixAgentMacAdd', 'agent/bz/mix-agent/mac/add'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentBzMixAgentMacGet', 'agent/bz/mix-agent/mac/get'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentBzMixAgentMacSearch', 'agent/bz/mix-agent/mac/search'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentRefillLast', 'bz-oss/card/agent/refill_last'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentBzMixAgentMacTimeAdd', 'agent/bz/mix-agent/mac/time/add'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentBzMixAgentMacSearchStore', 'agent/bz/mix-agent/mac/search/store'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentMacPsnNumberGet', 'agent/bz/mix-agent/mac/psn/number/get'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentOttMemberList', 'agent/ott/member/list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentOttMemberExpire', 'agent/ott/member/expire'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentOttMemberReplace', 'agent/ott/member/replace'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentOttMemberNum', 'agent/ott/member/num'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentOttMemberExport', 'agent/ott/member/export'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentOttMemberAdd', 'agent/ott/member/add'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'ottMemberRecognition', 'bz-oss/ott/member/recognition'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'filmCenterMgMemberRecognition', 'bz-oss/film-center/mg_member/recognition'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentMgMemberList', 'agent/mg/member/list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentMgMemberExport', 'agent/mg/member/export'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentMgMemberAdd', 'agent/mg/member/add'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentMgMemberExpire', 'agent/mg/member/expire'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentMgMemberNum', 'agent/mg/member/num'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentOttWorkList', 'agent/ott/work/list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentOttWorkExport', 'agent/ott/work/export'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'authAgentNum', 'bz-oss/auth/agent/num'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentOttMemberDel', 'agent/ott/member/del'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentMgMemberDel', 'agent/mg/member/del'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentBzMixAgentMacPsnExport', 'agent/bz/mix-agent/mac/psn/export'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'memberFilmStoreSearch', 'bz-oss/ott/member/film_store/search'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'appAppVersionList', 'app/appVersionList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentOttMemberBlackList', 'agent/ott/member/blacklist/fetch'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentGameOrderList', 'agent/game/order/list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'agentGameOrderExport', 'agent/game/order/export'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'softwareAgentThirdAppUninstall', "software/agent/thirdApp/uninstall"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'softwareAgentThirdAppCancleUninstall', "software/agent/thirdApp/cancel_uninstall"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'softwareAgentThirdAppAll_uninstall', "software/agent/thirdApp/all_uninstall"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'softwareAgentThirdAppAll_cancel', "software/agent/thirdApp/all_cancel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'commonClearrojectorCache', "common/clear/projector/cache"), _loginValidateTicket$);

/***/ }),

/***/ "N2mp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Levelbar_vue__ = __webpack_require__("3zpo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27592aaa_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Levelbar_vue__ = __webpack_require__("g37H");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Hg9M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27592aaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Levelbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27592aaa_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Levelbar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/Levelbar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Levelbar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-27592aaa", Component.options)
  } else {
    hotAPI.reload("data-v-27592aaa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css__ = __webpack_require__("q8zI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icons__ = __webpack_require__("Q7M0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__permission__ = __webpack_require__("kTXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_js_common__ = __webpack_require__("oHFL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directive_index__ = __webpack_require__("1cb1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_filters__ = __webpack_require__("iClD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_xlsx_table__ = __webpack_require__("SyTA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_xlsx_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_xlsx_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_accounting__ = __webpack_require__("W1GH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_QnInput__ = __webpack_require__("11jX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_QnImage__ = __webpack_require__("ojPt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_echarts__ = __webpack_require__("XLwt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__env_js__ = __webpack_require__("yZtZ");





// import locale from 'element-ui/lib/locale/lang/en'


 //vuex数据
 // icon
 // 权限
 //公共JS函数文件








__WEBPACK_IMPORTED_MODULE_14_accounting___default.a.settings.currency.symbol = '￥';
__WEBPACK_IMPORTED_MODULE_14_accounting___default.a.settings.currency.format = {
  pos: '%s%v', // for positive values, eg. "￥ 1.00" (required)
  neg: '%s-%v', // for negative values, eg. "￥ (1.00)" [optional]
  zero: '%s 0.00' // for zero values, eg. "￥  0.00" [optional]
};

for (var key in __WEBPACK_IMPORTED_MODULE_14_accounting___default.a) {
  if (typeof __WEBPACK_IMPORTED_MODULE_14_accounting___default.a[key] === 'function') {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_14_accounting___default.a[key]);
  }
}

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$accounting = __WEBPACK_IMPORTED_MODULE_14_accounting___default.a;

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$getUser = function () {
  var timeout = 5000;
  var interval = 1000;
  var timer = null;
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var startTime = Date.now();
    var fn = function fn() {
      var usedtime = Math.floor(Date.now() - startTime);
      if (usedtime > timeout) reject(new Error('获取用户信息超时'));
      var user = localStorage.getItem("user_data");
      if (user) {
        try {
          resolve(JSON.parse(user));
        } catch (e) {
          reject(new Error('用户信息解析出错'));
        }
      } else {
        if (timer) clearTimeout(timer);
        timer = setTimeout(fn, interval);
      }
    };
    fn();
  });
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$getUserAll = function () {
  var timeout = 5000;
  var interval = 1000;
  var timer = null;
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var startTime = Date.now();
    var fn = function fn() {
      var usedtime = Math.floor(Date.now() - startTime);
      if (usedtime > timeout) reject(new Error('获取权限超时'));
      var user = localStorage.getItem("user_all");
      if (user) {
        try {
          resolve(user);
        } catch (e) {
          reject(new Error('权限解析出错'));
        }
      } else {
        if (timer) clearTimeout(timer);
        timer = setTimeout(fn, interval);
      }
    };
    fn();
  });
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('qn-input', __WEBPACK_IMPORTED_MODULE_15__components_QnInput__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('qn-image', __WEBPACK_IMPORTED_MODULE_16__components_QnImage__["a" /* default */]);

// 全局filter注册
var filterNames = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_12__utils_filters__["a" /* default */]);
filterNames.forEach(function (name) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter(name, __WEBPACK_IMPORTED_MODULE_12__utils_filters__["a" /* default */][name]);
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__directive_index__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a, {});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_xlsx_table___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$echarts = __WEBPACK_IMPORTED_MODULE_17_echarts___default.a;

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
 //just run
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__common_js_common__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$bus = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]();
window.eventBus = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]();

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
});

/***/ }),

/***/ "OQVf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-helpCenter",
  "use": "icon-helpCenter-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-helpCenter\"><defs><style type=\"text/css\"></style></defs><path d=\"M848.928 170.656H634.56a153.184 153.184 0 0 0-122.464 61.312 153.184 153.184 0 0 0-122.496-61.312H175.104c-33.792 0-61.312 27.52-61.312 61.312v566.656c0 33.792 27.52 61.312 61.312 61.312h225.216a160.032 160.032 0 0 0 111.776 45.888 160.032 160.032 0 0 0 111.776-45.888h225.056c33.792 0 61.312-27.52 61.312-61.312V232c0-33.792-27.52-61.312-61.312-61.312z m0 627.968h-238.4a30.4 30.4 0 0 0-23.2 10.72 99.392 99.392 0 0 1-75.232 35.168 99.392 99.392 0 0 1-75.232-35.2 30.4 30.4 0 0 0-23.232-10.688H175.104V232h214.368a92.064 92.064 0 0 1 91.872 91.904v260.384a30.56 30.56 0 1 0 61.184 0v-260.384a92.064 92.064 0 0 1 91.872-91.904h214.528v566.656z\" p-id=\"3657\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Opzk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.vue": [
		"+H76",
		104
	],
	"./EquipmentManagement/PSNUsings/index.vue": [
		"/Sr4",
		85
	],
	"./EquipmentManagement/index.vue": [
		"I2MY",
		175
	],
	"./EquipmentManagement/monitoringManagement/components/copeDialog.vue": [
		"LJCM",
		47
	],
	"./EquipmentManagement/monitoringManagement/components/viewTemperatureDetails.vue": [
		"QFB8",
		174
	],
	"./EquipmentManagement/monitoringManagement/handleLog.vue": [
		"B6/w",
		173
	],
	"./EquipmentManagement/monitoringManagement/highTemperatureEquipment.vue": [
		"ARz6",
		21
	],
	"./EquipmentManagement/monitoringManagement/index.vue": [
		"t5A0",
		172
	],
	"./EquipmentManagement/monitoringManagement/temperatureDetails.vue": [
		"8wX7",
		171
	],
	"./EquipmentManagement/monitoringManagement/temperatureLog.vue": [
		"lzr5",
		84
	],
	"./EquipmentManagement/monitoringManagement/temperatureLogAll.vue": [
		"Un6c",
		83
	],
	"./EquipmentManagement/monitoringManagement/useMonitoring.vue": [
		"RrS3",
		170
	],
	"./EquipmentManagement/serialNumber/components/chengeBind.vue": [
		"kj4T",
		169
	],
	"./EquipmentManagement/serialNumber/index.vue": [
		"t0Xd",
		46
	],
	"./afterSalesManage/BorrowMachineSystem/AddApplication.vue": [
		"kegL",
		103
	],
	"./afterSalesManage/BorrowMachineSystem/BorrowMachinePact/index.vue": [
		"+YQk",
		168
	],
	"./afterSalesManage/BorrowMachineSystem/BorrworderDetails/index.vue": [
		"A0ei",
		97
	],
	"./afterSalesManage/BorrowMachineSystem/PaymentTransfer.vue": [
		"lWMO",
		167
	],
	"./afterSalesManage/BorrowMachineSystem/ReturnEquipmentOperation/index.vue": [
		"O+Hn",
		72
	],
	"./afterSalesManage/BorrowMachineSystem/index.vue": [
		"XlPc",
		102
	],
	"./afterSalesManage/NewReturnVisi/index.vue": [
		"ZidS",
		13
	],
	"./afterSalesManage/ReturnVisitDetails/index.vue": [
		"jFPe",
		12
	],
	"./afterSalesManage/ReturnVisitService/index.vue": [
		"MV3l",
		71
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/confirmCompletion.vue": [
		"QzKJ",
		45
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/confirmDetection.vue": [
		"drnP",
		44
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/confirmMaintain.vue": [
		"f6lC",
		43
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/confirmPrice.vue": [
		"QrJN",
		42
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/confirmRepair.vue": [
		"2ePy",
		41
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/confirmReturn.vue": [
		"wbxJ",
		32
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/editCancel.vue": [
		"S6YM",
		40
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/editDetection.vue": [
		"zqiG",
		39
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/editMaintain.vue": [
		"7mNp",
		38
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/editPickUp.vue": [
		"u7UP",
		166
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/editRecipt.vue": [
		"1BVk",
		37
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/editRepair.vue": [
		"iEkT",
		31
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/editReturn.vue": [
		"IeeO",
		30
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/components/expressInfo.vue": [
		"Evb4",
		165
	],
	"./afterSalesManage/afterSalesMaintenance/MaintenanceDetails/index.vue": [
		"Nx+g",
		1
	],
	"./afterSalesManage/afterSalesMaintenance/components/QnUploadAlpha/components/cropper/index.vue": [
		"fzh1",
		121
	],
	"./afterSalesManage/afterSalesMaintenance/components/QnUploadAlpha/components/cropperDialog/index.vue": [
		"1zzW",
		70
	],
	"./afterSalesManage/afterSalesMaintenance/components/QnUploadAlpha/components/image/index.vue": [
		"cBHM",
		180
	],
	"./afterSalesManage/afterSalesMaintenance/components/QnUploadAlpha/index.vue": [
		"xdAu",
		51
	],
	"./afterSalesManage/afterSalesMaintenance/components/addBillBatch.vue": [
		"J1ox",
		17
	],
	"./afterSalesManage/afterSalesMaintenance/components/addCallExpressBatch.vue": [
		"5UD7",
		100
	],
	"./afterSalesManage/afterSalesMaintenance/components/addCancel.vue": [
		"eYD9",
		36
	],
	"./afterSalesManage/afterSalesMaintenance/components/addMaintainBatch.vue": [
		"8UWe",
		16
	],
	"./afterSalesManage/afterSalesMaintenance/components/addRepair.vue": [
		"r4d0",
		29
	],
	"./afterSalesManage/afterSalesMaintenance/components/addReturnBatch.vue": [
		"DmSf",
		15
	],
	"./afterSalesManage/afterSalesMaintenance/components/editBillItem.vue": [
		"DylA",
		35
	],
	"./afterSalesManage/afterSalesMaintenance/components/editMaintainItem.vue": [
		"17nW",
		34
	],
	"./afterSalesManage/afterSalesMaintenance/components/editReturnItem.vue": [
		"byJ6",
		28
	],
	"./afterSalesManage/afterSalesMaintenance/components/exportAddresseeBatch.vue": [
		"Ab6A",
		99
	],
	"./afterSalesManage/afterSalesMaintenance/components/exportReceiptBatch.vue": [
		"V0px",
		98
	],
	"./afterSalesManage/afterSalesMaintenance/components/settleOrder.vue": [
		"A6lI",
		5
	],
	"./afterSalesManage/afterSalesMaintenance/components/systemSettings.vue": [
		"SDdz",
		120
	],
	"./afterSalesManage/afterSalesMaintenance/index.vue": [
		"TJBy",
		0
	],
	"./afterSalesManage/components/QnWangeditor.vue": [
		"uiHT",
		23
	],
	"./afterSalesManage/components/ReturnVisitsfrom.vue": [
		"Eot1",
		119
	],
	"./afterSalesManage/components/UploadDetailedImage.vue": [
		"qxRe",
		69
	],
	"./afterSalesManage/components/details.vue": [
		"8d+E",
		19
	],
	"./afterSalesManage/components/qn-upload4.vue": [
		"e/bc",
		68
	],
	"./afterSalesManage/exchange/details.vue": [
		"klEf",
		164
	],
	"./afterSalesManage/exchange/index.vue": [
		"Qp1v",
		118
	],
	"./afterSalesManage/repairOrder/addMaintenance.vue": [
		"QtFR",
		14
	],
	"./afterSalesManage/repairOrder/components/addSerialDialog.vue": [
		"pl3Z",
		27
	],
	"./afterSalesManage/repairOrder/components/editCommodity.vue": [
		"qoRF",
		163
	],
	"./afterSalesManage/repairOrder/components/editInformation.vue": [
		"0R8j",
		49
	],
	"./afterSalesManage/repairOrder/components/importDialog.vue": [
		"Lf8w",
		86
	],
	"./afterSalesManage/repairOrder/components/uploadComponents.vue": [
		"EzwF",
		67
	],
	"./afterSalesManage/repairOrder/detailOrder.vue": [
		"uqWK",
		18
	],
	"./afterSalesManage/repairOrder/index.vue": [
		"GEo/",
		96
	],
	"./description/description.vue": [
		"l6je",
		162
	],
	"./filmManagement/components/showMovie.vue": [
		"4+RX",
		101
	],
	"./filmManagement/device/components/detailsDialog.vue": [
		"I4AP",
		161
	],
	"./filmManagement/device/components/exportDialog.vue": [
		"hx3v",
		160
	],
	"./filmManagement/device/index.vue": [
		"8CXR",
		82
	],
	"./filmManagement/download.vue": [
		"Oqm+",
		66
	],
	"./filmManagement/mangoVip/components/exportDialog.vue": [
		"UUgv",
		159
	],
	"./filmManagement/mangoVip/index.vue": [
		"9MWm",
		81
	],
	"./filmManagement/movieBlacklist.vue": [
		"Nutl",
		158
	],
	"./filmManagement/movieWhitelist.vue": [
		"qoxe",
		157
	],
	"./filmManagement/serverManagement.vue": [
		"cJmk",
		156
	],
	"./gameManager/flowOrder.vue": [
		"7BH/",
		155
	],
	"./helpCenter/shareFiles/index.vue": [
		"9bJJ",
		154
	],
	"./helpCenter/techDocument/index.vue": [
		"8pND",
		153
	],
	"./layout/AppMain.vue": [
		"TAmc"
	],
	"./layout/Layout.vue": [
		"AkUR"
	],
	"./layout/Levelbar.vue": [
		"N2mp"
	],
	"./layout/Navbar.vue": [
		"kzJD"
	],
	"./layout/Sidebar.vue": [
		"DOpt"
	],
	"./layout/SidebarItem.vue": [
		"6o49"
	],
	"./layout/TabsView.vue": [
		"jSdT"
	],
	"./leaseManagement/index.vue": [
		"aGZ8",
		152
	],
	"./leaseManagement/lease/deviceInfo.vue": [
		"adUa",
		80
	],
	"./leaseManagement/lease/leaseAddInfo.vue": [
		"JSPa",
		58
	],
	"./leaseManagement/lease/leaseInfoCheck.vue": [
		"orEy",
		79
	],
	"./leaseManagement/lease2/device/components/SearchBar.vue": [
		"Lr/K",
		117
	],
	"./leaseManagement/lease2/device/index.vue": [
		"KEpO",
		50
	],
	"./leaseManagement/lease2/disbuteRecords/components/SearchBar.vue": [
		"Di6b",
		116
	],
	"./leaseManagement/lease2/disbuteRecords/index.vue": [
		"YPJw",
		11
	],
	"./leaseManagement/lease2/hotel/components/SearchBar.vue": [
		"zqZH",
		115
	],
	"./leaseManagement/lease2/hotel/index.vue": [
		"Xgr+",
		9
	],
	"./leaseManagement/lease2/payRecord/components/SearchBar.vue": [
		"bfWp",
		114
	],
	"./leaseManagement/lease2/payRecord/index.vue": [
		"EjBT",
		65
	],
	"./leaseManagement/lease2/useDetailList/components/SearchBar.vue": [
		"Ok78",
		113
	],
	"./leaseManagement/lease2/useDetailList/index.vue": [
		"5KsV",
		64
	],
	"./leaseManagement/lease2/useRecord/components/SearchBar.vue": [
		"HaV1",
		112
	],
	"./leaseManagement/lease2/useRecord/index.vue": [
		"Y40j",
		63
	],
	"./leaseManagement/lease3/components/addStore.vue": [
		"0Dbp",
		151
	],
	"./leaseManagement/lease3/components/editStore.vue": [
		"5A0n",
		150
	],
	"./leaseManagement/lease3/dataStatistics.vue": [
		"dR5J",
		149
	],
	"./leaseManagement/lease3/dataStatisticsDetails.vue": [
		"ya0s",
		148
	],
	"./leaseManagement/lease3/openStore.vue": [
		"HGoh",
		56
	],
	"./login/index.vue": [
		"T+/8",
		111
	],
	"./memberManagement/authorization.vue": [
		"TUfR",
		147
	],
	"./memberManagement/authorizationComplete.vue": [
		"pgfr",
		3
	],
	"./memberManagement/authorizationInApplication.vue": [
		"jCwD",
		2
	],
	"./memberManagement/components/applyForCopyright.vue": [
		"NCih",
		4
	],
	"./memberManagement/components/delDeviceDialog.vue": [
		"wuhq",
		146
	],
	"./memberManagement/components/editMember.vue": [
		"obLE",
		145
	],
	"./memberManagement/components/exportDialog.vue": [
		"tL5J",
		95
	],
	"./memberManagement/components/openMember.vue": [
		"Nsps",
		144
	],
	"./memberManagement/components/openMemberFile.vue": [
		"b+El",
		55
	],
	"./memberManagement/components/renewMember.vue": [
		"Akfu",
		143
	],
	"./memberManagement/components/renewMemberSingle.vue": [
		"wY5Q",
		142
	],
	"./memberManagement/components/replaceDialog.vue": [
		"OcEo",
		94
	],
	"./memberManagement/mango/components/delDeviceDialog.vue": [
		"B9mP",
		141
	],
	"./memberManagement/mango/components/exportDialog.vue": [
		"Szre",
		93
	],
	"./memberManagement/mango/components/openMember.vue": [
		"LGDk",
		140
	],
	"./memberManagement/mango/components/openMemberFile.vue": [
		"/Ro1",
		54
	],
	"./memberManagement/mango/components/renewMember.vue": [
		"iKWI",
		139
	],
	"./memberManagement/mango/components/renewMemberSingle.vue": [
		"MkK8",
		138
	],
	"./memberManagement/mango/index.vue": [
		"LeF3",
		10
	],
	"./memberManagement/memberWorkOrder.vue": [
		"dVLX",
		53
	],
	"./memberManagement/qnFilm.vue": [
		"DrnF",
		8
	],
	"./memberManagement/qnFilmMember/components/delDeviceDialog.vue": [
		"zhfA",
		137
	],
	"./memberManagement/qnFilmMember/components/exportDialog.vue": [
		"WNrT",
		92
	],
	"./memberManagement/qnFilmMember/components/openMember.vue": [
		"7MiH",
		52
	],
	"./memberManagement/qnFilmMember/components/renewMember.vue": [
		"+RzW",
		91
	],
	"./memberManagement/qnFilmMember/components/renewMemberSingle.vue": [
		"e6ad",
		136
	],
	"./memberManagement/qnFilmMember/components/replaceDialog.vue": [
		"GhoV",
		90
	],
	"./memberManagement/qnFilmMember/index.vue": [
		"9TXJ",
		7
	],
	"./operation/cinema/statistics/dailyRevenue/components/QnSearchBar/index.vue": [
		"Y9rA",
		179
	],
	"./operation/cinema/statistics/dailyRevenue/index.vue": [
		"lELA",
		78
	],
	"./operation/cinema/statistics/index.vue": [
		"LARX",
		135
	],
	"./operation/cinema/statistics/payStatistics/components/QnSearchBar/index.vue": [
		"+TD9",
		178
	],
	"./operation/cinema/statistics/payStatistics/index.vue": [
		"YpgQ",
		77
	],
	"./operation/cinema/statistics/revenueAnalysis/components/QnSearchBar/index.vue": [
		"Bpbv",
		134
	],
	"./operation/cinema/statistics/revenueAnalysis/components/chartBase/chartLevelBar.vue": [
		"gzbQ",
		110
	],
	"./operation/cinema/statistics/revenueAnalysis/components/chartBase/chartPanelLine.vue": [
		"fod3",
		109
	],
	"./operation/cinema/statistics/revenueAnalysis/components/chartBase/chartPanelPie.vue": [
		"/OjA",
		108
	],
	"./operation/cinema/statistics/revenueAnalysis/index.vue": [
		"EHPW",
		20
	],
	"./operation/cinema/statistics/shopOrder/components/QnSearchBar/index.vue": [
		"hN6K",
		177
	],
	"./operation/cinema/statistics/shopOrder/index.vue": [
		"By7m",
		89
	],
	"./operation/cinema/statistics/shopPay/components/QnSearchBar/index.vue": [
		"XSqs",
		176
	],
	"./operation/cinema/statistics/shopPay/index.vue": [
		"YWqg",
		88
	],
	"./operation/cinema/statistics/shopSales/components/QnSearchBar/index.vue": [
		"KsBl",
		107
	],
	"./operation/cinema/statistics/shopSales/index.vue": [
		"5A60",
		62
	],
	"./playbackRecord/playRecord/index.vue": [
		"QW2n",
		133
	],
	"./serialNumberMgt/activeNumber.vue": [
		"wuRl",
		76
	],
	"./serialNumberMgt/serialNumber.vue": [
		"62jj",
		75
	],
	"./settle/orderList/components/SearchBar.vue": [
		"vJTC",
		106
	],
	"./settle/orderList/index.vue": [
		"n7rt",
		61
	],
	"./settle/recordList/components/SearchBar.vue": [
		"kF4z",
		105
	],
	"./settle/recordList/index.vue": [
		"XdMl",
		60
	],
	"./store/addDemoStore.vue": [
		"mZji",
		26
	],
	"./store/addStore.vue": [
		"PbQx",
		25
	],
	"./store/advertisement.vue": [
		"xL0v",
		6
	],
	"./store/details.vue": [
		"uypf",
		24
	],
	"./store/editStore.vue": [
		"7SNX",
		33
	],
	"./store/examine.vue": [
		"WrbD",
		132
	],
	"./store/phone.vue": [
		"90d9",
		74
	],
	"./store/phone_edit.vue": [
		"8oig",
		73
	],
	"./store/previewApplyStore.vue": [
		"BgJQ",
		131
	],
	"./store/previewStore.vue": [
		"Te50",
		130
	],
	"./store/roleManagement/components/RoleDialog.vue": [
		"6hKX",
		87
	],
	"./store/roleManagement/index.vue": [
		"d/Lf",
		57
	],
	"./store/staffManagement/components/AddStaffDialog.vue": [
		"4FyV",
		129
	],
	"./store/staffManagement/components/EditStaffDialog.vue": [
		"jH7t",
		128
	],
	"./store/staffManagement/components/ResetPwdDialog.vue": [
		"ZY2X",
		127
	],
	"./store/staffManagement/index.vue": [
		"I3KZ",
		48
	],
	"./store/storeMGR.vue": [
		"MVRa",
		59
	],
	"./updateManagement/appDetails.vue": [
		"60y4",
		22
	],
	"./updateManagement/components/ImportDialog.vue": [
		"aVuS",
		126
	],
	"./updateManagement/components/addEditDialog.vue": [
		"n6RK",
		125
	],
	"./updateManagement/components/cancelPushOrPush.vue": [
		"dMsY",
		124
	],
	"./updateManagement/generalSoftware.vue": [
		"vgGJ",
		123
	],
	"./updateManagement/softwareStoreManagement.vue": [
		"yr3M",
		122
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "Opzk";

/***/ }),

/***/ "PInp":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.screenfull[data-v-200e3c4e] {\n  display: inline-block;\n  cursor: pointer;\n  vertical-align: -0.15em;\n}\n", ""]);

// exports


/***/ }),

/***/ "PloX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-c",
  "use": "icon-c-usage",
  "viewBox": "0 0 1131 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1131 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-c\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 0h53.894737v970.105263H0zM269.473684 431.157895h53.894737v538.947368H269.473684zM538.947368 161.684211h53.894737v808.421052h-53.894737zM808.421053 646.736842h53.894736v323.368421h-53.894736zM1077.894737 323.368421h53.894737v646.736842h-53.894737z\" fill=\"\" p-id=\"8787\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "PvI4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_qnbar_platform_js__ = __webpack_require__("Ljt4");


//qnbar平台工具的基础配置
//var PT = require('./vendor/qnbar/platform.js');


var PT = new __WEBPACK_IMPORTED_MODULE_0__vendor_qnbar_platform_js__["a" /* default */].Platform();
PT.config.env = "test";
PT.config.hostBaseUrl = 'https://agent.qnbar.cn/';
PT.config.platformUsagespace = 'PT_AGENT_BZ';
PT.config.apiBaseUrl = 'https://api2.qnbar.cn/';
PT.config.qnloginBaseUrl = "http://passport.t.qnbar.cn/";
PT.config.qnloginPlatformNo = 8;
PT.config.loginJumpBackUrl = encodeURIComponent(PT.config.hostBaseUrl);
PT.config.wsHost = "ws.qnbar.cn";
PT.config.wsPort = "16668";
PT.config.wsProto = "wss";
PT.init();

/* unused harmony default export */ var _unused_webpack_default_export = ({
    PT: PT
});

/***/ }),

/***/ "Q7M0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Icon_svg__ = __webpack_require__("xNsp");

 // svg组件

// register globally
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('icon-svg', __WEBPACK_IMPORTED_MODULE_1__components_Icon_svg__["a" /* default */]);

var requireAll = function requireAll(requireContext) {
  return requireContext.keys().map(requireContext);
};
var req = __webpack_require__("90Fk");
requireAll(req);

/***/ }),

/***/ "Qvxz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "navbar",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('hamburger', {
    staticClass: "hamburger-container",
    attrs: {
      "toggleClick": _vm.toggleSideBar,
      "isActive": _vm.sidebar.opened
    }
  }), _vm._v(" "), _c('levelbar'), _vm._v(" "), (_vm.navbarData.storetotal) ? _c('div', {
    staticClass: "nav-info"
  }, [_vm._v("门店：" + _vm._s(_vm.navbarData.storetotal))]) : _vm._e(), _vm._v(" "), (_vm.navbarData.agenttotal) ? _c('div', {
    staticClass: "nav-info"
  }, [_vm._v("合作商：" + _vm._s(_vm.navbarData.agenttotal))]) : _vm._e(), _vm._v(" "), _c('screenfull', {
    staticClass: "screenfull"
  }), _vm._v(" "), _c('el-dropdown', {
    staticClass: "avatar-container",
    attrs: {
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('img', {
    staticClass: "user-avatar",
    attrs: {
      "src": _vm.photoUrl
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "user-dropdown",
    slot: "dropdown"
  }, [(_vm.user_title) ? _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.user_title))])]) : _vm._e(), _vm._v(" "), (_vm.islocal_user === true) ? _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.changePSW
    }
  }, [_vm._v("修改密码")])]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.runLogout
    }
  }, [_vm._v("退出")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pass"
  }, [_c('el-dialog', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "修改密码"
    },
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm2,
      "status-icon": "",
      "rules": _vm.rules2,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.pass),
      callback: function($$v) {
        _vm.ruleForm2.pass = $$v
      },
      expression: "ruleForm2.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.ruleForm2.checkPass = $$v
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('ruleForm2')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetForm('ruleForm2')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6bce3e2a", esExports)
  }
}

/***/ }),

/***/ "SM0Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
});

/***/ }),

/***/ "SVqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-bug",
  "use": "icon-bug-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-bug\"><defs><style type=\"text/css\"></style></defs><path d=\"M969.142857 548.571429q0 14.848-10.861714 25.709714t-25.709714 10.861714l-128 0q0 97.718857-38.290286 165.705143l118.857143 119.442286q10.861714 10.861714 10.861714 25.709714t-10.861714 25.709714q-10.276571 10.861714-25.709714 10.861714t-25.709714-10.861714l-113.152-112.566857q-2.852571 2.852571-8.557714 7.424t-23.990857 16.274286-37.156571 20.845714-46.848 16.566857-55.442286 7.424l0-512-73.142857 0 0 512q-29.147429 0-58.002286-7.716571t-49.700571-18.870857-37.705143-22.272-24.868571-18.578286l-8.557714-8.009143-104.557714 118.272q-11.446857 11.995429-27.428571 11.995429-13.714286 0-24.576-9.142857-10.861714-10.276571-11.702857-25.417143t8.850286-26.587429l115.419429-129.718857q-33.133714-65.133714-33.133714-156.562286l-128 0q-14.848 0-25.709714-10.861714t-10.861714-25.709714 10.861714-25.709714 25.709714-10.861714l128 0 0-168.009143-98.852571-98.852571q-10.861714-10.861714-10.861714-25.709714t10.861714-25.709714 25.709714-10.861714 25.709714 10.861714l98.852571 98.852571 482.304 0 98.852571-98.852571q10.861714-10.861714 25.709714-10.861714t25.709714 10.861714 10.861714 25.709714-10.861714 25.709714l-98.852571 98.852571 0 168.009143 128 0q14.848 0 25.709714 10.861714t10.861714 25.709714zM694.857143 219.428571l-365.714286 0q0-75.995429 53.430857-129.426286t129.426286-53.430857 129.426286 53.430857 53.430857 129.426286z\" p-id=\"10315\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "TAmc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__ = __webpack_require__("vuLS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eaa0f2f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__ = __webpack_require__("8x+Q");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eaa0f2f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/AppMain.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AppMain.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2eaa0f2f", Component.options)
  } else {
    hotAPI.reload("data-v-2eaa0f2f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TIfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var TokenKey = 'local_sess';

function getToken() {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(TokenKey);
}

function setToken(token) {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(TokenKey, token);
}

function removeToken() {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(TokenKey);
}

/***/ }),

/***/ "TvT6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.app-wrapper[data-v-29d0b9f6] {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.app-wrapper[data-v-29d0b9f6]:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.app-wrapper.hideSidebar .sidebar-wrapper[data-v-29d0b9f6] {\n    transform: translate(-140px, 0);\n}\n.app-wrapper.hideSidebar .sidebar-wrapper .sidebar-container[data-v-29d0b9f6] {\n      transform: translate(132px, 0);\n}\n.app-wrapper.hideSidebar .main-container[data-v-29d0b9f6] {\n    margin-left: 40px;\n}\n.app-wrapper .sidebar-wrapper[data-v-29d0b9f6] {\n    width: 180px;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1001;\n    overflow: hidden;\n    transition: all .28s ease-out;\n}\n.app-wrapper .sidebar-container[data-v-29d0b9f6] {\n    transition: all .28s ease-out;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: -17px;\n    overflow: hidden;\n    overflow-y: scroll;\n}\n.app-wrapper .main-container[data-v-29d0b9f6] {\n    min-height: 100%;\n    transition: all .28s ease-out;\n    margin-left: 180px;\n}\n", ""]);

// exports


/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
    sidebar: function sidebar(state) {
        return state.app.sidebar;
    },
    visitedViews: function visitedViews(state) {
        return state.app.visitedViews;
    },
    navbarData: function navbarData(state) {
        return state.app.navbarData;
    },
    token: function token(state) {
        return state.user.token;
    },
    avatar: function avatar(state) {
        return state.user.avatar;
    },
    name: function name(state) {
        return state.user.name;
    },
    roles: function roles(state) {
        return state.user.roles;
    },
    guid: function guid(state) {
        return state.user.agent_guid;
    },
    appSysTime: function appSysTime(state) {
        return state.app.systemTime;
    },
    examineRemind: function examineRemind(state) {
        return state.app.examineRemind;
    },
    whiteListType: function whiteListType(state) {
        return state.app.whiteListType;
    },
    auditShopInfo: function auditShopInfo(state) {
        return state.app.auditShopInfo;
    },
    permissions: function permissions(state) {
        return state.user.permissions;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "V8LJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pack__ = __webpack_require__("xPWx");



// node websocket module
// var WebSocket = require('ws');
// proto定义和接口
var proto = __webpack_require__("0Gq2");
// 发包解包工具


var MSG_WS_CMD_HEART_BEAT = 1; // 心跳处理
var MSG_WS_CMD_COMM_MSG = 2; // 通用消息收发
var MSG_WS_CMD_BIND = 3; // 绑定信息
var MSG_WS_CMD_AUTH_KEY = 4; // key 方式 鉴权


// ----------- File 4 client lib ----------- 
var MsgWsClient = {
    ws: null,
    hasInit: false,
    hbIntervalId: 0,
    sendWaitQueue: new Array(),

    conf: {
        proto: "ws",
        host: "",
        port: "",
        path: "",
        authSys: "",
        authKey: "",
        toBindMap: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(),
        onOpen: null,
        onMessage: null,
        onClose: null,
        onError: null,
        onSendSuccess: null,
        onSendFail: null,
        bzMsgDealerMap: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(),
        debug: false
    },

    init: function init(confData) {
        this.conf = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.conf, confData);
        this.hasInit = true;
    },

    startRun: function startRun() {
        if (!this.hasInit) {
            console.log("not init error");
            return;
        }
        var connAddr = this.conf.proto + "://" + this.conf.host + ":" + this.conf.port + this.conf.path;
        console.log("wsaddr:" + connAddr);
        this.ws = new WebSocket(connAddr);

        var that = this;

        this.ws.onopen = function () {
            that.ws.binaryType = 'arraybuffer'; // must

            if (that.conf.onOpen) {
                that.conf.onOpen();
            }

            // send auth
            that.sendAuth();
            // send all bind
            that.sendBinds();

            // send waiting queue
            if (that.sendWaitQueue.length > 0) {
                // just wait auth and binds...
                setTimeout(function () {
                    var copyWaitQueue = that.sendWaitQueue.slice();
                    that.sendWaitQueue = new Array();
                    for (var i = 0; i < copyWaitQueue.length; i++) {
                        that.sendBytes(copyWaitQueue[i]);
                    }
                }, 1000);
            }

            //start heart beat
            if (that.hbIntervalId) {
                clearInterval(that.hbIntervalId);
            }
            that.hbIntervalId = setInterval(function () {
                that.sendHeartBeat();
            }, 5000);
            console.log("ws has closed, wait for reconnect...");
        };

        this.ws.onmessage = function (evt) {
            if (that.conf.onMessage) {
                that.conf.onMessage();
            }
            var packet = __WEBPACK_IMPORTED_MODULE_3__pack__["a" /* default */].MsgSvrPacker.unpack(evt.data);
            if (packet.H_Cmd == MSG_WS_CMD_COMM_MSG && packet.H_Version == 1) {
                var msg = proto.Msg.deserializeBinary(packet.PayloadBody);
                if (that.conf.bzMsgDealerMap && that.conf.bzMsgDealerMap.has(msg.getBzid())) {
                    that.conf.bzMsgDealerMap.get(msg.getBzid())(msg);
                }
            }
        };

        this.ws.onclose = function () {
            if (that.conf.onClose) {
                that.conf.onClose();
            }
            setTimeout(function () {
                that.startRun();
            }, 2000);
        };

        this.ws.onerror = function (event) {
            console.log("WS connect Error");
            if (that.conf.onError) {
                that.conf.onError();
            }
        };
    },

    sendBytes: function sendBytes(uint8ArrBuf) {
        var needSaveFail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (this.ws.readyState == WebSocket.OPEN) {
            this.ws.send(uint8ArrBuf);
            if (this.conf.onSendSuccess) {
                this.conf.onSendSuccess();
            }
        } else {
            if (needSaveFail) {
                this.sendWaitQueue.push(uint8ArrBuf);
            } else {
                console.log(this.ws.readyState);
                console.log("send fail.ws state not open");
            }

            if (this.conf.onSendFail) {
                this.conf.onSendFail();
            }
        }
    },

    sendAuth: function sendAuth(key) {
        var authKey = key;
        if (!authKey) {
            authKey = this.conf.authKey;
        }
        if (!authKey) {
            return;
        }
        var authKeyReq = new proto.AuthKeyReq();
        authKeyReq.setKey(authKey);
        this.sendBytes(__WEBPACK_IMPORTED_MODULE_3__pack__["a" /* default */].MsgSvrPacker.pack(1, MSG_WS_CMD_AUTH_KEY, authKeyReq.serializeBinary()));
    },

    sendBinds: function sendBinds(bindMap) {
        var toBind = bindMap;
        if (!toBind || toBind.length == 0) {
            toBind = this.conf.toBindMap;
        }
        if (!toBind || toBind.length == 0) {
            return;
        }

        // 处理所有的绑定请求
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(toBind.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var bzIdKey = _step.value;

                // 补充bind
                if (!this.conf.toBindMap.has(bzIdKey)) {
                    this.conf.toBindMap.set(bzIdKey, snAtGroup);
                }

                var bindEndPoint = this.makeFromEndPointByBindKey(bzIdKey);
                if (!bindEndPoint) {
                    continue;
                }

                var bindReq = new proto.BindReq();
                bindReq.setTobindbzid(bzIdKey);
                bindReq.setOp("bind");
                bindReq.setBindendpoint(bindEndPoint);
                //console.log(bindReq.serializeBinary());
                this.sendBytes(__WEBPACK_IMPORTED_MODULE_3__pack__["a" /* default */].MsgSvrPacker.pack(1, MSG_WS_CMD_BIND, bindReq.serializeBinary()));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    },

    sendHeartBeat: function sendHeartBeat() {
        var hbReq = this.sendBytes(__WEBPACK_IMPORTED_MODULE_3__pack__["a" /* default */].MsgSvrPacker.pack(1, MSG_WS_CMD_HEART_BEAT, null));
    },

    sendMsg: function sendMsg(bzId, op, bzDataStr, sendToStr) {
        if (!bzId || !op) {
            return;
        }

        // get group and sn to make endpoint
        var endPointFrom = this.makeFromEndPointByBindKey(bzId);
        var msg = new proto.Msg();
        msg.setBzid(bzId);
        msg.setOp(op);
        if (endPointFrom) {
            msg.setFrom(endPointFrom);
        }
        if (bzDataStr) {
            msg.setBzdata(bzDataStr);
        }
        if (sendToStr) {
            var toEndPoint = this.getEndPointObjByStr(sendToStr);
            if (toEndPoint) {
                msg.setTo(toEndPoint);
            }
        }
        this.sendBytes(__WEBPACK_IMPORTED_MODULE_3__pack__["a" /* default */].MsgSvrPacker.pack(1, MSG_WS_CMD_COMM_MSG, msg.serializeBinary()), true);
    },

    getEndPointObjByStr: function getEndPointObjByStr(str) {
        var rows = str.split("@");
        if (rows.length != 2 || !rows[0] || !rows[1]) {
            return null;
        }

        var endPoint = new proto.MsgEndPoint();
        endPoint.setGroup(rows[1]);
        endPoint.setSn(rows[0]);

        return endPoint;
    },

    makeFromEndPointByBindKey: function makeFromEndPointByBindKey(bzId) {
        if (!this.conf.toBindMap.has(bzId)) {
            return null;
        }

        var snAtGroup = this.conf.toBindMap.get(bzId);
        return this.getEndPointObjByStr(snAtGroup);
    }

    // module.exports.MsgWsClient = MsgWsClient;
};/* harmony default export */ __webpack_exports__["a"] = ({
    MsgWsClient: MsgWsClient
});

/***/ }),

/***/ "Vk+A":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("p9JE");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3476b114", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2bc943de\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2bc943de\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Vo7i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__env__ = __webpack_require__("yZtZ");







var PT = __WEBPACK_IMPORTED_MODULE_5__env__["a" /* default */].PT;

// 创建axios实例
var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    baseURL: PT.config.apiBaseUrl, // api的base_url
    timeout: 15000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(function (config) {
    if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.token) {
        config.headers['X-Token'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_auth__["a" /* getToken */])(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
}, function (error) {
    // Do something with request error
    console.log(error); // for debug
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// respone拦截器
service.interceptors.response.use(function (response) {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    var res = response.data;
    if (res.code !== 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({
            message: res.msg || '系统错误',
            type: 'error',
            duration: 5 * 1000
        });

        // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
        if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
            __WEBPACK_IMPORTED_MODULE_2_element_ui__["MessageBox"].confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('FedLogOut').then(function () {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                });
            });
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('error');
    } else {
        return response.data;
    }
}, function (error) {
    console.log('err' + error); // for debug
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
    });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ "WI2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.iconName
    }
  })])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5e617bba", esExports)
  }
}

/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__env__ = __webpack_require__("yZtZ");







var PT = __WEBPACK_IMPORTED_MODULE_5__env__["a" /* default */].PT;
var app = {
    state: {
        sidebar: {
            opened: !+__WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('sidebarStatus')
        },
        visitedViews: [],
        navbarData: {
            name: "mike",
            age: 24
        },
        systemTime: '',
        examineRemind: 0, //审核消息
        whiteListType: true, //审核 白名单状态
        auditShopInfo: 0 // 待审核门店
    },
    mutations: {
        // 审核 通知
        SET_EXAMINE_REMIND: function SET_EXAMINE_REMIND(state, view) {
            state.examineRemind = view;
        },
        //审核 是否白名单
        SET_WHITE_LIST_TYPE: function SET_WHITE_LIST_TYPE(state, view) {
            state.whiteListType = view;
        },
        TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
            if (state.sidebar.opened) {
                __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('sidebarStatus', 1);
            } else {
                __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('sidebarStatus', 0);
            }
            state.sidebar.opened = !state.sidebar.opened;
        },
        ADD_VISITED_VIEWS: function ADD_VISITED_VIEWS(state, view) {
            if (state.visitedViews.some(function (v) {
                return v.path === view.path;
            })) return;
            state.visitedViews.push({ name: view.name, path: view.path });
        },
        DEL_VISITED_VIEWS: function DEL_VISITED_VIEWS(state, view) {
            var index = void 0;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.visitedViews.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref = _step.value;

                    var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                    var i = _ref2[0];
                    var v = _ref2[1];

                    if (v.path === view.path) {
                        index = i;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            state.visitedViews.splice(index, 1);
        },
        GET_NAVBAR_DATA: function GET_NAVBAR_DATA(state, view) {
            state.navbarData = view;
        },
        SET_AUDIT_SHOP_INFO: function SET_AUDIT_SHOP_INFO(state, view) {
            state.auditShopInfo = view;
        }
    },
    actions: {
        //审核消息 提醒
        getExamineRemind: function getExamineRemind(_ref3) {
            var commit = _ref3.commit,
                rootState = _ref3.rootState;

            var agent_guid = rootState.user.agent_guid;
            if (!agent_guid) return;
            var parame = {
                qnbar_agent_sn: agent_guid,
                search_begin_time: '',
                search_end_time: '',
                audit_status: 3,
                keyword: '',
                page: 1,
                page_size: 15
            };
            PT.apiClient.query("/agent/interface/audit/list", parame, function (rsp) {
                console.log('审核消息', rsp);
                var num = rsp.data.total;

                commit('SET_EXAMINE_REMIND', num);
            });
        },

        //审核白名单状态
        getWhiteListType: function getWhiteListType(_ref4) {
            var commit = _ref4.commit,
                rootState = _ref4.rootState;

            var user_type = rootState.user.user_type;
            if (!user_type) return;
            if (user_type === 'official_staff') {
                console.log('审核白名单oss权限');
                return commit('SET_WHITE_LIST_TYPE', true);
            }
            var parame = {
                guid: rootState.user.agent_guid
            };
            PT.apiClient.query("/bz-oss/interface/audit/whitelist/check", parame, function (rsp) {
                console.log('审核白名单', rsp);
                var type = rsp.data[0];

                commit('SET_WHITE_LIST_TYPE', type);
            });
        },
        ToggleSideBar: function ToggleSideBar(_ref5) {
            var commit = _ref5.commit;

            commit('TOGGLE_SIDEBAR');
        },
        addVisitedViews: function addVisitedViews(_ref6, view) {
            var commit = _ref6.commit;

            commit('ADD_VISITED_VIEWS', view);
        },
        delVisitedViews: function delVisitedViews(_ref7, view) {
            var commit = _ref7.commit,
                state = _ref7.state;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                commit('DEL_VISITED_VIEWS', view);
                resolve([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.visitedViews)));
            });
        },
        getNavbarData: function getNavbarData(_ref8, view) {
            var commit = _ref8.commit;

            commit('GET_NAVBAR_DATA', view);
        },

        // 获取待审核门店信息
        getAuditShopInfo: function getAuditShopInfo(_ref9) {
            var commit = _ref9.commit;

            var parame = {};
            PT.apiClient.query("/agent/store/storeStatusCount", parame, function (rsp) {
                console.log('待审核门店', rsp);
                var num = rsp.data.filter(function (item) {
                    return item.check_status == '1';
                }).map(function (item) {
                    return item.count;
                })[0] - 0;
                console.log(num);
                commit('SET_AUDIT_SHOP_INFO', num);
            });
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (app);

/***/ }),

/***/ "WmEM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.app-levelbar.el-breadcrumb[data-v-27592aaa] {\n  display: inline-block;\n  font-size: 14px;\n  line-height: 50px;\n  margin-left: 10px;\n}\n.app-levelbar.el-breadcrumb .no-redirect[data-v-27592aaa] {\n    color: #97a8be;\n    cursor: text;\n}\n", ""]);

// exports


/***/ }),

/***/ "XWx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        visitedViews: function visitedViews() {
            return this.$store.state.app.visitedViews.slice(-6);
        }
    },
    methods: {
        closeViewTabs: function closeViewTabs(view, $event) {
            var _this = this;

            this.$store.dispatch('delVisitedViews', view).then(function (views) {
                if (_this.isActive(view.path)) {
                    var latestView = views.slice(-1)[0];
                    if (latestView) {
                        _this.$router.push(latestView.path);
                    } else {
                        _this.$router.push('/');
                    }
                }
            });
            $event.preventDefault();
        },
        generateRoute: function generateRoute() {
            if (this.$route.name) {
                return this.$route;
            }
            return false;
        },
        addViewTabs: function addViewTabs() {
            var route = this.generateRoute();
            if (!route) {
                return false;
            }
            this.$store.dispatch('addVisitedViews', this.generateRoute());
        },
        isActive: function isActive(path) {
            return path === this.$route.path;
        }
    },
    watch: {
        $route: function $route() {
            this.addViewTabs();
        }
    }
});

/***/ }),

/***/ "XclO":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("q98q");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7eed151a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b93f3c44\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabsView.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b93f3c44\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabsView.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "XzKX":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("PInp");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("47ddae1d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-200e3c4e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-200e3c4e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "YPbV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__("kzJD");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__("DOpt");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Levelbar__ = __webpack_require__("N2mp");
/* unused harmony reexport Levelbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppMain__ = __webpack_require__("TAmc");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__AppMain__["default"]; });








/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constantRouterMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__ = __webpack_require__("AkUR");


var _import = __webpack_require__("A66B");
// in development env not use Lazy Loading,because Lazy Loading too many pages will cause webpack hot update too slow.so only in production use Lazy Loading

/*   */


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/**
 * icon : the icon show in the sidebar
 * hidden : if `hidden:true` will not show in the sidebar
 * redirect : if `redirect:noredirect` will not redirct in the levelbar
 * noDropdown : if `noDropdown:true` will not has submenu in the sidebar
 * meta : `{ role: ['admin'] }`  will control the page role
 **/
var constantRouterMap = [{ path: '/404', component: _import('404'), hidden: true },
// 首页默认跳转
// {
//     path: '/',
//     component: Layout,
//     redirect: '/description/index',
//     name: 'description',
//     hidden: true,
//     children: [{ path: 'index', component: _import(newFunction()) }]
// },
// {
//     path: '/description',
//     component: Layout,
//     redirect: '/description/index',
//     icon: 'description',
//     noDropdown: true,
//     children: [{ path: 'index', name: '说明补充', component: _import('description/description') }]
// },
// 收缩菜单
// {
//     path: '/store',
//     component: Layout,
//     redirect: 'noredirect',
//     name: '足浴酒店',
//     icon: 'store',
//     children: [
//         { path: 'storeMGR', name: '足浴酒店-门店管理', component: _import('store/storeMGR') },
//         { path: 'agentMGR', name: '足浴酒店-合作商表', component: _import('agent/agentMGR') },
//     ]
// },

// {
//     path: '/',
//     component: Layout,
//     redirect: '/storeMGR/index',
//     name: 'storeMGR',
//     icon: 'store',
//     hidden: true,
//     children: [{ path: 'index', component: _import("store/storeMGR") }]
// },
// // 单列菜单
// {
//     path: '/storeMGR',
//     component: Layout,
//     redirect: '/storeMGR/index',
//     icon: 'store',
//     noDropdown: true,
//     beforeEnter: (to, from, next) => {
//         if ((navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
//             // window.location.href="你的手机版地址";
//             next("/storeMgrPhone");
//         } else {
//             next();
//         }
//         // ...
//     },
//     children: [
// { path: 'index', name: '门店管理', component: _import('store/storeMGR') },
// { path: 'advertisement', name: '广告管理',hidden: true, component: _import('store/advertisement') },
// { path: 'details/:id', name: '门店详情', hidden: true, component: _import('store/details')},
// { path: 'addStore', name: '申请建店', hidden: true, component: _import('store/addStore')},
// { path: 'addDemoStore', name: '新增演示门店', hidden: true, component: _import('store/addDemoStore')},
// { path: 'previewApplyStore/:id', name: '门店信息', hidden: true, component: _import('store/previewApplyStore')},
// { path: 'editStore/:id', name: '编辑门店', hidden: true, component: _import('store/editStore')},
//     ]
// },

// 移动端门店管理
{
  path: '/storeMgrPhone',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__["default"],
  redirect: '/storeMgrPhone/index',
  icon: 'store',
  noDropdown: true,
  hidden: true,
  children: [{ path: 'index', name: '门店管理wap', component: _import('store/phone') }]
},
// 移动端门店序列号编辑
{
  path: '/phoneEdit',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__["default"],
  redirect: '/phoneEdit/index',
  icon: 'store',
  noDropdown: true,
  hidden: true,
  children: [{ path: 'index', name: '门店管理序列号编辑wap', component: _import('store/phone_edit') }]
},
// {
//     path: '/serialNumberMgt',
//     component: Layout,
//     redirect: 'noredirect',
//     name: '序列号',
//     icon: 'store',
//     children: [
//         { path: 'lists', name: '序列号列表', component: _import('serialNumberMgt/serialNumber') },
//         { path: 'active', name: '激活序列号', component: _import('serialNumberMgt/activeNumber') },
//     ]
// },

// {
//     path: '/serialNumberMgt',
//     component: Layout,
//     redirect: '/serialNumberMgt/index',
//     icon: 'icons',
//     noDropdown: true,
//     children: [{ path: 'index', name: 'PSN管理', component: _import('serialNumberMgt/serialNumber') }]
// },

// {
//     path: '/agentMGR',
//     component: Layout,
//     redirect: '/agentMGR/index',
//     icon: 'agent',
//     noDropdown: true,
//     children: [{ path: 'index', name: '合作商', component: _import('agent/agentMGR') }]
// },

// 路径错误，默认跳转地址
{
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__["default"],
  redirect: '/store/storeMGR',
  name: 'storeMGR*',
  hidden: true
}, {
  path: '/store',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__["default"],
  name: '门店管理',
  icon: 'store',
  meta: { permission: 'agent_store_manage' },
  children: [{ path: 'storeMGR', name: '门店管理', component: _import('store/storeMGR'), meta: { permission: 'agent_store' } }, { path: 'advertisement', name: '广告管理', hidden: true, component: _import('store/advertisement') }, { path: 'details/:id', name: '门店详情', hidden: true, component: _import('store/details') }, { path: 'addStore', name: '申请建店', hidden: true, component: _import('store/addStore') }, { path: 'addDemoStore', name: '新增演示门店', hidden: true, component: _import('store/addDemoStore') }, { path: 'previewApplyStore/:id', name: '门店信息', hidden: true, component: _import('store/previewApplyStore') }, { path: 'editStore/:id', name: '编辑门店', hidden: true, component: _import('store/editStore') }, { path: 'examine', name: '内容审核', component: _import('store/examine'), hidden: true }, { path: 'roleManagement', name: '角色管理', component: _import('store/roleManagement/index'), meta: { permission: 'agent_store1' } }, { path: 'staffManagement', name: '员工管理', component: _import('store/staffManagement/index'), meta: { permission: 'agent_store2' } }]
}, {
  path: '/memberManagement',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__["default"],
  icon: 'lease',
  name: '会员管理',
  meta: { permission: 'agent_member_manage' },
  children: [{
    path: 'qnFilm',
    name: '青柠电影',
    component: _import('memberManagement/qnFilm'),
    meta: { permission: 'agent_member_manage_qnFilm' }
  }, {
    path: 'qnFilmMember',
    name: '青柠电影',
    component: _import('memberManagement/qnFilmMember/index'),
    meta: { permission: 'agent_member_manage_qnFilm_tv' }
  }, {
    path: 'mango',
    name: '芒果TV',
    component: _import('memberManagement/mango/index'),
    meta: { permission: 'agent_member_manage_mangoTV' }
  }, {
    path: 'memberWorkOrder',
    name: '会员工单',
    component: _import('memberManagement/memberWorkOrder'),
    meta: { permission: 'agent_member_manage_workorder' }
  }, {
    path: '/memberManagement/authorization',
    name: '授权书',
    redirect: 'memberManagement/authorization/authorizationInApplication',
    noDropdown: true,
    component: _import('memberManagement/authorization'),
    meta: { permission: 'agent_member_manage_authorization' },
    children: [{
      path: 'authorizationComplete',
      name: '申请成功',
      component: _import('memberManagement/authorizationComplete')
    }, {
      path: 'authorizationInApplication',
      name: '申请中',
      component: _import('memberManagement/authorizationInApplication')
    }]
  }]
}, {
  path: '/EquipmentManagement',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__["default"],
  name: '设备管理',
  icon: 'store',
  meta: { permission: 'agent_device_manage' },
  children: [{
    path: 'serialNumberMgts',
    component: _import('EquipmentManagement/serialNumber/index'),
    name: 'PSN管理',
    meta: { permission: 'agent_device_manage_psn' }
  },
  // {
  //   path: 'PsnUsing',
  //   component: _import('EquipmentManagement/PSNUsings/index'),
  //   name: 'PSN使用'
  // },
  {
    path: '/monitoringManagement',
    component: _import("EquipmentManagement/index"),
    name: '监测管理',
    meta: { permission: 'agent_device_manage_monitoring' },
    children: [{
      name: '温度监测',
      path: '/EquipmentManagement/monitoringManagement',
      noDropdown: true,
      component: _import('EquipmentManagement/monitoringManagement/index'),
      redirect: '/EquipmentManagement/monitoringManagement/highTemperatureEquipment',
      meta: { permission: 'agent_device_manage_monitoring_temperature' },
      children: [{
        path: 'highTemperatureEquipment',
        component: _import('EquipmentManagement/monitoringManagement/highTemperatureEquipment'),
        hidden: true,
        name: '高温设备'
      }, {
        path: 'temperatureLog',
        component: _import('EquipmentManagement/monitoringManagement/temperatureLog'),
        name: '高温设备 / 高温日志'
      }, {
        path: 'temperatureDetails',
        component: _import('EquipmentManagement/monitoringManagement/temperatureDetails'),
        name: '高温设备 / 高温详情'
      }, {
        path: 'temperatureLogAll',
        component: _import('EquipmentManagement/monitoringManagement/temperatureLogAll'),
        hidden: true,
        name: '高温日志'
      }, {
        path: 'handleLog',
        component: _import('EquipmentManagement/monitoringManagement/handleLog'),
        hidden: true,
        name: '处理日志'
      }]
    }, {
      path: 'PsnUsing',
      component: _import('EquipmentManagement/PSNUsings/index'),
      name: '使用监测',
      meta: { permission: 'agent_device_manage_monitoring_area' }
    }]
  }]
}, {
  path: '/filmManagement',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__["default"],
  // redirect: 'filmManagement/MovieBlacklist',
  name: '电影管理',
  icon: 'lease',
  meta: { permission: 'agent_film_manage' },

  children: [{
    path: 'MovieBlacklist',
    component: _import('filmManagement/movieBlacklist'),
    name: '电影黑名单',
    meta: { permission: 'agent_film_manage_backlist' }

  }, {
    path: 'MovieWhitelist',
    component: _import('filmManagement/movieWhitelist'),
    name: '电影白名单',
    meta: { permission: 'agent_film_manage_whitelist' }

  }]
}, {
  path: '/updateManagement',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__["default"],
  // redirect: 'filmManagement/MovieBlacklist',
  name: '更新管理',
  icon: 'lease',
  meta: { permission: 'agent_update_manage' },

  children: [{
    path: 'GeneralSoftware',
    component: _import('updateManagement/generalSoftware'),
    name: '通用软件',
    meta: { permission: 'agent_general_software_server_software' }
  }, {
    path: 'GeneralSoftware/:sn/:id',
    component: _import('updateManagement/softwareStoreManagement'),
    name: '通用软件 / 门店管理',
    hidden: true
  }, {
    path: 'appDetails',
    component: _import('updateManagement/appDetails'),
    name: '通用软件 / 门店管理',
    hidden: true
  }]
}, {
  path: '/leaseManagement',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__["default"],
  // redirect: '/agent/agentMGR',
  name: '租赁管理',
  icon: 'lease',
  meta: { permission: 'agent_lease_manage' },

  children: [{
    path: '/lease',
    component: _import('leaseManagement/index'),
    name: '租赁管理1',
    meta: { permission: 'agent_lease_manage_one' },

    children: [{
      path: 'leaseAddInfo',
      component: _import('leaseManagement/lease/leaseAddInfo'),
      name: '租赁信息添加',
      meta: { permission: 'agent_lease_manage_one_list' }
    }, {
      path: 'leaseInfoCheck',
      component: _import('leaseManagement/lease/leaseInfoCheck'),
      name: '租赁数据查看',
      hidden: true
    }, {
      path: 'deviceInfo',
      component: _import('leaseManagement/lease/deviceInfo'),
      name: '租赁数据查看 / 租赁设备信息',
      hidden: true
    }]
  }, {
    path: '/lease2',
    component: _import('leaseManagement/index'),
    name: '租赁管理2',
    meta: { permission: 'agent_lease_manage_two' },

    children: [{
      path: 'hotel',
      component: _import('leaseManagement/lease2/hotel/index'),
      name: '租赁门店',
      meta: { permission: 'agent_lease_manage_two_store' }
    }, {
      path: 'device',
      component: _import('leaseManagement/lease2/device/index'),
      name: '租赁设备',
      meta: { permission: 'agent_lease_manage_two_device' }
    }, {
      path: 'payRecord',
      component: _import('leaseManagement/lease2/payRecord/index'),
      name: '购买记录',
      meta: { permission: 'agent_lease_manage_two_purchase_record' }
    }, {
      path: 'disbuteRecords',
      component: _import('leaseManagement/lease2/disbuteRecords/index'),
      name: '分发记录',
      meta: { permission: 'agent_lease_manage_two_distribution_record' }
    }, {
      path: 'useRecord',
      component: _import('leaseManagement/lease2/useRecord/index'),
      name: '使用详情',
      meta: { permission: 'agent_lease_manage_two_usage_record' }
    }, {
      path: 'useDetailList/:id',
      component: _import('leaseManagement/lease2/useDetailList/index'),
      name: '使用详情 / 详情',
      hidden: true
    }]
  }, {
    path: '/lease3',
    component: _import('leaseManagement/index'),
    name: '租赁管理3',
    meta: { permission: 'agent_lease_manage_three' },

    children: [{
      path: 'openStore',
      component: _import('leaseManagement/lease3/openStore'),
      name: '开通门店',
      meta: { permission: 'agent_lease_manage_three_open_store' }
    }, {
      path: 'dataStatistics',
      component: _import('leaseManagement/lease3/dataStatistics'),
      name: '数据统计',
      meta: { permission: 'agent_lease_manage_three_report' }
    }, {
      path: 'dataStatisticsDetails',
      component: _import('leaseManagement/lease3/dataStatisticsDetails'),
      name: '数据统计 / 查看',
      hidden: true
    }]
  }]
}, {
  path: '/gameManager',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__["default"],
  name: '游戏管理',
  icon: 'tubiao',
  meta: { permission: 'agent_game_manage' },
  children: [{
    path: 'flowOrder',
    component: _import('gameManager/flowOrder'),
    name: '订单管理',
    meta: { permission: 'agent_game_order_manage' }
  }]
}, {
  path: '/settle',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__["default"],
  redirect: '/settle/recordList',
  icon: 'tubiao',
  noDropdown: true,
  hidden: true,
  children: [{
    path: 'recordList',
    name: '结算详情',
    component: _import('settle/recordList/index'),
    hidden: true
  }, {
    path: 'orderList/:id',
    name: '结算详情 / 订单',
    component: _import('settle/orderList/index'),
    hidden: true
  }]
}, {
  path: '/helpCenter',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__["default"],
  icon: 'helpCenter',
  name: '帮助中心',
  meta: { permission: 'agent_support_enter' },
  children: [{
    path: 'sharedFiles',
    name: '共享文件',
    component: _import('helpCenter/shareFiles/index'),
    meta: { permission: 'agent_support_enter_shared_files' }
  }, {
    path: 'techDocument',
    name: '共享文件 / 技术文档',
    component: _import('helpCenter/techDocument/index'),
    hidden: true
  }]
}, {
  path: '/afterSalesManage',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__["default"],
  icon: 'helpCenter',
  name: '售后管理',
  meta: { permission: 'agent_after_sales_manage' },
  children: [{
    path: 'exchangeGoods',
    name: '售后换货',
    component: _import('afterSalesManage/exchange/index'),
    meta: { permission: 'agent_after_sales_exchange' }
  }, {
    path: 'exchangeDetails',
    name: '售后换货 / 详情',
    component: _import('afterSalesManage/exchange/details'),
    hidden: true
  },
  // {
  //   path: 'repairOrder',
  //   name: '维修工单',
  //   component: _import('afterSalesManage/repairOrder/index'),
  //   meta: 'repair_order'
  // },
  {
    path: 'ReturnVisitService',
    name: '回访记录',
    component: _import('afterSalesManage/ReturnVisitService/index'),
    meta: { permission: 'agent_return_visit_record' }

  },
  // {
  //   path: 'repairOrderAdd',
  //   name: '维修工单 / 新增维修',
  //   component: _import('afterSalesManage/repairOrder/addMaintenance'),
  //   hidden: true
  // },
  // {
  //   path: 'repairOrderDetail',
  //   name: '维修工单 / 工单详情',
  //   component: _import('afterSalesManage/repairOrder/detailOrder'),
  //   hidden: true
  // },
  {
    path: 'NewReturnVisi',
    name: '回访记录 / 新增回访',
    component: _import('afterSalesManage/NewReturnVisi/index'),
    hidden: true
  }, {
    path: 'ReturnVisitDetails',
    name: '回访记录 / 回访详情',
    component: _import('afterSalesManage/ReturnVisitDetails/index'),
    hidden: true
  }, {
    path: 'BorrowMachineSystem',
    name: '借机系统',
    component: _import('afterSalesManage/BorrowMachineSystem/index'),
    meta: { permission: 'agent_borrowing_machine_manage' }

  }, {
    path: 'BorrowMachinePact',
    name: '借机协议',
    component: _import('afterSalesManage/BorrowMachineSystem/BorrowMachinePact/index'),
    hidden: true
  }, {
    path: 'AddApplication',
    name: '借机服务',
    component: _import('afterSalesManage/BorrowMachineSystem/AddApplication'),
    hidden: true
  }, {
    path: 'PaymentTransfer',
    name: '借机服务 ',
    component: _import('afterSalesManage/BorrowMachineSystem/PaymentTransfer'),
    hidden: true
  }, {
    path: 'ThroughDetails',
    name: '借机详情',
    component: _import('afterSalesManage/BorrowMachineSystem/BorrworderDetails/index'),
    hidden: true
  }, {
    path: 'ReturnEquipment',
    name: '借机服务 / 归还设备',
    component: _import('afterSalesManage/BorrowMachineSystem/ReturnEquipmentOperation/index'),
    hidden: true
  }, {
    path: 'afterSalesMaintenance',
    name: '售后维修',
    component: _import('afterSalesManage/afterSalesMaintenance/index'),
    meta: { permission: 'agent_after_sales_maintenance' }

  }, {
    path: 'MaintenanceDetails/:id',
    name: '售后维修 / 维修详情',
    component: _import('afterSalesManage/afterSalesMaintenance/MaintenanceDetails/index'),
    hidden: true
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history', //后端支持可开
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: constantRouterMap
}));

/***/ }),

/***/ "aacO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['examineRemind', 'auditShopInfo', 'permissions'])),
  methods: {
    hasPermission: function hasPermission(item) {
      if (item.meta && item.meta.permission) {
        var perms = this.permissions || [];
        return perms.includes(item.meta.permission);
      }
      return true;
    }
  },
  mounted: function mounted() {
    console.log(this.routes, '处理理由');
  }
});

/***/ }),

/***/ "afte":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_screenfull__ = __webpack_require__("I95x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_screenfull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_screenfull__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hamburger',
  props: {
    width: {
      type: Number,
      default: 22
    },
    height: {
      type: Number,
      default: 22
    },
    fill: {
      type: String,
      default: '#48576a'
    }
  },
  data: function data() {
    return {
      isFullscreen: false
    };
  },

  methods: {
    click: function click() {
      if (!__WEBPACK_IMPORTED_MODULE_0_screenfull___default.a.enabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        });
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_0_screenfull___default.a.toggle();
    }
  }
});

/***/ }),

/***/ "aret":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout__ = __webpack_require__("YPbV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("0xDb");
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'layout',
    data: function data() {
        return {
            showLayout: false
        };
    },
    components: {
        Navbar: __WEBPACK_IMPORTED_MODULE_0__views_layout__["a" /* Navbar */],
        Sidebar: __WEBPACK_IMPORTED_MODULE_0__views_layout__["b" /* Sidebar */],
        AppMain: __WEBPACK_IMPORTED_MODULE_0__views_layout__["c" /* AppMain */]
    },
    created: function created() {
        this.getLeaseKeysNotify();
    },

    mounted: function mounted() {
        var self = this;
        self.checkIsPhone();
    },
    computed: {
        sidebar: function sidebar() {
            return this.$store.state.app.sidebar;
        }
    },
    methods: {
        checkIsPhone: function checkIsPhone() {
            var self = this;
            if (navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
                self.showLayout = true;
                // $(".main-container").css("marginLeft","0");
            } else {
                self.showLayout = true;
            }
        },
        toggleSidebar: function toggleSidebar() {
            if (!this.$store.state.app.sidebar.opened) {
                // 修改vuex中silder_bar的值
                this.$store.commit('TOGGLE_SIDEBAR');
            }
        },
        leaseKeysAlert: function leaseKeysAlert() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* agencyQnbarRequest */])('leaseKeysAlert');
        },
        getLeaseKeysNotify: function getLeaseKeysNotify() {
            var _this = this;

            this.leaseKeysAlert().then(function (res) {
                var infoList = res.data;
                var h = _this.$createElement;
                infoList.forEach(function (info) {
                    var message = h('div', { style: 'margin: 0' }, [h('p', { style: 'margin: 0' }, '\u95E8\u5E97\uFF1A' + info.store_name), h('p', { style: 'margin: 0' }, ['可用密钥预计不足', h('span', { style: 'color: red' }, ' ' + info.days + ' '), '天使用，请通知门店购买'])]);
                    setTimeout(function () {
                        _this.$notify.info({
                            title: '温馨提示',
                            message: message,
                            duration: 0
                        });
                    }, 100); // 不用定时任务，显示会重叠，预计是计算高度时还未渲染完成
                });
            });
        }
    }
});

/***/ }),

/***/ "bFqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "mode": "vertical",
      "theme": "dark",
      "unique-opened": "",
      "default-active": _vm.$route.path
    }
  }, [_c('div', {
    class: {
      'logo-name': _vm.sidebar.opened, 'logo-img': !_vm.sidebar.opened
    }
  }, [(_vm.sidebar.opened) ? _c('span', [_vm._v("青柠微影合作商后台系统")]) : _vm._e(), _vm._v(" "), (!_vm.sidebar.opened) ? _c('span', [_c('img', {
    staticClass: "logoImage",
    attrs: {
      "src": __webpack_require__("6PsS"),
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('sidebar-item', {
    attrs: {
      "routes": _vm.myRoutes
    }
  })], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2bc943de", esExports)
  }
}

/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_login__ = __webpack_require__("M9A7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__env__ = __webpack_require__("yZtZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vendor_qnbar_qnpermission__ = __webpack_require__("rGfR");







var userInfo = null;
try {
    userInfo = JSON.parse(localStorage.getItem('user_data'));
} catch (e) {
    throw Error('user_data解析出错');
}

var user = {
    state: {
        token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["a" /* getToken */])(),
        name: '',
        avatar: '',
        roles: [],
        agent_guid: '',
        agent_name: '',
        guid: '',
        official_staff_guid: '',
        official_staff_name: '',
        user_type: '',
        permissions: []
    },

    mutations: {
        SET_TOKEN: function SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_NAME: function SET_NAME(state, name) {
            state.name = name;
        },
        SET_AVATAR: function SET_AVATAR(state, avatar) {
            state.avatar = avatar;
        },
        SET_ROLES: function SET_ROLES(state, roles) {
            state.roles = roles;
        },
        SET_DATA: function SET_DATA(state, data) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, data);
        },
        SET_PERMISSIONS: function SET_PERMISSIONS(state, permissions) {
            state.permissions = permissions;
        }
    },

    actions: {
        // 登录 (保持现状，项目主要走 SSO)
        Login: function Login(_ref, userInfo) {
            var commit = _ref.commit;

            var username = userInfo.username.trim();
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_login__["a" /* login */])(username, userInfo.password).then(function (response) {
                    var data = response.data;
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["b" /* setToken */])(data.token);
                    commit('SET_TOKEN', data.token);
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            });
        },


        // 获取用户信息
        GetInfo: function GetInfo(_ref2) {
            var commit = _ref2.commit,
                state = _ref2.state;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var PT = __WEBPACK_IMPORTED_MODULE_4__env__["a" /* default */].PT;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_login__["b" /* getInfo */])(state.token).then(function (response) {
                    var data = response.data;
                    if (!data) {
                        reject('获取用户信息失败');
                        return;
                    }
                    // 对齐业务字段：agent_name -> name, agent_guid -> guid
                    commit('SET_DATA', data);
                    commit('SET_NAME', data.agent_name || data.name || '');
                    commit('SET_AVATAR', data.avatar || '');

                    // 获取全量权限 (每次都从接口拉取，不缓存)
                    var PermissionChecker = new __WEBPACK_IMPORTED_MODULE_5__vendor_qnbar_qnpermission__["a" /* default */].PermissionChecker();
                    var localSess = PT.qnlogin.getLocalSess();
                    PermissionChecker.queryAllPermissions(PT.apiClient, PT.config.platformUsagespace, localSess, function (pMsg) {
                        var permissions = pMsg.data || [];
                        commit('SET_PERMISSIONS', permissions);
                        commit('SET_ROLES', ['admin']);
                        // queryAllPermissions 内部会将 blocked 重新设为 true，需释放阻塞队列
                        PT.apiClient.resumeQuery();
                        resolve(response);
                    }, function (pMsg) {
                        commit('SET_ROLES', ['admin']);
                        PT.apiClient.resumeQuery();
                        resolve(response);
                    });
                }).catch(function (error) {
                    reject(error);
                });
            });
        },


        // 登出
        LogOut: function LogOut(_ref3) {
            var commit = _ref3.commit,
                state = _ref3.state;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_login__["c" /* logout */])(state.token).then(function () {
                    commit('SET_TOKEN', '');
                    commit('SET_ROLES', []);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["c" /* removeToken */])();
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            });
        },


        // 前端 登出
        FedLogOut: function FedLogOut(_ref4) {
            var commit = _ref4.commit;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                commit('SET_TOKEN', '');
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["c" /* removeToken */])();
                resolve();
            });
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),

/***/ "cOJy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "icon screenfull",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "t": "1497503607356",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "p-id": "4109",
      "fill": _vm.fill,
      "width": _vm.width,
      "height": _vm.height
    },
    on: {
      "click": _vm.click
    }
  }, [_c('path', {
    attrs: {
      "d": "M604.157933 512l204.484208 204.484208 82.942037-82.942037c10.364045-10.952446 26.498514-13.83817 40.309054-8.067746 13.249769 5.742794 22.465664 18.99154 22.465664 33.977859l0 258.042008c0 20.168342-16.695241 36.863582-36.863582 36.863582L659.452283 954.357873c-14.986319 0-28.236088-9.215896-33.977859-23.025413-5.770424-13.249769-2.885723-29.384237 8.067746-39.748283l82.942037-82.942037L512 604.157933 307.515792 808.642141l82.942037 82.942037c10.952446 10.364045 13.83817 26.498514 8.067746 39.748283-5.742794 13.809517-18.99154 23.025413-33.977859 23.025413L106.504686 954.357873c-20.168342 0-36.863582-16.695241-36.863582-36.863582L69.641103 659.452283c0-14.986319 9.215896-28.236088 23.025413-33.977859 13.249769-5.770424 29.384237-2.8847 39.748283 8.067746l82.942037 82.942037 204.484208-204.484208L215.357859 307.515792l-82.942037 82.942037c-6.890944 6.918573-16.10684 10.952446-25.911136 10.952446-4.593622 0-9.804297-1.14815-13.83817-2.8847-13.809517-5.742794-23.025413-18.99154-23.025413-33.977859L69.641103 106.504686c0-20.168342 16.695241-36.863582 36.863582-36.863582L364.546693 69.641103c14.986319 0 28.236088 9.215896 33.977859 23.025413 5.770424 13.249769 2.8847 29.384237-8.067746 39.748283l-82.942037 82.942037 204.484208 204.484208L716.484208 215.357859l-82.942037-82.942037c-10.952446-10.364045-13.83817-26.498514-8.067746-39.748283 5.742794-13.809517 18.99154-23.025413 33.977859-23.025413l258.042008 0c20.168342 0 36.863582 16.695241 36.863582 36.863582l0 258.042008c0 14.986319-9.215896 28.236088-22.465664 33.977859-4.593622 1.736551-9.804297 2.8847-14.397918 2.8847-9.804297 0-19.020192-4.033873-25.911136-10.952446l-82.942037-82.942037L604.157933 512z",
      "p-id": "4110"
    }
  })])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-200e3c4e", esExports)
  }
}

/***/ }),

/***/ "dahE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("SM0Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df96aa28_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("l0Uw");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("/qC1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-df96aa28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df96aa28_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Hamburger/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-df96aa28", Component.options)
  } else {
    hotAPI.reload("data-v-df96aa28", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "effA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.i(__webpack_require__("JdRO"), "");

// module
exports.push([module.i, "\n.el-upload input[type=\"file\"] {\n  display: none !important;\n}\n.el-upload__input {\n  display: none;\n}\n.el-dialog {\n  transform: none;\n  left: 0;\n  position: relative;\n  margin: 0 auto;\n}\n.upload-container .el-upload {\n  width: 100%;\n}\n.upload-container .el-upload .el-upload-dragger {\n    width: 100%;\n    height: 200px;\n}\n.navigation .el-table td,\n.navigation .el-table th {\n  padding: 0 !important;\n}\n.navigation .el-table th > .cell {\n  text-align: center;\n}\n.navigation .el-table .cell,\n.navigation .el-table th > div {\n  padding: 0 !important;\n  text-align: center;\n}\n.navigation .pass .el-dialog--small {\n  width: 28%;\n}\n.botttomform .el-input__inner {\n  margin-bottom: 20px !important;\n}\n.bottomone .el-input,\n.bottomone .el-input__inner {\n  width: 100% !important;\n}\n.bottomone .el-form-item {\n  display: inline-block !important;\n  margin-left: 9px;\n  width: 35%;\n}\n.bottomone .el-form-item__content {\n  margin-left: 0 !important;\n}\n.el-table .cell .setoverflow {\n  display: block;\n  width: 120px;\n  height: 24px !important;\n  overflow: hidden !important;\n  margin: auto !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n.link {\n  color: #1c8de0 !important;\n}\n.link:hover {\n    color: #1c94ea !important;\n}\n.tip {\n  margin: 0;\n  line-height: 1.5;\n  font-size: 12px;\n  color: #ccc;\n}\n.show-info {\n  margin: 0;\n  padding: 3px 10px;\n  height: 36px;\n  background-color: #eef1f6;\n  border-radius: 4px;\n  border: 1px solid #d1dbe5;\n  box-sizing: border-box;\n  font-size: inherit;\n  color: #bbb;\n  line-height: 28px;\n  outline: 0;\n}\nbody {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;\n}\nhtml {\n  box-sizing: border-box;\n}\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\na:focus,\na:active {\n  outline: none;\n}\na,\na:focus,\na:hover {\n  cursor: pointer;\n  color: inherit;\n  text-decoration: none;\n}\n.clearfix:after {\n  visibility: hidden;\n  display: block;\n  font-size: 0;\n  content: \" \";\n  clear: both;\n  height: 0;\n}\n.fade-enter-active,\n.fade-leave-active {\n  transition: all .2s ease;\n}\n.fade-enter,\n.fade-leave-active {\n  opacity: 0;\n}\n.app-main {\n  min-height: 100%;\n}\n.app-container {\n  padding: 20px;\n}\n.svg-icon {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n.red {\n  color: red;\n}\n.text-center {\n  text-align: center;\n}\n.pull-left {\n  float: left;\n}\n.pull-right {\n  float: right;\n}\n", ""]);

// exports


/***/ }),

/***/ "fK1T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-lease",
  "use": "icon-lease-usage",
  "viewBox": "0 0 1280 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1280 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-lease\"><defs><style type=\"text/css\"></style></defs><path d=\"M546.181006 571.351955v-21.309497h64.643575V504.849162h-64.643575v-69.649162c21.738547-4.43352 42.905028-9.439106 63.070391-14.873743l-16.303911-43.763129c-48.339665 15.44581-103.115084 25.886034-165.184358 31.320671l9.439107 42.189944c21.738547-2.002235 42.475978-4.43352 62.64134-7.436871V504.849162h-73.939664v45.193296h69.077095c-17.305028 51.2-44.907263 97.394413-82.806704 138.726257l19.164245 49.197765c27.602235-35.32514 50.77095-74.511732 68.505028-117.84581V832.357542h46.337431V619.119553c12.299441 15.44581 27.173184 35.32514 43.906145 60.210056l25.6-39.758659c-23.168715-24.884916-46.33743-47.338547-69.506145-68.218995z\" fill=\"#cdcdcd\" p-id=\"1644\" /><path d=\"M832.786592 391.436872h-198.793296v379.280446h-42.905028v45.193297h279.597766v-45.193297h-38.042459V391.436872h0.143017z m-46.909497 379.280446H679.329609v-83.521787h106.547486v83.521787z m0-127.713966H679.329609v-82.949721h106.547486v82.949721z m0-127.284916H679.329609v-80.089386h106.547486v80.089386z\" fill=\"#cdcdcd\" p-id=\"1645\" /><path d=\"M1255.401117 45.193296h-171.620111C1075.62905 19.021229 1051.173184 0 1022.283799 0c-29.890503 0-54.918436 20.30838-62.212291 47.910615-3.289385-1.716201-7.007821-2.717318-11.01229-2.717319H778.011173c-13.300559 0-24.026816 10.726257-24.026815 24.026816s10.726257 24.026816 24.026815 24.026815h171.191062c4.576536 0 8.867039-1.287151 12.442458-3.575419 6.721788 19.307263 22.310615 34.467039 41.90391 40.473743-0.143017 0.858101-0.143017 1.859218-0.143016 2.717319v48.625698c0 1.001117 0.143017 1.859218 0.286033 2.860335-26.315084 8.151955-45.336313 32.607821-45.336313 61.497207h-72.509497c-4.290503 0-8.294972 2.145251-11.727374 5.72067-65.930726-43.763128-144.732961-69.363128-229.5419-69.363128-83.950838 0-162.181006 25.027933-227.682681 68.075978-3.289385-2.860335-6.864804-4.43352-10.726257-4.43352h-78.659218c0-27.745251-17.591061-51.343017-42.046927-60.353073 0.143017-1.287151 0.286034-2.574302 0.286033-4.004469v-48.625698c0-1.287151-0.143017-2.574302-0.286033-3.861453 17.305028-6.435754 31.034637-20.022346 37.756424-37.184357 2.431285 0.858101 5.005587 1.287151 7.722905 1.287151h171.191062c13.300559 0 24.026816-10.726257 24.026815-24.026816s-10.726257-24.026816-24.026815-24.026816h-171.620112c-2.145251 0-4.147486 0.286034-6.149721 0.858101C316.496089 19.450279 291.897207 0 262.721788 0c-29.175419 0-53.774302 19.307263-61.640224 45.90838-1.859218-0.42905-3.718436-0.715084-5.72067-0.715084H24.169832C10.869274 45.193296 0.143017 55.919553 0.143017 69.220112s10.726257 24.026816 24.026815 24.026815h171.191062c2.574302 0 5.148603-0.42905 7.436871-1.144134 6.292737 16.303911 19.021229 29.318436 35.182123 36.040224-0.286034 1.573184-0.572067 3.289385-0.572067 4.86257v48.625698c0 1.716201 0.143017 3.289385 0.572067 5.005587-23.168715 9.72514-39.472626 32.607821-39.472625 59.351955v54.203352c0 35.611173 28.746369 64.357542 64.357541 64.357542 22.024581 0 41.331844-11.012291 53.059218-27.888268 1.001117 1.001117 2.002235 2.002235 3.146369 2.717318-57.635754 72.080447-92.102793 163.75419-92.102793 263.579888 0 232.259218 186.922905 420.612291 417.322905 420.612291 230.4 0 417.322905-188.353073 417.322905-420.612291 0-102.256983-36.18324-196.075978-96.536313-268.871508 0.715084-0.286034 1.287151-0.715084 2.002235-1.144134 11.155307 18.878212 31.749721 31.606704 55.347486 31.606704 35.468156 0 64.357542-28.746369 64.357542-64.357542V245.988827c0-28.031285-17.877095-51.772067-42.762012-60.639106 0.286034-1.144134 0.286034-2.431285 0.286034-3.718436V133.005587c0-1.287151-0.143017-2.431285-0.286034-3.718436 17.162011-6.149721 31.034637-19.307263 37.899442-36.18324 0.858101 0.143017 1.573184 0.143017 2.431285 0.143016h171.191061c13.300559 0 24.026816-10.726257 24.026816-24.026815s-10.869274-24.026816-24.169833-24.026816zM1005.979888 64.357542c0-9.010056 7.293855-16.446927 16.446928-16.446927 9.010056 0 16.446927 7.293855 16.446927 16.446927v4.147486c0 9.010056-7.293855 16.446927-16.446927 16.446927-9.010056 0-16.446927-7.293855-16.446928-16.446927V64.357542z m-759.705028 0c0-9.010056 7.293855-16.446927 16.446928-16.446927 9.010056 0 16.446927 7.293855 16.446927 16.446927v4.147486c0 9.010056-7.293855 16.446927-16.446927 16.446927-9.010056 0-16.446927-7.293855-16.446928-16.446927V64.357542z m32.893855 235.548603c0 9.010056-7.293855 16.446927-16.446927 16.446928-9.010056 0-16.446927-7.293855-16.446928-16.446928v-54.203352c0-9.010056 7.293855-16.446927 16.446928-16.446927 9.010056 0 16.446927 7.293855 16.446927 16.446927v54.203352z m364.978771 639.1419C459.798883 939.048045 310.346369 788.594413 310.346369 602.815642c0-185.778771 149.452514-336.375419 333.801117-336.375419s333.801117 150.596648 333.801117 336.375419c0 185.778771-149.452514 336.232402-333.801117 336.232403z m394.58324-639.1419c0 9.010056-7.293855 16.446927-16.446927 16.446928-9.010056 0-16.446927-7.293855-16.446927-16.446928v-54.203352c0-9.010056 7.293855-16.446927 16.446927-16.446927 9.010056 0 16.446927 7.293855 16.446927 16.446927v54.203352z\" fill=\"#cdcdcd\" p-id=\"1646\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "g37H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-breadcrumb', {
    staticClass: "app-levelbar",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.levelList), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [(item.redirect === "noredirect" || index == _vm.levelList.length - 1) ? _c('router-link', {
      staticClass: "no-redirect",
      attrs: {
        "to": ""
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('router-link', {
      attrs: {
        "to": item.redirect || item.path
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-27592aaa", esExports)
  }
}

/***/ }),

/***/ "gQzw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("TvT6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("f1df53a8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-29d0b9f6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Layout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-29d0b9f6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Layout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "hdtf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-theme",
  "use": "icon-theme-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-theme\"><defs><style type=\"text/css\"></style></defs><path d=\"M788.00002 159.831491C756.00002 128 746 128 724.3801 128L642 128C642 128 576 188.923077 512 188.923077 448 188.923077 384 128 384 128L299.204802 128C276.629934 128 266 140.923077 245.847214 159.831491L81.582979 323.871735C70.243732 335.19552 52 371.692308 81.582979 408.655004 81.582979 408.655004 224.023667 540.29784 238.000003 541.53846L238.000003 835.076924C238.000003 868.452352 286.579 896 320 896L706 896C739.419808 896 788.00002 868.452352 788.00002 835.076924L788.00002 541.53846C802.145492 540.385864 942.448564 408.654992 942.448564 408.654992 974.00002 372 965.851264 334.883878 942.448584 311.513109L788.00002 159.831491Z\" p-id=\"9990\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "iClD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filterFileSize */
/* unused harmony export filterServerType */
/* unused harmony export filterServerStatus */
/* unused harmony export parseTime */
/* unused harmony export parsePayType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



// 过滤门店类型
var filterStoreType = function filterStoreType(value) {
  if (typeof value === 'string' || typeof value === 'number') {
    var index = -1;
    var arr = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.dictionaries.storeTypes;
    arr.forEach(function (item, i) {
      if (item.value === String(value)) {
        index = i;
      }
    });
    if (index !== -1) {
      return arr[index].key;
    } else {
      return '';
    }
  } else {
    return value;
  }
};
/**
 * 返回添加前缀后的门店组名称，前缀：C影吧 H酒店 F足浴
 * @param {String} value
 * @returns {String}
 */
var filterStoreGroup = function filterStoreGroup(value, type) {
  var result = '';
  if (typeof value === 'string') {
    var types = {
      1: 'C',
      2: 'H',
      3: 'F'
    };
    var prefix = types[type];
    if ((typeof type === 'string' || typeof type === 'number') && typeof prefix === 'string') {
      result = prefix + ' - ' + value;
    } else {
      result = value;
    }
  } else {
    result = value;
  }
  return result;
};

/**
 * 返回添加前缀后的软件名称，前缀：C影吧 H酒店 F足浴 P公用
 * @param {String} value
 * @param {Array} params 必传值，确定前缀，门店组数组
 * @returns {String}
 */
var filterSoftwareName = function filterSoftwareName(value, params) {
  var result = '';
  if (typeof value === 'string') {
    var types = {
      1: 'C',
      2: 'H',
      3: 'F',
      'multi': 'P'
    };
    if (Array.isArray(params)) {
      // 门店组数组对应的前缀数组
      var prefixes = [];
      params.forEach(function (item) {
        var prefix = types[item];
        // 去重
        if (!!prefix && !prefixes.includes(prefix)) {
          prefixes.push(prefix);
        }
      });
      var prefix = void 0;
      if (prefixes.length === 1) {
        prefix = prefixes.join('');
      } else if (prefixes.length > 1) {
        prefix = types.multi;
      } else {
        prefix = '';
      }
      result = prefix + ' - ' + value;
    } else {
      result = value;
    }
  } else {
    result = value;
  }
  return result;
};

/**
 * 过滤文件尺寸
 * @param size
 * @return {*|string}
 */
function filterFileSize(size) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MB';

  size = Number(size);
  var suffixes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  var step = 1024;
  var i = suffixes.indexOf(unit.toUpperCase());
  i = i !== -1 ? i : 0;
  while (size >= step) {
    size = size / step;
    i++;
  }
  return Math.floor(size * 100) / 100 + suffixes[i];
}

// 服务器授权状态
var SERVER_TYPE_LIST = [{ value: 1, label: '正常' }, { value: 2, label: '即将授权' }, { value: 3, label: '即将过期' }, { value: 4, label: '停用' }];
/**
 * 过滤服务器授权状态
 * @param type
 * @return {*|string}
 */
function filterServerType(type) {
  var res = SERVER_TYPE_LIST.filter(function (item) {
    return item.value === Number(type);
  })[0] || '';
  return res && res.label;
}

// 服务器在线状态
var SERVER_STATUS = [{ value: 0, label: '离线' }, { value: 1, label: '在线' }];
/**
 * 过滤服务器在线状态
 * @param status
 * @return {*|string}
 */
function filterServerStatus(status) {
  var res = SERVER_STATUS.filter(function (item) {
    return item.value === Number(status);
  })[0] || '';
  return res && res.label;
}

function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date = void 0;
  if ((typeof time === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(time)) === 'object') {
    date = time;
  } else {
    if (/^[0-9]{0,}$/.test(time + '')) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  return format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
}

function parsePayType(val) {
  var payTypes = {
    1: { icon: 'cash', label: '现金', value: 1 },
    2: { icon: 'member', label: '会员卡', value: 2 },
    3: { icon: 'alipay', label: '支付宝', value: 3 },
    4: { icon: 'wechat', label: '微信', value: 4 },
    5: { icon: 'integral', label: '积分', value: 5 },
    6: { icon: 'alipay', label: '支付宝(自收)', value: 6 },
    7: { icon: 'wechat', label: '微信(自收)', value: 7 },
    8: { icon: 'bank_card', label: '银行卡', value: 8 },
    9: { icon: 'apple', label: 'Apple Pay', value: 9 },
    10: { icon: 'group', label: '美团', value: 10 },
    11: { icon: 'douyin', label: '抖音', value: 11 },
    12: { icon: 'koubei', label: '口碑', value: 12 },
    13: { icon: 'exemption', label: '免单', value: 13 },
    14: { icon: 'alipay', label: '预约', value: 14 }
  };
  return payTypes[val] || null;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  filterStoreType: filterStoreType,
  filterStoreGroup: filterStoreGroup,
  filterSoftwareName: filterSoftwareName,
  filterFileSize: filterFileSize,
  filterServerType: filterServerType,
  filterServerStatus: filterServerStatus,
  parseTime: parseTime,
  parsePayType: parsePayType
});

/***/ }),

/***/ "izhu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper",
    class: {
      hideSidebar: !_vm.sidebar.opened
    }
  }, [(_vm.showLayout) ? _c('div', {
    staticClass: "sidebar-wrapper",
    on: {
      "mouseover": function($event) {
        _vm.toggleSidebar()
      }
    }
  }, [_c('sidebar', {
    staticClass: "sidebar-container"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [(_vm.showLayout) ? _c('navbar') : _vm._e(), _vm._v(" "), _c('app-main')], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-29d0b9f6", esExports)
  }
}

/***/ }),

/***/ "jSdT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabsView_vue__ = __webpack_require__("XWx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b93f3c44_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_TabsView_vue__ = __webpack_require__("D5KH");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("XclO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b93f3c44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b93f3c44_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_TabsView_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/TabsView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TabsView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b93f3c44", Component.options)
  } else {
    hotAPI.reload("data-v-b93f3c44", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "k0sJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("afte");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_200e3c4e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("cOJy");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("XzKX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-200e3c4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_200e3c4e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Screenfull/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-200e3c4e", Component.options)
  } else {
    hotAPI.reload("data-v-200e3c4e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kTXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress_nprogress_css__ = __webpack_require__("UVIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__env__ = __webpack_require__("yZtZ");



 // Progress 进度条
 // Progress 进度条样式

 // 验权



var PT = __WEBPACK_IMPORTED_MODULE_7__env__["a" /* default */].PT;

var whiteList = []; // 不重定向白名单

// 从路由表中找到第一个用户有权限访问的页面路径
function findFirstPermittedRoute(permissions) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1__router__["b" /* constantRouterMap */]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var route = _step.value;

            if (route.hidden || !route.children || route.path === '*' || route.path === '/404') continue;
            // 检查父级权限
            if (route.meta && route.meta.permission && !permissions.includes(route.meta.permission)) continue;
            // 在 children 中找第一个非隐藏且有权限的子路由
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(route.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var child = _step2.value;

                    if (child.hidden) continue;
                    if (child.meta && child.meta.permission && !permissions.includes(child.meta.permission)) continue;
                    // 拼接完整路径
                    var parentPath = route.path.endsWith('/') ? route.path : route.path + '/';
                    var childPath = child.path.startsWith('/') ? child.path : parentPath + child.path;
                    return childPath;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return '/404';
}

function checkPermission(to, next) {
    if (to.meta && to.meta.permission) {
        var permissions = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.permissions || [];
        if (permissions.includes(to.meta.permission)) {
            next();
        } else {
            var firstRoute = findFirstPermittedRoute(permissions);
            if (to.path === firstRoute) {
                next();
            } else {
                __WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"].error('无权限访问，已跳转到默认页面');
                next(firstRoute);
            }
            __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.done();
        }
    } else {
        next();
    }
}

__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].beforeEach(function (to, from, next) {
    __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.start();
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_auth__["a" /* getToken */])()) {
        if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.permissions || __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.permissions.length === 0) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('GetInfo').then(function (res) {
                // 拉取用户信息（内部已集成全量权限拉取）
                checkPermission(to, next);
            }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('FedLogOut').then(function () {
                    __WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"].error('验证失败,请重新登录');
                    PT.qnlogin.firstCheck(PT.config.hostBaseUrl); // 跳转统一登录
                });
            });
        } else {
            checkPermission(to, next);
        }
    } else {
        // 允许带着 ticket 的请求进入（由 App.vue 处理验证）
        var ticket = PT.qnlogin.findGetParameter('service_ticket');
        if (ticket) {
            next();
        } else {
            PT.qnlogin.firstCheck(PT.config.hostBaseUrl); // 跳转统一登录
            __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.done();
        }
    }
});

__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].afterEach(function () {
    __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.done(); // 结束Progress
});

/***/ }),

/***/ "kzJD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("Hana");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bce3e2a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("Qvxz");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("IqSV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bce3e2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bce3e2a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/Navbar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Navbar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6bce3e2a", Component.options)
  } else {
    hotAPI.reload("data-v-6bce3e2a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "l0Uw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    staticClass: "svg-icon hamburger",
    class: {
      'is-active': _vm.isActive
    },
    attrs: {
      "t": "1492500959545",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1691",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "64",
      "height": "64"
    },
    on: {
      "click": _vm.toggleClick
    }
  }, [_c('path', {
    attrs: {
      "d": "M966.8023 568.849776 57.196677 568.849776c-31.397081 0-56.850799-25.452695-56.850799-56.850799l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 543.397081 998.200404 568.849776 966.8023 568.849776z",
      "p-id": "1692"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M966.8023 881.527125 57.196677 881.527125c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 856.07443 998.200404 881.527125 966.8023 881.527125z",
      "p-id": "1693"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M966.8023 256.17345 57.196677 256.17345c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.850799 56.850799-56.850799l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.850799l0 0C1023.653099 230.720755 998.200404 256.17345 966.8023 256.17345z",
      "p-id": "1694"
    }
  })])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-df96aa28", esExports)
  }
}

/***/ }),

/***/ "mwRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-quanxian",
  "use": "icon-quanxian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-quanxian\"><defs><style type=\"text/css\"></style></defs><path d=\"M818.246893 412.326906l-45.988404 0 0-70.991868c0-152.307871-123.463939-275.778974-275.778974-275.778974s-275.78102 123.471103-275.78102 275.778974l0 70.991868-45.987381 0c-25.379017 0-45.988404 20.566408-45.988404 45.987381l0 455.407074c0 25.428136 20.560268 45.988404 45.988404 45.988404l643.535779 0c25.37697 0 45.988404-20.560268 45.988404-45.988404L864.235296 458.314287C864.190271 432.893314 843.623863 412.326906 818.246893 412.326906L818.246893 412.326906zM680.331823 412.326906 312.62516 412.326906l0-70.991868c0-101.55393 82.344426-183.853331 183.854355-183.853331 101.509928 0 183.853331 82.343403 183.853331 183.853331L680.332846 412.326906 680.331823 412.326906zM680.331823 412.326906\" p-id=\"9663\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "n/eG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', _vm._b({
    staticClass: "qn-image",
    attrs: {
      "src": _vm.previewImg,
      "alt": "图片"
    }
  }, 'img', _vm.$attrs, false))
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-713823e1", esExports)
  }
}

/***/ }),

/***/ "nFVA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.hamburger[data-v-df96aa28] {\n    display: inline-block;\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n    transform: rotate(0deg);\n    transition: .38s;\n    transform-origin: 50% 50%;\n}\n.hamburger.is-active[data-v-df96aa28] {\n    transform: rotate(90deg);\n}\n", ""]);

// exports


/***/ }),

/***/ "nQME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tubiao",
  "use": "icon-tubiao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tubiao\"><defs><style type=\"text/css\"></style></defs><path d=\"M64 448 320 448 320 960 64 960 64 448 64 448ZM704 256 960 256 960 960 704 960 704 256 704 256ZM384 64 640 64 640 960 384 960 384 64 384 64Z\" p-id=\"10423\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "nUw4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASAAAADYCAMAAAB8685yAAAAXVBMVEVHcEz6+vr6+vr6+vr6+vr6+vr5+fn////6+vr6+vr5+fn6+vr6+vr6+vr////6+vr6+vr5+fn6+vr6+vr6+vr6+vr6+vr6+vr6+vr////6+vr8/Pz7+/v9/f3+/v5xDZdaAAAAGXRSTlMAlI+V1/ksBv38K5COvQm71CqY+PrW2PTzgNQjbwAABHVJREFUeNrt3QlyIyEMBVCy2s6+zIaFdP9jTuKkpuKMoRENvaD/L5DKK6AxLTXOveX57vJ1jxzl9efds/vI5mwLj1PZvjwcfB5BEcv95g3oAg7xnDl3swNDPLsbdw6FVM7dJRBSuXRXQEjlysEgHQABCEAAAhCAAAQgACEAAtD0QMTi+45wKAYK7E1EuAyIvJ1QARB7SxE1kC2fuFAMKHgPoRSQmAOKrEMOA+hfNEBsEYgUQGIRiAFUsExHgLzHIpQNxNRxagCFnn+sAwhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQFogAhCAAAQgAAEIQACaN4FYRJgoAOh/nONqXCYAfQ2dqLXgAKDPxGqZJABony5WziDqHohL659tAIXBQi82DRQyCuHYMlBWoSDbBcospCSrQNnNNsEmUH6tu9gEUlQqB4tAmmYJsQikKnUP9oB03TZkD0jXbSP2gJTNJOaAtP1sZA2IAFRzCUr8IOsVSNvPJgACUPz/AhCAAAQgAOEpho2iZSD8Fis9Mev2uMPjuKPmKm3wwIzqLEEdH9rXmWEdA3GNh3zXLw6rDKCegajCCtR38YKMfoTtUf4yMME6BwrjNtH9A2WV4IW9YaDhWTZYCNx9GTCNqnE1UWkf3zHmdCOY6NU4/Vn5vGYNI90+35p9Bj9Ubw7ogER8yLr6xUQW/lmCmYFk8QNwXiBe/hSdFYizdyM2gVjX+2cOiFfxBZn5gEjZ+mcNiPQ/i0wBUWETshUgKjmaMQQUSnuQjQCFEeczFoBC6RsGI0Bh3Blo90CDB+lkHGj4RQObBsp5mSeGgfJedi5oIZoYKLvuK9gEUtTskEUgVW0u2wNS1i4vYyGaEEh/sW8wBVRy8TH1AcStfMoXIqK1AZVenF2yZzxcYl5rBZsIqPzeWvU/Guq+TJoGaNS9vqrZcvTNTVoL0Mh7j1k9eCruFKYAGn0vtJTx5BcBzQsUxt/qmzESSNrsyCcAqnLrMY3YpNOygSrdCk3KuVVrKWoOVO3WbNbOrTrzrDVQxVvFT44DkhabhemA2NdM0M6tCvOsLVBdn2/DgKT+s3BioNo+X/8UScV1bCYg8vXzMQoCN9ouTArUwuewEI3aeWrnWTugRj5v/2Kj/cLEQM182m/LJwEKfskRmhto2T6apagN0OJ98peiJkBr8MldiloABVkHUNY8awG0Fp+sA8cGQCvy8dNcXcMr9hl85FcHWpvP0FJUG4j9GtP4+0FCn+2yzOJXGgqR1ACyEwABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIABZAxKLPgKgdFgBRBaBSAEUsASlgSzOMVYBGZxjQQVkbwhFiohcs2bvHp7xKSBjQtHefbeHkE8V6bnidvWehk+iEtalv6pA3PtiLQO3uLg9sgcQgAAEIAABCEAAQgAEIAABaGFAVzBI5Y+7BEIqT+4cCKncuusdFOLZXTt3AYZ4Lpxzm0c4xHK/ce9CZ1tQnMr25cF95Ob21w94HOf30+31u81fWSRb8qQmCt8AAAAASUVORK5CYII="

/***/ }),

/***/ "o0jG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'QnInput',
  props: {
    clearable: {
      type: Boolean,
      default: true
    },
    value: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    closeIcon: function closeIcon() {
      return this.clearable ? 'close' : '';
    }
  },
  methods: {
    clearValue: function clearValue() {
      if (!this.clearable) return;
      this.$emit('input', '');
    }
  }
});

/***/ }),

/***/ "o6Ms":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_qnbar_platform_js__ = __webpack_require__("Ljt4");


//qnbar平台工具的基础配置
//var PT = require('./vendor/qnbar/platform.js');


var PT = new __WEBPACK_IMPORTED_MODULE_0__vendor_qnbar_platform_js__["a" /* default */].Platform();
PT.config.env = "release";
PT.config.hostBaseUrl = 'https://agent.qnbar.com/';
PT.config.platformUsagespace = 'PT_AGENT_BZ';
PT.config.apiBaseUrl = 'https://apih.qnbar.com/';
PT.config.qnloginBaseUrl = "https://login.qnbar.com/";
PT.config.qnloginPlatformNo = 8;
PT.config.loginJumpBackUrl = encodeURIComponent(PT.config.hostBaseUrl);
PT.config.wsHost = "ws.qnbar.com";
PT.config.wsPort = "16668";
PT.config.wsProto = "wss";
PT.init();

/* harmony default export */ __webpack_exports__["a"] = ({
    PT: PT
});

/***/ }),

/***/ "oHFL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_js__ = __webpack_require__("DfDl");
// 封装到window对象上的公共函数
// console封装
window.Log = function (input) {
    console.log(input);
};


// 封装到vue原型上的公共函数
/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        // 删除登录信息
        Vue.prototype.commondelLocalAllData = function () {
            delete localStorage[__WEBPACK_IMPORTED_MODULE_0__base_js__["a" /* default */].localName];
        };
        //序列号
        //门店名称
        Vue.filter("filterStoreName", function (value) {
            if (!!value) {
                return value;
            } else {
                return "无";
            }
        });
        //生成时间
        Vue.filter("filterBornTime", function (value) {
            if (!value) {
                return "未知日期";
            }
            var out = "0";
            out = getLocalTime(value);
            function getLocalTime(time) {
                var date = new Date(parseInt(time) * 1000);
                var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
                var minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
                var second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
                return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + hour + ":" + minute + ":" + second;
            }
            return out;
        });
        //使用状态
        Vue.filter("usedStatus", function (value) {
            if (value == 1) {
                return "正常";
            } else if (value == 2) {
                return "冻结";
            } else {
                return "未投入使用";
            }
        });
        //激活状态
        Vue.filter("activationStatus", function (value) {
            if (value == 1) {
                return "激活";
            } else {
                return "未激活";
            }
        });
        // 删除空属性
        Vue.prototype.commonDelEmptyAttr = function (obj) {
            for (var x in obj) {
                if (obj[x] === "" || obj[x] === null || obj[x] === undefined || obj[x] === 0) {
                    delete obj[x];
                }
            };
            return obj;
        };
        // 时间对象转换成时间戳
        Vue.prototype.commonFucGetUnixTime = function (date) {
            if (!date) {
                return "";
            }
            var getDate = date;
            var year = getDate.getFullYear();
            var month = getDate.getMonth();
            var day = getDate.getDate();
            getDate = new Date(year, month, day);
            // 返回今日时间戳
            return parseInt(getDate.getTime() / 1000);
        };
        //租赁状态
        Vue.filter("leaseStatus", function (value) {
            if (Number(value) == 1) {
                return "否";
            } else {
                return "是";
            }
        });
        //判断
        Vue.filter("changUnkown", function (value) {
            if (value == "unkown" || value == null) {
                return "";
            } else {
                return value;
            }
        });
        //设备在线
        Vue.filter("isOnLine", function (value) {
            if (Number(value) == 1) {
                return "在线";
            } else {
                return "不在线";
            }
        });
        // 秒转时分
        Vue.filter("turnHours", function (value) {
            if (!value) {
                return "0分钟";
            };
            var h = Math.floor(value / 3600 % 24);
            var m = Math.floor(value / 60 % 60);
            if (h < 1) {
                return value = m + "分钟";
            } else {
                return value = h + "小时" + m + "分钟";
            }
        });
        // 判空
        Vue.filter("filterEmpty", function (value) {
            if (!value) {
                return "0";
            } else {
                return value;
            }
        });
    }
});

/***/ }),

/***/ "oSYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-table",
  "use": "icon-table-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-table\"><defs><style type=\"text/css\"></style></defs><path d=\"M67.039347 100.410897l889.919259 0 0 200.231347-889.919259 0 0-200.231347Z\" p-id=\"8434\" /><path d=\"M67.039347 345.138668l266.976494 0 0 266.975471-266.976494 0 0-266.975471Z\" p-id=\"8435\" /><path d=\"M67.039347 656.610562l266.976494 0 0 266.976494-266.976494 0 0-266.976494Z\" p-id=\"8436\" /><path d=\"M378.511241 345.138668l266.976494 0 0 266.975471-266.976494 0 0-266.975471Z\" p-id=\"8437\" /><path d=\"M378.511241 656.610562l266.976494 0 0 266.976494-266.976494 0 0-266.976494Z\" p-id=\"8438\" /><path d=\"M689.983135 345.138668l266.976494 0 0 266.975471-266.976494 0 0-266.975471Z\" p-id=\"8439\" /><path d=\"M689.983135 656.610562l266.976494 0 0 266.976494-266.976494 0 0-266.976494Z\" p-id=\"8440\" /><path d=\"M67.039347 100.410897l889.919259 0 0 200.231347-889.919259 0 0-200.231347Z\" p-id=\"8441\" /><path d=\"M67.039347 345.138668l266.976494 0 0 266.975471-266.976494 0 0-266.975471Z\" p-id=\"8442\" /><path d=\"M67.039347 656.610562l266.976494 0 0 266.976494-266.976494 0 0-266.976494Z\" p-id=\"8443\" /><path d=\"M378.511241 345.138668l266.976494 0 0 266.975471-266.976494 0 0-266.975471Z\" p-id=\"8444\" /><path d=\"M378.511241 656.610562l266.976494 0 0 266.976494-266.976494 0 0-266.976494Z\" p-id=\"8445\" /><path d=\"M689.983135 345.138668l266.976494 0 0 266.975471-266.976494 0 0-266.975471Z\" p-id=\"8446\" /><path d=\"M689.983135 656.610562l266.976494 0 0 266.976494-266.976494 0 0-266.976494Z\" p-id=\"8447\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "oglU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-zonghe",
  "use": "icon-zonghe-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zonghe\"><defs><style type=\"text/css\"></style></defs><path d=\"M770.56 460.8l250.88 0C998.4 220.16 803.84 25.6 563.2 2.56l0 250.88C668.16 273.92 750.08 355.84 770.56 460.8L770.56 460.8zM770.56 460.8\" p-id=\"9879\" /><path d=\"M460.8 253.44 460.8 2.56C220.16 25.6 25.6 220.16 2.56 460.8l250.88 0C273.92 355.84 355.84 273.92 460.8 253.44L460.8 253.44zM460.8 253.44\" p-id=\"9880\" /><path d=\"M563.2 770.56l0 250.88c243.2-23.04 435.2-217.6 460.8-460.8l-250.88 0C750.08 668.16 668.16 750.08 563.2 770.56L563.2 770.56zM563.2 770.56\" p-id=\"9881\" /><path d=\"M253.44 563.2 2.56 563.2c23.04 243.2 217.6 435.2 460.8 460.8l0-250.88C355.84 750.08 273.92 668.16 253.44 563.2L253.44 563.2zM253.44 563.2\" p-id=\"9882\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "ojPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("7eqC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713823e1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("n/eG");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713823e1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/QnImage/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-713823e1", Component.options)
  } else {
    hotAPI.reload("data-v-713823e1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p9JE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.el-menu[data-v-2bc943de] {\n  min-height: 100%;\n}\n.logo-name[data-v-2bc943de] {\n  height: 50px;\n  width: 100%;\n  line-height: 50px;\n  text-align: center;\n  color: #c4d0d9;\n}\n.logo-img[data-v-2bc943de] {\n  height: 50px;\n  width: 100%;\n  line-height: 50px;\n  text-align: left;\n  color: #c4d0d9;\n}\n.logoImage[data-v-2bc943de] {\n  height: 32px;\n  margin-left: 17px;\n  margin-top: 7px;\n}\n", ""]);

// exports


/***/ }),

/***/ "q8zI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q98q":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.tabs-view-container[data-v-b93f3c44] {\n  display: inline-block;\n  vertical-align: top;\n  margin-left: 10px;\n}\n.tabs-view-container .tabs-view[data-v-b93f3c44] {\n    margin-left: 10px;\n}\n", ""]);

// exports


/***/ }),

/***/ "rGfR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//这坨是前端用的权限控制代码
//对qnbarApi有依赖
function PermissionChecker() {
    var that = this;

    var BindThing = function BindThing() {
        this.code = ""; //
        this.type = ""; // page / elementId / function / check
        this.value = ""; //具体id或function对象
        this.noPrmsnDo = null; //没权限时，做啥
        this.ownPrmsnDo = null; //有权限时，做啥
        this.isPrmsnOk = false; //是否权限ok
    };

    var bindArr = [];

    var DoHide = function DoHide(bindThingObj) {
        if (bindThingObj) {
            bindThingObj.style.display = "none";
        }
    };

    var DoShow = function DoShow(bindThingObj) {
        if (bindThingObj) {
            bindThingObj.style.display = "";
        }
    };

    var onQueryFinishOutDoFunc = null;
    var onNoPageCoreDoFunc = null;

    //权限请求后的处理 
    var HandlePermissionQueryOK = function HandlePermissionQueryOK(rsp) {
        if (rsp.code == 0) {
            if (rsp.data.length != bindArr.length) {
                alert("权限验证未对齐错误");
            }

            //set result
            for (var i = 0; i < bindArr.length; i++) {
                if (rsp.data[i] > 0) {
                    bindArr[i].isPrmsnOk = true;
                }
            }

            //run deal
            var isPageCoreOk = true;
            for (var i = 0; i < bindArr.length; i++) {
                if (bindArr[i].type == "page") {
                    if (!bindArr[i].isPrmsnOk) {
                        isPageCoreOk = false;
                    }
                } else if (bindArr[i].type == "elementId") {

                    if (!bindArr[i].isPrmsnOk) {
                        if (bindArr[i].noPrmsnDo) {
                            var element = document.getElementById(bindArr[i].value);
                            if (element) {
                                bindArr[i].noPrmsnDo(element);
                            }
                        }
                    } else {
                        if (bindArr[i].ownPrmsnDo) {
                            var element = document.getElementById(bindArr[i].value);
                            if (element) {
                                bindArr[i].ownPrmsnDo(element);
                            }
                        }
                    }
                } else if (bindArr[i].type == "function") {
                    if (!bindArr[i].isPrmsnOk) {
                        //not run
                    } else {
                        bindArr[i].value();
                    }
                }
            }

            if (!isPageCoreOk) {
                if (onNoPageCoreDoFunc != null) {
                    onNoPageCoreDoFunc();
                } else {
                    alert("你不具有该页面的访问权限");
                }
            } else {
                if (onQueryFinishOutDoFunc) {
                    onQueryFinishOutDoFunc();
                }
            }
        } else {
            alert("请求权限出现错误：" + rsp.code);
        }
    };

    //绑定当前页面访问时控制
    this.bindElementById = function (permissionCode, elementId, noPrmsnMethod, ownPrmsnMethod) {
        var tempBind = new BindThing();
        tempBind.code = permissionCode;
        tempBind.type = "elementId";
        tempBind.value = elementId;

        if (!noPrmsnMethod || noPrmsnMethod == 'hide') {
            tempBind.noPrmsnDo = DoHide;
        } else {
            //todo
        }

        if (ownPrmsnMethod) {
            if (ownPrmsnMethod == 'show') {
                tempBind.ownPrmsnDo = DoShow;
            }
        }

        bindArr.push(tempBind);
    };

    this.bindRunFunc = function (permissionCode, func) {
        var tempBind = new BindThing();
        tempBind.code = permissionCode;
        tempBind.type = "function";
        tempBind.value = func;

        bindArr.push(tempBind);
    };

    /*
     * 绑定页面核心权限，没有核心权限判定为全页无法使用
     */
    this.bindPageCore = function (permissionCode) {
        var tempBind = new BindThing();
        tempBind.code = permissionCode;
        tempBind.type = "page";

        bindArr.push(tempBind);
    };

    /*
     * 绑定要检查的权限，用于外部逻辑
     */
    this.bindCheck = function (permissionCode) {
        var tempBind = new BindThing();
        tempBind.code = permissionCode;
        tempBind.type = "check";

        bindArr.push(tempBind);
    };

    /*
     * 页面无核心权限时的回调
     */
    this.setNoPageCoreDoFunc = function (noPageCoreDoFunc) {
        onNoPageCoreDoFunc = noPageCoreDoFunc;
    };

    this.queryAddress = 'role-permission/role/match-permission';

    //-- 单独请求权限 --
    this.queryPermissions = function (qnbarApiClient, usagespaceParam, localSessionKey, onQueryFinishOutDo) {
        if (bindArr.length == 0) {
            alert("未绑定任何权限和资源错误！");
        }

        onQueryFinishOutDoFunc = onQueryFinishOutDo;

        var codesStr = '';
        for (var i = 0; i < bindArr.length; i++) {
            codesStr += bindArr[i].code;
            if (i != bindArr.length - 1) {
                codesStr += ',';
            }
        }

        var postParams = {
            usagespace: usagespaceParam,
            codes: codesStr
        };
        if (localSessionKey) {
            postParams.local_sess = localSessionKey;
        }
        qnbarApiClient.query(that.queryAddress, postParams, HandlePermissionQueryOK);
    };

    //---- 直接获取全量权限 ----
    var allUserPermissionCodes = [];
    var onQueryAllOKOutDoFunc = null;
    var onQueryAllFailOutDoFunc = null;
    this.queryAllPermissionUrl = 'role-permission/role/get-all';

    var handleAllPermissionsOk = function handleAllPermissionsOk(rsp) {
        if (rsp.code == 0) {
            if (rsp.data && rsp.data.length > 0) {
                for (var i = 0; i < rsp.data.length; i++) {
                    allUserPermissionCodes.push(rsp.data[i]);
                }
                localStorage.setItem("user_all", rsp.data);
                // console.log("all permission code");
                // console.log(allUserPermissionCodes);
            }

            if (onQueryAllOKOutDoFunc) {
                onQueryAllOKOutDoFunc(rsp);
            }
        } else {
            if (onQueryAllFailOutDoFunc) {
                onQueryAllFailOutDoFunc(rsp);
            } else {
                alert("请求权限出现错误，请尝试重新登录或清理浏览器cookie ：" + rsp.code + rsp.msg);
            }
        }
    };

    this.queryAllPermissions = function (qnbarApiClient, usagespaceParam, localSessionKey, onQueryOKOutDo, onQueryFailOutDo) {
        onQueryAllOKOutDoFunc = onQueryOKOutDo;
        onQueryAllFailOutDoFunc = onQueryFailOutDo;

        var postParams = {
            usagespace: usagespaceParam
        };
        if (localSessionKey) {
            postParams.local_sess = localSessionKey;
        }
        //特殊处理block
        qnbarApiClient.blocked = false;
        qnbarApiClient.query(that.queryAllPermissionUrl, postParams, handleAllPermissionsOk);
        qnbarApiClient.blocked = true;
    };

    this.hasPermission = function (permissionCode) {
        if (bindArr.length > 0) {
            for (var i = 0; i < bindArr.length; i++) {
                if (bindArr[i].code == permissionCode && bindArr[i].isPrmsnOk) {
                    return true;
                }
            }
        }

        if (allUserPermissionCodes.length > 0) {
            for (var i = 0; i < allUserPermissionCodes.length; i++) {
                if (allUserPermissionCodes[i] == permissionCode) {
                    return true;
                }
            }
        }

        return false;
    };

    this.checkAndRun = function (permissionCode, outThing, outRunOkFunc, outRunFailFunc) {
        if (that.hasPermission(permissionCode)) {
            if (outRunOkFunc) {
                outRunOkFunc(outThing);
            }
            return;
        }

        if (outRunFailFunc) {
            outRunFailFunc(outThing);
        }
    };
}

/* harmony default export */ __webpack_exports__["a"] = ({
    PermissionChecker: PermissionChecker
});

/***/ }),

/***/ "rn/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-description",
  "use": "icon-description-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-description\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 8.448a501.248 501.248 0 1 0 501.248 501.248A503.04 503.04 0 0 0 512 8.448z m0 743.68a38.912 38.912 0 0 1-55.04-55.04 28.672 28.672 0 0 1 22.016-11.008 37.632 37.632 0 0 1 38.656 38.656 25.6 25.6 0 0 1-5.632 27.392z m110.08-314.112a220.416 220.416 0 0 1-60.672 66.048 162.048 162.048 0 0 0-44.032 44.032 103.68 103.68 0 0 0-11.008 44.032v27.648h-55.04v-27.392a198.144 198.144 0 0 1 11.008-60.672 123.648 123.648 0 0 1 55.04-49.664 210.432 210.432 0 0 0 49.664-49.664 93.184 93.184 0 0 0 16.64-55.04 70.656 70.656 0 0 0-22.016-55.04 92.416 92.416 0 0 0-66.048-16.64 174.848 174.848 0 0 0-110.08 44.032v-65.792a230.4 230.4 0 0 1 115.456-33.024 134.656 134.656 0 0 1 99.072 33.024 119.808 119.808 0 0 1 38.656 88.064 146.688 146.688 0 0 1-16.64 66.048z\" p-id=\"2862\" fill=\"#d81e06\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "sEM+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-404",
  "use": "icon-404-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-404\"><defs><style type=\"text/css\"></style></defs><path d=\"M931.6 585.6l0 79c28.6-60.2 44.8-127.4 44.8-198.4C976.4 211 769.4 4 514.2 4S52 211 52 466.2c0 3.2 0.2 6.4 0.2 9.6l166-206 96.4 0L171.8 485.6l46.4 0 0-54.8 99.2-154.6 0 209.4 0 100 0 82.4-99.2 0 0-82.4L67.6 585.6c43 161 170.6 287.4 332.4 328.6-10.4 26.2-40.6 89.4-90.8 100.6-62.2 14 168.8 3.4 333.6-104.6 126.6-36.6 230.8-125.8 287.4-242.2l-97.6 0 0-82.4-166.2 0 0-87.2 0-12.8L666.4 476l166.2-206.2 94 0-140.4 215.8 46.4 0 0-59 99.2-154 0 213.2L931.8 585.6zM366.2 608c-4.8-11.2-7.2-23.2-7.2-36L359 357.6c0-12.8 2.4-24.8 7.2-36 4.8-11.2 11.4-21 19.6-29.2 8.2-8.2 18-14.8 29.2-19.6 11.2-4.8 23.2-7.2 36-7.2l81.6 0c12.8 0 24.8 2.4 36 7.2 11 4.8 20.6 11.2 28.8 19.2l-88.6 129.4 0-23c0-4.8-1.6-8.8-4.8-12-3.2-3.2-7.2-4.8-12-4.8-4.8 0-8.8 1.6-12 4.8-3.2 3.2-4.8 7.2-4.8 12l0 72L372.6 620C370.2 616.2 368 612.2 366.2 608zM624.4 572c0 12.8-2.4 24.8-7.2 36-4.8 11.2-11.4 21-19.6 29.2-8.2 8.2-18 14.8-29.2 19.6-11.2 4.8-23.2 7.2-36 7.2l-81.6 0c-12.8 0-24.8-2.4-36-7.2-11.2-4.8-21-11.4-29.2-19.6-3.6-3.6-7-7.8-10-12l99.2-144.6 0 50.6c0 4.8 1.6 8.8 4.8 12 3.2 3.2 7.2 4.8 12 4.8 4.8 0 8.8-1.6 12-4.8 3.2-3.2 4.8-7.2 4.8-12l0-99.6 92.6-135.2c6.6 7.4 12 15.8 16 25.2 4.8 11.2 7.2 23.2 7.2 36L624.2 572z\" p-id=\"10207\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "sHk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-wujiaoxing",
  "use": "icon-wujiaoxing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-wujiaoxing\"><defs><style type=\"text/css\"></style></defs><path d=\"M565.272827 34.627285l112.095872 237.542288c8.706637 18.321022 25.411424 31.051641 44.82285 33.996289l250.776598 38.081157c48.697387 7.411435 68.22505 70.046082 32.933559 105.979639l-181.494353 184.937155c-13.998147 14.230618-20.352386 34.815477-17.05903 54.93539l42.819161 261.127145c8.346858 50.695541-42.64204 89.451974-86.225039 65.51841l-224.307979-123.271141c-17.285968-9.525824-37.992596-9.525824-55.278564 0l-224.313514 123.271141c-43.582999 23.933565-94.571897-14.822869-86.219504-65.51841l42.813626-261.127145c3.321031-20.119914-3.088559-40.704772-17.086706-54.93539l-181.439002-184.937155c-35.285956-35.933557-15.819179-98.57374 32.933559-105.979639l250.748923-38.081157c19.350541-2.939112 36.083003-15.675267 44.75643-33.996289l112.123547-237.542288C480.497972-11.540583 543.509003-11.540583 565.272827 34.627285z\" p-id=\"9771\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "sQ6K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.routes), function(item) {
    return [(_vm.hasPermission(item) && !item.hidden && item.noDropdown && item.children.length > 0) ? _c('router-link', {
      attrs: {
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.name) + "\n      ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasPermission(item) && !item.noDropdown && !item.hidden) ? _c('el-submenu', {
      attrs: {
        "index": item.name
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.name) + "\n        "), _c('el-badge', {
      attrs: {
        "value": _vm.auditShopInfo,
        "hidden": item.name !== '门店管理'
      }
    })], 1), _vm._v(" "), _vm._l((item.children), function(child) {
      return (_vm.hasPermission(child) && !child.hidden) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n            " + _vm._s(child.name) + "\n            "), _vm._v(" "), _c('el-badge', {
        attrs: {
          "value": _vm.auditShopInfo,
          "hidden": child.name !== '门店管理'
        }
      })], 1)], 1)] : _vm._e()
    })], 2) : _vm._e()]
  })], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-02591744", esExports)
  }
}

/***/ }),

/***/ "tAWD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-yanjing",
  "use": "icon-yanjing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yanjing\"><defs><style type=\"text/css\"></style></defs><path d=\"M941.677063 391.710356c9.337669-14.005992 6.224772-32.68133-6.224772-43.575447-14.005992-10.894118-32.68133-7.78122-43.575447 6.224771-1.556449 1.556449-174.300768 205.426673-379.727441 205.426673-199.200878 0-379.727441-205.426673-381.28389-206.982098-10.894118-12.450567-31.124881-14.005992-43.575448-3.112898-12.450567 10.894118-14.005992 31.124881-3.112897 43.575448 3.112897 4.668323 40.46255 46.687322 99.600439 93.375667l-79.369676 82.48155c-12.450567 12.450567-10.894118 32.68133 1.556449 43.575448 3.112897 6.224772 10.894118 9.337669 18.675338 9.337669 7.78122 0 15.562441-3.112897 21.787213-9.337669l85.594447-88.706321c40.46255 28.013007 88.706321 54.469566 141.619438 73.14388L340.959485 707.631586c-4.668323 17.118889 4.669346 34.237779 21.787213 38.906101h9.337669c14.005992 0 26.456558-9.337669 29.568432-23.343661l32.68133-110.494556c24.90011 4.668323 51.356668 7.78122 77.813227 7.78122s52.913117-3.112897 77.813227-7.78122l32.68133 108.938108c3.112897 14.005992 17.118889 23.343661 29.569456 23.343661 3.112897 0 6.224772 0 7.78122-1.556449 17.118889-4.669346 26.456558-21.787212 21.788236-38.906102l-32.68133-108.938108c52.913117-18.675338 101.156888-45.131897 141.619438-73.14388l84.037998 87.150896c6.224772 6.224772 14.005992 9.337669 21.787212 9.337669 7.78122 0 15.562441-3.112897 21.787212-9.337669 12.450567-12.450567 12.450567-31.124881 1.556449-43.575448l-79.369675-82.48155c63.808258-46.688345 101.158934-91.820242 101.158934-91.820242z\" p-id=\"7879\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "vT7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-87a99cd0", esExports)
  }
}

/***/ }),

/***/ "vXUM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-yonghuming",
  "use": "icon-yonghuming-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yonghuming\"><defs><style type=\"text/css\"></style></defs><path d=\"M504.951 511.98c93.49 0 169.28-74.002 169.28-165.26 0-91.276-75.79-165.248-169.28-165.248-93.486 0-169.287 73.972-169.279 165.248-0.001 91.258 75.793 165.26 169.28 165.26z m77.6 55.098H441.466c-120.767 0-218.678 95.564-218.678 213.45V794.3c0 48.183 97.911 48.229 218.678 48.229H582.55c120.754 0 218.66-1.78 218.66-48.229v-13.77c0-117.887-97.898-213.45-218.66-213.45z\" p-id=\"7987\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "vuLS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppMain',
  computed: {
    key: function key() {
      return this.$route.name !== undefined ? this.$route.name : this.$route;
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__env_js__ = __webpack_require__("yZtZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svrapi_js__ = __webpack_require__("Mp/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_vendor_qnbar_msgWsClient__ = __webpack_require__("V8LJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_http_ws_base__ = __webpack_require__("xjuR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__("0xDb");



//
//
//
//
//
//

// import base from './base.js'






var PT = __WEBPACK_IMPORTED_MODULE_3__env_js__["a" /* default */].PT;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  beforeMount: function beforeMount() {
    // 平台
    var self = this;

    // --------- 固定统一登录初始化流程 ---------
    var withLocalSessClean = PT.qnlogin.findGetParameter('local_sess_clean');
    if (withLocalSessClean) {
      PT.apiClient.blockQuery();
    }
    // 登录模块的配置和初始化
    var LoginRunConf = {};

    // 本地session ok时执行
    function OnLocalSessionOkDoFunc() {
      self.hasLogin = PT.qnlogin.isLocalSessOk;
    }
    // 没有本地session时执行, 注意不是完全没有，可能带ticket或tgc...
    function OnLocalSessionNotOkDoFunc() {
      self.hasLogin = PT.qnlogin.isLocalSessOk;
    }

    // 平台本地ticket校验并返回session的接口
    function OnHasTicketDoFunc(ticket) {
      var postParams = {
        service_ticket: ticket
      };
      PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_4__svrapi_js__["a" /* default */].loginValidateTicket, postParams, PT.qnlogin.handleTicketValidate);
      PT.apiClient.blockQuery();
    }

    // 避免无失败卡页面
    function OnTicketValidateFailFunc() {
      alert('登录ticket验证失败！请尝试重新登录');
      PT.qnlogin.logout();
      this.hasLogin = PT.qnlogin.isLocalSessOk;
      window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl);
    }

    function OnSessionFailDoFunc() {
      // 本地和passport都失败，完全没有session
      PT.apiClient.blockQuery();
      // console.log('OnSessionFailDoFunc');
      self.jumpLogin();
    }

    // ----------- 外部执行带入登录工具的配置 ------------
    LoginRunConf.JumpBackUrl = PT.config.loginJumpBackUrl; // 登录回跳地址
    LoginRunConf.OnLocalSessionOkDo = OnLocalSessionOkDoFunc;
    LoginRunConf.OnLocalSessionNotOkDo = OnLocalSessionNotOkDoFunc;
    LoginRunConf.OnHasTicketDo = OnHasTicketDoFunc;
    LoginRunConf.OnSessionFailDo = OnSessionFailDoFunc;
    LoginRunConf.OnTicketValidateFail = OnTicketValidateFailFunc;

    // ---- 登录ok后的执行和鉴权的执行 ----

    // 权限检查对象
    // 全局 - 获取当前登录用户的全量权限code
    function checkAllUserPermission() {
      // 开始执行鉴权请求
      PT.apiClient.blockQuery();
      PT.permissionChecker.queryAllPermissions(PT.apiClient, PT.config.platformUsagespace, PT.qnlogin.getLocalSess(), onAllPermissionQueryOK);
    }

    // 全局 - 登录OK后执行内容
    function onPageSessionOk() {
      self.user_title = '读取中...';
      self.hasLogin = PT.qnlogin.isLocalSessOk;

      // 有登录，就执行权限获取
      checkAllUserPermission();
    }

    // 执行passport登录模块的页面初始化运行过程
    LoginRunConf.OnAfterLocalSessionOkDo = onPageSessionOk;
    PT.qnlogin.runInPageReady(LoginRunConf);

    //
    function onAllPermissionQueryOK(rsp) {
      // 勿动~
      PT.apiClient.resumeQuery();
      // 同步权限到 Vuex，确保 Sidebar 等组件能读取
      if (rsp && rsp.data) {
        self.$store.commit('SET_PERMISSIONS', rsp.data);
      }
      // 判断是否有权限修改密码和登出
      self.islocal_user = PT.permissionChecker.hasPermission('local_user_base_module');
      // console.log(self.islocal_user)
      eventBus.$emit('islocal_user', self.islocal_user);
    }
    // self.clickstore();
  },

  mounted: function mounted() {
    var _this = this;

    var setTime = setTimeout(function () {
      _this.$store.dispatch('getAuditShopInfo');
      clearTimeout(setTime);
      setTime = null;
    }, 1000);
    var setIntervalShopInfo = setInterval(function () {
      _this.$store.dispatch('getAuditShopInfo');
    }, 300000);
    // this.$store.dispatch('getAuditShopInfo')
    var self = this;

    // 【业务逻辑入口改到这里了！！！】
    PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_4__svrapi_js__["a" /* default */].loginUserInfo, '', function (rsp) {
      if (rsp.code == 0) {
        localStorage.setItem('user_data', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(rsp.data));
        self.SET_DATA(rsp.data);
        var dispName = rsp.data.name || rsp.data.agent_name;
        handleWs();
        // eslint-disable-next-line no-undef
        eventBus.$emit('user_title', dispName);
      } else {
        alert('获取用户信息错误！');
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* agencyQnbarRequest */])('getdetail').then(function (res) {
        // 新起点合作商
        var data = res.data;
        localStorage.setItem('base_info', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data));
        if (res.data.xqd === '1') {
          // 登出
          self.runLogout();
          localStorage.removeItem('base_info');
        }
      });
    });

    function showDeskTopNotice(title, msg) {
      var Notification = window.Notification || window.mozNotification || window.webkitNotification;
      if (Notification) {
        Notification.requestPermission(function (status) {
          // console.log('status: ' + status)
          // status默认值'default'等同于拒绝 'denied' 意味着用户不想要通知 'granted' 意味着用户同意启用通知
          if (status != 'granted') {
            return;
          } else {
            var tag = 'qnbar' + Math.random();
            var notify = new Notification(title, {
              dir: 'auto',
              lang: 'zh-CN',
              tag: tag, // 实例化的notification的id
              icon: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80', // 通知的缩略图,//icon 支持ico、png、jpg、jpeg格式
              body: msg // 通知的具体内容
            });
            notify.onclick = function () {
              // 如果通知消息被点击,通知窗口将被激活
              window.focus();
            }, notify.onerror = function () {
              // console.log("HTML5桌面消息出错！！！");
            };
            notify.onshow = function () {
              // setTimeout(function(){
              //     notify.close();
              // },2000)
            };
            notify.onclose = function () {
              // console.log("HTML5桌面消息关闭！！！");
            };
          }
        });
      } else {
        alert('您的浏览器不支持桌面消息');
      }
    }

    // ----------- 执行一个全局或当前页的websocket -----------
    function handleWs() {
      // ---- 1.身份绑定 -----
      // 测试内容: 商户页面通知业务
      // 门店序号绑定
      // sn = agent_guid
      var storeSn = JSON.parse(localStorage.getItem('user_data')).agent_guid + '@agent'; // sn@group self.agent_id
      // console.log(storeSn)
      // 业务-组和序号 的绑定
      var bzAndIdBindMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
      bzAndIdBindMap.set(__WEBPACK_IMPORTED_MODULE_7__src_http_ws_base__["a" /* ws_base */].AGENT_WEB_MSG, storeSn);
      // ---- 2.业务处理器绑定 ----
      // 测试内容: 商户页面通知业务
      // 对收到的消息进行处理
      var bzMchWebNtfDealer = function bzMchWebNtfDealer(protoMsg) {
        // todo 这里最好也配置化然后处理
        window.eventBus.$emit(protoMsg.getOp(), JSON.parse(protoMsg.getBzdata())); // 发送事件
        if (protoMsg.getOp() == 'prjt_retail_ntf') {
          // 投影商品购买通知...
          if (protoMsg.getBzdata()) {
            // console.log(protoMsg.getBzdata());
            var data = JSON.parse(protoMsg.getBzdata());
            var sendData = {
              total: data.num
            };
            if (data.type == 1) {
              var Prompt = document.getElementById('Prompt');
              Prompt.play();
              showDeskTopNotice('待配送数量', data.num);
              self.$store.commit('SET_WAIT_ORDER', sendData);
              self.$store.commit('GET_ISORDER_DATA', true);
            } else if (data.type == 2) {
              self.$store.commit('SET_WAIT_ORDER', sendData);
              self.$store.commit('GET_ISORDER_DATA', true);
            } else {
              // console.log('error')
            }
          } else {
              // console.log("?????");
            }
        }
        // 如果当前路由无法处理，使用其他形式传达通知
      };
      var bzMchHotelRoomMgr = function bzMchHotelRoomMgr(protoMsg) {
        window.eventBus.$emit(protoMsg.getOp(), protoMsg.getBzdata()); // 发送事件
      };
      var bzMsgDealerMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
      bzMsgDealerMap.set(__WEBPACK_IMPORTED_MODULE_7__src_http_ws_base__["a" /* ws_base */].AGENT_WEB_MSG, bzMchHotelRoomMgr);
      // ---- 3.鉴权信息获取 ----
      var PT_NAME = PT.config.platformUsagespace;

      // ---- 4.初始化并启动客户端 ----
      __WEBPACK_IMPORTED_MODULE_6__src_vendor_qnbar_msgWsClient__["a" /* default */].MsgWsClient.init({
        proto: PT.config.wsProto,
        host: PT.config.wsHost, // 必填
        port: PT.config.wsPort, // 必填
        path: __WEBPACK_IMPORTED_MODULE_7__src_http_ws_base__["a" /* ws_base */].wsPath, // 必填
        authSys: PT_NAME, // 必填 项目配置中的平台字符串
        authKey: PT.qnlogin.getLocalSess(), // 必填 本地系统的session key/token
        toBindMap: bzAndIdBindMap, // 必填
        bzMsgDealerMap: bzMsgDealerMap // 必填
        // debug : true,
      });
      __WEBPACK_IMPORTED_MODULE_6__src_vendor_qnbar_msgWsClient__["a" /* default */].MsgWsClient.startRun();
      var obj = {
        proto: PT.config.wsProto,
        host: PT.config.wsHost, // 必填
        port: PT.config.wsPort, // 必填
        path: __WEBPACK_IMPORTED_MODULE_7__src_http_ws_base__["a" /* ws_base */].wsPath, // 必填
        authSys: PT_NAME, // 必填 项目配置中的平台字符串
        authKey: PT.qnlogin.getLocalSess(), // 必填 本地系统的session key/token
        toBindMap: bzAndIdBindMap, // 必填
        bzMsgDealerMap: bzMsgDealerMap // 必填
      };
      console.log(obj);

      // ------- 发送消息功能暂时禁用中 -------
      // test send a msg to self
      // wsc.MsgWsClient.sendMsg(BZ_MCH_WEB_NTF, "prjt_retail_ntf", "test send and receive self", storeSn);
      // test send a msg to projector
      // wsc.MsgWsClient.sendMsg(BZ_PRJT_TXT_MSG, "send_msg", "hello!!!", "2@p");
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapMutations */])(['SET_DATA']), {
    // -- 这坨是登录的 --
    handleCheckLoginInfoFail: function handleCheckLoginInfoFail() {
      // 单一用户类型，直接进入登录
      console.log('handleCheckLoginInfoFail');
      PT.qnlogin.jumpToCheck(PT.config.loginJumpBackUrl, 'agent'); // agent 官方运营人员  /  agent 合作商  /  merchant 商户
      return;
      this.hasLogin = PT.qnlogin.isLocalSessOk;
    },
    handleOnLogout: function handleOnLogout(rsp) {
      window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl);
    },
    jumpLogin: function jumpLogin() {
      // console.log('jumpLogin');
      PT.qnlogin.firstCheck(PT.config.loginJumpBackUrl, this.handleCheckLoginInfoFail);
    },
    runLogout: function runLogout() {
      var postParams = {
        local_sess: PT.qnlogin.getLocalSess()
      };
      PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_4__svrapi_js__["a" /* default */].logout, postParams, this.handleOnLogout);
      PT.qnlogin.logout();

      this.hasLogin = PT.qnlogin.isLocalSessOk;
    }
  }) // end of methods
});

/***/ }),

/***/ "xNsp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("6HNQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e617bba_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("WI2W");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e617bba_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Icon-svg/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5e617bba", Component.options)
  } else {
    hotAPI.reload("data-v-5e617bba", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xPWx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var PackHeadLen = 16;

var TransPacket = function () {
    //static PackHeadLen = 16;

    function TransPacket(versionInt, cmdInt, reserveInt, bodyUint8Af) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TransPacket);

        this.H_Version = 0;
        this.H_Cmd = 0;
        this.H_Reserve = 0;
        this.H_BodyLen = 0;
        this.PayloadBody = null; // Uint8Array

        if (Number(versionInt) > 0) {
            this.H_Version = versionInt;
        }
        if (Number(cmdInt) > 0) {
            this.H_Cmd = cmdInt;
        }
        if (Number(reserveInt) > 0) {
            this.H_Reserve = reserveInt;
        }

        if (bodyUint8Af) {
            this.H_BodyLen = bodyUint8Af.byteLength;
            this.PayloadBody = bodyUint8Af;
        }
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TransPacket, [{
        key: "encodeToBytes",
        value: function encodeToBytes() {
            var buffer = new Uint8Array(PackHeadLen + this.H_BodyLen);
            var headBuffer = new ArrayBuffer(PackHeadLen);
            var dv = new DataView(headBuffer);
            dv.setUint32(0, this.H_Version);
            dv.setUint32(4, this.H_Cmd);
            dv.setUint32(8, this.H_BodyLen);
            dv.setUint32(12, this.H_Reserve);

            buffer.set(new Uint8Array(headBuffer), 0);
            if (this.H_BodyLen > 0) {
                buffer.set(this.PayloadBody, headBuffer.byteLength);
            }

            return buffer.buffer;
        }
    }], [{
        key: "decodeByBytes",
        value: function decodeByBytes(arrayBuffData) {
            if (arrayBuffData.byteLength <= PackHeadLen) {
                return null;
            }
            var dv = new DataView(arrayBuffData);
            var ver = dv.getUint32(0);
            var cmd = dv.getUint32(4);
            var bodyLen = dv.getUint32(8);
            var reserve = dv.getUint32(12);
            var bodyPayload = new Uint8Array(arrayBuffData.slice(PackHeadLen));
            return new TransPacket(ver, cmd, reserve, bodyPayload);
        }
    }]);

    return TransPacket;
}();

// 导出对象


var MsgSvrPacker = {
    pack: function pack(verInt, cmdInt, dataUint8ArrBuf) {
        var pack = new TransPacket(verInt, cmdInt, 0, dataUint8ArrBuf);
        return pack.encodeToBytes();
    },
    unpack: function unpack(arrayBuffData) {
        return TransPacket.decodeByBytes(arrayBuffData);
    }

    // node exports
    //module.exports.TransPacket = TransPacket;
    // module.exports.MsgSvrPacker = MsgSvrPacker;
};/* harmony default export */ __webpack_exports__["a"] = ({
    MsgSvrPacker: MsgSvrPacker

    // es6 exports

});

/***/ }),

/***/ "xjuR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ws_base; });
var ws_base = {
  // ----------- File 1 Ws配置 ----------- 
  // wsHost : "10.10.4.6", // 测试环境 10.10.4.6
  // wsPort : "16666",         // 暂时固定
  wsPath: "/msgws", // 固定
  // ----------- File 2 全局ws业务定义，和服务端同步定义 ----------- 
  AGENT_WEB_MSG: 1012 // 投影仪即时显示的文字消息业务
};



/***/ }),

/***/ "yZtZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env_release_js__ = __webpack_require__("o6Ms");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env_test_js__ = __webpack_require__("PvI4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__env_local_js__ = __webpack_require__("+nHC");




var env = null;
if (true) {
    env = __WEBPACK_IMPORTED_MODULE_0__env_release_js__["a" /* default */];
} else if (process.env.NODE_ENV === 'testing') {
    env = test;
} else {
    env = local;
}
/* harmony default export */ __webpack_exports__["a"] = (env);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8b24d4a604ab414d3597.js